$.SVGRequiresTspanTextLength = navigator.vendor === 'Apple Computer, Inc.';

$.FlowLayoutSVG = function(options, instance) {
	var me;
	if(!options || options.renderable !== false) {
		me = new $.FlowLayoutFlowContent();
		$(me).addClass('flowSVGContent');
		var _setFocused = me.setFocused;
		var _initEdit = me.initEdit;
		var _setOtherUserFocused = me.setOtherUserFocused;
		var _destroy = me.destroy;
		var _onUserTypes = me.onUserTypes;
		var _shouldIgnoreFocus = me.shouldIgnoreFocus;
		var _isContentHidden = me.isContentHidden;
	} else {
		me = new Object;
	}

	$.extend(me, {
		setInstance: function(instance, render) {
			var recalculatePosition = false;
			if(instance) {
				if(!instance.schema) {
					instance.schema = this.maxSchema;
				}

				this.instance = this.definition = $.extend(true, {}, instance);

				if(instance.position) {
					recalculatePosition = this.setupPosition(this.instance.position);
				}
				
				this.setupManualSize();

				if(instance.id) {
					$(this).attr('id', 'flow-content-' + instance.id);
				}
			} else {
				this.instance = null;
				$(this).removeAttr('id');
			}

			// Definition is for compat with FlowLayoutFlowContent methods
			this.definition = this.instance;
			this.origInstance = instance;

			if(render !== false && this.renderable) {
				this.refreshInstance();

				if(recalculatePosition) {
					this.postRenderRecalculatePosition();
				}

				if(instance.callFunctionOnFirstLoad) {
					var page = this.wrapper.getPage();
					page[instance.callFunctionOnFirstLoad](this);
					this.changeInstanceProperty('callFunctionOnFirstLoad', null);
				}
			}
		},
		sanitizeInstance: function() {
			if(this.instance) {
				if (!$.isInit(this.instance.lines)) {
					this.instance.lines = '';
				}

				if ($.isArray(this.instance.lines)) {
					if(this.instance.lines.length) {
						// Fix for somehow getting stuck with title lines: [[line, line, line]]
						if($.isArray(this.instance.lines[0])) {
							this.instance.lines = this.instance.lines[0];
						}
					} else {
						this.instance.lines = [{
							text: ''
						}];
					}
				}
			}

			// This automatically sanitizes the parts as it loops through
			this.getInstanceParts();
		},
		setupPosition: function(position) {
			var recalculatePosition = false;

			var css = {};
			if($.isInit(position.left)) {
				if(position.left == 'center') {
					position.left = 0;
					recalculatePosition = true;
				}

				css.left = position.left * this.ratio - 1 + this.extraOffset;
			} else if(position.right) {
				css.right = position.right * this.ratio - 1 - this.extraOffset;
			}

			if($.isInit(position.top)) {
				css.top = position.top * this.ratio - 1 + this.extraOffset;
			} else if(position.bottom) {
				css.bottom = position.bottom * this.ratio - 1 - this.extraOffset;
			}

			$(this).css(css);

			if(this.focused) {
				if(this.editToolbar) {
					$(this.getEditToolTarget()).popup('reposition');
				}
			}

			return recalculatePosition;
		},
		setupManualSize: function() {
			if(this.instance.manualSize) {
				var borderThickness = this.getBorderThickness();

				if(this.instance.manualSize.width) {
					var width = (this.instance.manualSize.width * this.ratio) + (borderThickness * 2);
					$(this).css('width', width);
					$(this.outerWrapper).css('width', width);
				} else {
					$(this).add(this.outerWrapper).css('width', '');
				}
				if(this.instance.manualSize.height) {
					var height = (this.instance.manualSize.height * this.ratio) + (borderThickness * 2);
					$(this).css('height', height);
					$(this.outerWrapper).css('height', height);
				} else {
					$(this).add(this.outerWrapper).css('height', '');
				}
			}
		},
		updateManualSize: function(manualSize) {
			this.updateProperty('manualSize', manualSize);
			this.setupManualSize();
			this.renderInstance(this.instance);
		},
		postRenderRecalculatePosition: function() {
			if($(this).isAttached()) {
				var parentRect = this.parentNode.getBoundingClientRect();

				var center = (parentRect.width) / 2 - (this.renderedWidth / 2);
				$(this).css('left', center);

				this.changeInstanceProperty('position', {
					left: center / this.ratio,
					top: this.instance.position.top
				});
			}
		},
		setChangedInstance: function(instance) {
			var startInstance = this.instance;
			try {
				let startText = this.getCurrentLineText();
				this.setInstance(instance);

				if(this.selectionPosition && window.diff_match_patch) {
					var endText = this.getCurrentLineText();

					// http://stackoverflow.com/questions/15303631/what-are-some-algorithms-for-comparing-how-similar-two-strings-are
					// https://code.google.com/p/google-diff-match-patch/
					// https://en.wikipedia.org/wiki/Smith%E2%80%93Waterman_algorithm
					// https://github.com/lqc/google-diff-match-patch
					var dmp = new window.diff_match_patch();
					var diffs = dmp.diff_main(startText, endText);

					var diffPosition = 0;
					var startPosition = this.selectionPosition;
					for(let i = 0; i < diffs.length; i++) {
						let diff = diffs[i];
						var diffIndex = diff[0];
						var diffString = diff[1];
						var diffLength = diffString.length;

						if(diffPosition == startPosition) {
							// Only change the length if we are at the end of the text and add some
							// If text is removed we will end up with going back even more then we should
							if(diffIndex != 1) {
								break;
							}
						} else if(diffPosition > startPosition) {
							// End loop once we have caught up to how long the string should have been
							break;
						}

						if(diffIndex == 1) {
							startPosition += diffLength;
						} else if(diffIndex == -1) {
							startPosition -= diffLength;
						}

						diffPosition += diffLength;
					}

					if(this.selectionPosition != startPosition) {
						this.selectionPosition = Math.max(0, startPosition);
						this.updateCursorPosition();
					}
				}
			} catch(e) {
				this.fireErrorReport('Failed to update instance', 'Failed to update to a new version of the same instance', e, {
					start: startInstance,
					end: instance
				});
			}
		},
		refreshInstance: function(fromUpdate) {
			if(this.instance) {
				this.sanitizeInstance();

				var oldRect = null;
				if(this.instance.position && this.instance.transform && this.isTyping) {
					oldRect = this.getBoundingClientRect();
				}
				var rotation = this.getRotation(true);
				this.style['-webkit-transform'] = this.style.transform = '';

				this.renderInstance(this.instance);
				if(rotation) {
					this.style['-webkit-transform'] = this.style.transform = this.instance.transform;

					// We have to do this to maintain the visible position when typing while rotated
					if(fromUpdate && oldRect) {
						var newRect = this.getBoundingClientRect();
						var sin = Math.sin(rotation);
						var cos = Math.cos(rotation);
						var topDiff =  cos * (oldRect.y - newRect.y) - sin * (oldRect.x - newRect.x);
						
						$(this).css({
							left: $(this).getFloatStyle('left') + (oldRect.x - newRect.x),
							top: $(this).getFloatStyle('top') + topDiff
						});
						this.saveCurrentPosition({
							propogate: false
						});
						this.checkOverflowToLinkedLayouts();
					}
				}
				this.applyZIndex();
				this.applyEffects();
				this.setupManualSize();

				if(this.textEditable) {
					this.updateCursorPosition();
				} else if(this.editToolbar) {
					this.updateToolbarDisplay();
				}
			}
		},
		renderInstance: function(instance) {
			try {
				var objectAttributes = this.renderLines(instance);
				this.postRenderInstanceAutoSized(instance, objectAttributes);
				this.postRenderInstaceDynamicText(instance);
				this.postRenderCheckFonts();
			} catch(e) {
				this.fireErrorReport('renderInstance', 'Error in renderInstance', e, {
					instance: JSON.stringify(instance)
				});

				if($.isBackgroundRenderer) {
					throw e;
				}
			}
		},
		postRenderInstanceAutoSized: function(instance, objectAttributes) {
			// Check if we need to re-run this
			if(this.isAutoSized() && instance.manualSize && !this.disablePostAutoSizeCheck) {
				// Check if we need to shrink to fit in the width
				var manualHeight = $(this).getFloatStyle('height');
				var manualWidth = $(this).getFloatStyle('width');
				var lastFontSizeUsed;
				for(let i = 0, widthOverflow; i < 100 && (widthOverflow = this.getSVGWidthOverflow()) > 0; i++) {
					var widthLines = this.renderedWidth / manualWidth;
					var heightLines = manualHeight / this.renderedHeight;

					var widthHeightDiff = (this.renderedWidth / manualWidth) / (this.renderedHeight / manualHeight);
					if(heightLines > 1.3 && widthLines > 1.1 && heightLines > widthLines && widthHeightDiff > 2.5 && this.wordWrapText && lastFontSizeUsed && (!this.focused || !this.hasDynamicText())) {
						this.runWithSavingDisabled(function() {
							var reps = {};
							this.iterateInstanceParts(function(part) {
								if(part.text && !this.focused) {
									part.text = this.getDynamicText(part.text, reps);
								}
							});

							try {
								this.disablePostAutoSizeCheck = true;
								this.overrideAutomaticFontSize = lastFontSizeUsed;
								if(this.findWordWrapText(0, 0, this.getInstanceLength())) {
									this.updateLines();
								}
								instance = this.instance;
							} finally {
								this.disablePostAutoSizeCheck = false;
								delete this.overrideAutomaticFontSize;
							}
						});

						if(instance.lines && instance.lines.length > 1) {
							break;
						}
					}

					// We want to make sure to go down slower than full speed since not all fonts scale linearly
					let diff = widthOverflow / this.renderedWidth * 0.2;
					let multiplier = 1 - Math.max(0.01, diff);

					let newFontSize = lastFontSizeUsed = objectAttributes.automaticFontSize * multiplier;
					if($.AutoScalingFontFloor) {
						newFontSize = Math.floor(newFontSize);
					}
					objectAttributes = this.renderLines(instance, {
						automaticFontSize: newFontSize
					});
				}

				// Check if font goes down past the edge
				var heightOverflow = this.getSVGHeightOverflow();
				if(heightOverflow > 0) {
					let diff = heightOverflow / this.renderedHeight;
					let multiplier = 1 - Math.max(0.01, diff);

					let newFontSize = objectAttributes.automaticFontSize * multiplier;
					objectAttributes = this.renderLines(instance, {
						automaticFontSize: newFontSize
					});
				}
			}
		},
		postRenderInstaceDynamicText: function(instance) {
			if(this.hasDynamicText() && !this.focused && !this.isAutoSized() && !this.hasBarcode() && !this.disablePostDynamicTextCheck) {
				var useInstance = null;
				this.runWithSavingDisabled(function() {
					try {
						this.disableWrapMergeWithNextLine = true;
						this.disablePostDynamicTextCheck = true;

						if(this.findDynamicTextNewlines(instance)) {
							useInstance = this.instance;
						}
					} catch(e) {
						this.fireErrorReport('postRenderInstaceDynamicText2', 'Error in postRenderInstaceDynamicText 2', e, {
							instance: JSON.stringify(instance)
						});
					} finally {
						this.disablePostDynamicTextCheck = false;
						this.disableWrapMergeWithNextLine = false;
					}
				});

				if(this.wordWrapText) {
					this.runWithSavingDisabled(function() {
						var reps = {};
						if(useInstance) {
							this.instance = useInstance;
						}
						if(typeof this.instance.lines === 'string') {
							this.instance.lines = {
								text: this.instance.lines
							};
						}

						this.iterateInstanceParts(function(part) {
							if(part.text) {
								part.text = this.getDynamicText(part.text, reps);
							}
						});

						// Don't try to wrap placeholders
						var repsCount = 0;
						for(var id in reps) {
							if($.isInit(reps[id])) {
								repsCount++;
							}
						}
						if(repsCount === 0) {
							return;
						}

						try {
							this.disableWrapMergeWithNextLine = true;
							this.disablePostDynamicTextCheck = true;
							if(this.findWordWrapText(0, 0, this.getInstanceLength())) {
								this.refreshInstance(true);
							}
						} catch(e) {
							this.fireErrorReport('postRenderInstaceDynamicText', 'Error in postRenderInstaceDynamicText', e, {
								instance: JSON.stringify(instance)
							});
						} finally {
							this.disablePostDynamicTextCheck = false;
							this.disableWrapMergeWithNextLine = false;
						}
					});
				}
			}
		},
		findDynamicTextNewlines: function() {
			if(typeof this.instance.lines === 'string') {
				this.instance.lines = {
					text: this.instance.lines
				};
			}

			var startPosition = this.selectionPosition;
			var startLine = this.selectionLine;

			var reps = {};
			var hasNewline = false;
			this.iterateInstanceLines(function(line, lineIndex) {
				this.iterateLineParts(line, function(part) {
					if(!part.text) {
						return;
					}
					part.text = this.getDynamicText(part.text, reps);

					// We removed newlines earlier, so this means we definitely have a newline in dynamic text
					if($.FlowLayoutSVGUtils.newLineRegex.test(part.text)) {
						this.selectionLine = lineIndex;
						this.splitSelectionAlongNewLines(part);
						hasNewline = true;
					}
				});
			});

			if(hasNewline) {
				this.refreshInstance(true);
			}

			this.selectionPosition = startPosition;
			this.selectionLine = startLine;

			return hasNewline;
		},
		postRenderCheckFonts: function() {
			if(!this.refreshWhenFontLoaded || $.isPrinceRenderer) {
				return;
			}
			let fonts = [];
			this.iterateInstanceParts(part => {
				if(part.fontFamily) {
					let font = part.fontFamily;
					if($.GoogleFontList.includes($.FlowLayoutSVGUtils.getTitleCaseFont(font))) {
						if(!fonts.includes(font)) {
							fonts.push(font);
						}
					}
				} else if(!fonts.includes('open sans')) {
					fonts.push('open sans');
				}
			});

			let waitingForFonts = fonts.filter(font => {
				return !document.fonts.check('12px "' + font + '"');
			});

			if(waitingForFonts.length) {
				$.waitFor({
					test: () => {
						waitingForFonts = waitingForFonts.filter(font => {
							return !document.fonts.check('12px "' + font + '"');
						});

						return waitingForFonts.length === 0;
					},
					onComplete: () => {
						this.refreshInstance();
					}
				})
			}
		},

		renderLines: function(instance, overrideObjectAttributes) {
			var lines = instance.lines;
			this.emptyLines();
			// Want to be able to pass in a single line as well
			if(!$.isInit(lines)) {
				lines = [];
			} else if(!$.isArray(lines)) {
				lines = [lines];
			}

			var objectAttributes = this.getStartObjectAttributes(instance);
			$.extend(objectAttributes, overrideObjectAttributes);

			var allTextNodes = [];
			var svgRect;
			if($(this).isAttached()) {
				svgRect = this.svgEditor.getBoundingClientRect();
				objectAttributes.svgEditorRect = svgRect;
			}
			var documentFragment = document.createDocumentFragment();
			for(let i = 0; i < lines.length; i++) {
				var linesTextNodes = this.createLine(lines[i], objectAttributes);

				var textNode;
				for(let j = 0; j < linesTextNodes.length; j++) {
					textNode = linesTextNodes[j];
					documentFragment.appendChild(textNode);
					allTextNodes.push(textNode);
				}
			}
			this.svgEditor.appendChild(documentFragment);

			var defs = this.createDefs(objectAttributes);
			if(defs.firstChild) {
				this.svgEditor.insertBefore(defs, this.svgEditor.firstChild);
			}

			this.cachedTextNodes = allTextNodes;
			this.cachedObjectAttributes = objectAttributes;
			if(svgRect) {
				this.postRenderLines(allTextNodes, objectAttributes);
			} else {
				this.delayedPostRenderLines = function() {
					this.delayedPostRenderLines = null;

					let svgRect = this.svgEditor.getBoundingClientRect();
					objectAttributes.svgEditorRect = svgRect;
					this.postRenderLines(allTextNodes, objectAttributes);
				};
			}

			if(this.onPostRenderLines) {
				this.onPostRenderLines(objectAttributes);
			}

			return objectAttributes;
		},
		getStartObjectAttributes: function(instance) {
			var objectAttributes = {
				backgroundColors: [],
				nextLineStartY: 0,
				maxLineWidth: 0,
				dynamicFieldReps: {},
				maxStrokeWidth: 0,
				maxDropShadowSize: 0,
				dropShadowColors: {},
				startHeightMultiplier: 0
			};

			// Setup line height stuff for entire object
			objectAttributes.lineHeight = instance.lineHeight ? instance.lineHeight : this.defaultLineHeight;
			objectAttributes.startHeightMultiplier = objectAttributes.lineHeight - (objectAttributes.lineHeight - 1) / 2;

			// If we are auto sized, figure out what size we should be ahead of time
			if(instance.manualSize && this.isAutoSized()) {
				if(this.overrideAutomaticFontSize) {
					objectAttributes.automaticFontSize = this.overrideAutomaticFontSize;
				} else if(instance.maxFontSize) {
					objectAttributes.automaticFontSize = parseFloat(instance.maxFontSize.replace('pt', ''));
				} else {
					var maxLineHeight = instance.manualSize.height / this.getLineCount() / objectAttributes.lineHeight;
					objectAttributes.automaticFontSize = $.convertToPt(maxLineHeight * $.PRODUCTION_RATIO, true);
				}
			}

			return objectAttributes;
		},
		setRenderedWidth: function(width, inc) {
			if(!inc) {
				inc = 0;
			}

			this.renderedWidth = width;
			this.manualWidth = width;

			if(this.instance && this.instance.manualSize && this.instance.manualSize.width) {
				width = Math.max(this.instance.manualSize.width * this.ratio + inc, width);
				this.manualWidth = this.instance.manualSize.width * this.ratio;
			} else if(this.instance && this.instance.useMaxWidth) {
				var maxWidth = $(this).getFloatStyle('max-width');
				var page = this.wrapper.getPage();
				if(page && page.getLayout()) {
					var layout = page.getLayout();

					if(layout.sidePadding) {
						maxWidth -= layout.sidePadding * 2 * this.ratio;
					}

					if(layout.row) {
						if(layout.row.insidePadding) {
							maxWidth -= layout.row.insidePadding * this.ratio;
						} else if(layout.row.sidePadding) {
							maxWidth -= layout.row.sidePadding * this.ratio;
						}
		
						if(layout.row.outsidePadding) {
							maxWidth -= layout.row.outsidePadding * this.ratio;
						} else if(layout.row.sidePadding) {
							maxWidth -= layout.row.sidePadding * this.ratio;
						}
					}
				}

				width = Math.max(maxWidth, width);
			} else if(this.instance && this.instance.useParentWidth) {
				// The 2px is the border + 1px for padding
				this.manualWidth = width = Math.max(width, Math.floor(this.parentNode.getBoundingClientRect().width) - 3);
			}
			this.renderedDisplayWidth = width;
			// Use ceil to make sure rounding issues don't cause corner to be cut off
			this.svgEditor.setAttribute('width', Math.ceil(width));
		},
		setRenderedHeight: function(height) {
			this.renderedHeight = height;

			if(this.instance && this.instance.manualSize && this.instance.manualSize.height) {
				height = Math.max(this.instance.manualSize.height * this.ratio, height);
			}
			this.renderedDisplayHeight = height;
			this.svgEditor.setAttribute('height', height);
		},
		createDefs: function(objectAttributes) {
			var defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');

			for(var color in objectAttributes.dropShadowColors) {
				var filterDef = objectAttributes.dropShadowColors[color];
				var filterId = filterDef.id;
				var filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
				filter.setAttribute('x', '-50%');
				filter.setAttribute('y', '-50%');
				filter.setAttribute('width', '200%');
				filter.setAttribute('height', '200%');
				filter.setAttribute('id', filterId);

				var blur = document.createElementNS('http://www.w3.org/2000/svg', 'feGaussianBlur');
				var stdDeviation = filterDef.blur / 240 + 0.2;
				blur.setAttribute('stdDeviation', stdDeviation + ' ' + stdDeviation);
				blur.setAttribute('result', 'shadow');

				var offset = document.createElementNS('http://www.w3.org/2000/svg', 'feOffset');
				var position = filterDef.size / $.PRODUCTION_RATIO + 0.3;
				// If we have stroke, make sure this is outside of it
				if(objectAttributes.maxStrokeWidth > 0) {
					position += (objectAttributes.maxStrokeWidth / 2);
				}

				offset.setAttribute('dx', position);
				offset.setAttribute('dy', position);

				filter.appendChild(blur);
				filter.appendChild(offset);
				defs.appendChild(filter);
			}

			return defs;
		},
		calculateRenderedDimensions: function(textNodes, objectAttributes) {
			var lastLineBottom = 0;
			for(let i = 0; i < textNodes.length; i++) {
				var textNode = textNodes[i];

				if(textNode.clonedFrom) {
					textNode.cachedBoundingClientRect = textNode.clonedFrom.cachedBoundingClientRect;
				} else {
					var textRect = textNode.getBoundingClientRect();
					var textWidth = textRect.width;
					// If we are justifying text that is greather than it should be, don't want to set the svg width greater than it actually will be rendered
					if(textNode.line && textNode.line.align === 'justify' && this.instance.manualSize && this.instance.manualSize.width) {
						textWidth = Math.min(this.instance.manualSize.width * this.ratio, textWidth);
					}
					objectAttributes.maxLineWidth = Math.max(objectAttributes.maxLineWidth, textWidth, 1);
					lastLineBottom = textRect.bottom;
					textNode.cachedBoundingClientRect = textRect;
				}
			}

			if($(this.svgEditor).find('svg').length) {
				return;
			}

			// Set the rendered width/height's for these
			if(objectAttributes.maxLineWidth) {
				this.setRenderedWidth(objectAttributes.maxLineWidth);
			}
			// If we add -1, fontdiner swanky cuts off some lower case g's
			var renderedHeight = Math.ceil(lastLineBottom - objectAttributes.svgEditorRect.top);
			// Some fonts render larger than they should.  If we have issues with different browsers/ratio's, change parent div to be a maximum height of objectAttributes.nextLineStartY
			this.calculatedRenderedHeight = objectAttributes.nextLineStartY;
			this.setRenderedHeight(Math.max(renderedHeight, this.calculatedRenderedHeight));
			if(this.applyCalculatedRenderedDimensions) {
				this.style.height = this.calculatedRenderedHeight + 'px';
			}
		},
		postRenderLines: function(textNodes, objectAttributes) {
			this.calculateRenderedDimensions(textNodes, objectAttributes);
			var svgWidth = this.renderedDisplayWidth;

			var hasUpdatedSVGLeft = false;
			for(let i = 0; i < textNodes.length; i++) {
				var textNode = textNodes[i];
				let line = textNode.line;

				if(textNode.nodeName == 'text') {
					// Font's dont obey the x position and write part of some text before this (ie: E in Mystery Quest)
					var svgLeft = objectAttributes.svgEditorRect.left;
					var textLeft = textNode.cachedBoundingClientRect.left;
					var leadingTextSpace = svgLeft - textLeft;
					// When changing subject drop shadow, centering for labels gets messed up here
					if((leadingTextSpace < -10 || leadingTextSpace > 10) && (line.align === 'center' || hasUpdatedSVGLeft)) {
						if(!hasUpdatedSVGLeft) {
							objectAttributes.svgEditorRect = this.svgEditor.getBoundingClientRect();
							svgLeft = objectAttributes.svgEditorRect.left;
						}

						textNode.cachedBoundingClientRect = textNode.getBoundingClientRect();
						textLeft = textNode.cachedBoundingClientRect.left;

						leadingTextSpace = svgLeft - textLeft;
						hasUpdatedSVGLeft = true;
					}

					switch(line.align) {
						case 'center':
							textNode.cachedLeadingTextSpace = leadingTextSpace;
							textNode.setAttribute('x', (svgWidth + leadingTextSpace) / 2);
							textNode.setAttribute('text-anchor', 'middle');

							// Some fonts such as bangers with large leading text space need to recalculated to see if the width needs to be increased
							if(leadingTextSpace > 1) {
								var textRect = textNode.getBoundingClientRect();
								// Do NOT try to use cached verison of this as it caused render issues with some two line composite names while using some fonts with drop shadow
								let svgRect = this.svgEditor.getBoundingClientRect();
								var rightDiff = textRect.right - svgRect.right;
								if(rightDiff > 0) {
									this.setRenderedWidth(this.renderedWidth + rightDiff);
								}
							}
							break;
						case 'right':
							if(!$(textNode).hasClass('strokeClone')) {
								var newX = svgWidth;
								textNode.setAttribute('x', newX);
								textNode.setAttribute('text-anchor', 'end');

								var textRight = textNode.getBoundingClientRect().right;
								var svgRight = this.svgEditor.getBoundingClientRect().right;
								var trailingTextSpace = textRight - svgRight;
								if(trailingTextSpace > 0) {
									newX = svgWidth - trailingTextSpace;
									textNode.setAttribute('x', newX);
								}

								var nextSibling = textNode.nextSibling;
								if(nextSibling && $(nextSibling).hasClass('strokeClone')) {
									nextSibling.setAttribute('x', newX);
									nextSibling.setAttribute('text-anchor', 'end');
								}
							}
							break;
						case 'justify':
							textNode.setAttribute('x', leadingTextSpace);
							this.justifyTextNode(textNode, leadingTextSpace);
							break;
						default:
							textNode.setAttribute('x', leadingTextSpace);
							break;
					}

					let y = parseFloat(textNode.getAttribute('y'));
					// Move over so not on boundry
					if (objectAttributes.hasStroke || objectAttributes.hasDropShadow) {
						if(line.align != 'right') {
							let x = parseFloat(textNode.getAttribute('x'));
							textNode.setAttribute('x', x + Math.max(objectAttributes.maxDropShadowSize, objectAttributes.maxStrokeWidth));
						}

						y += Math.max(objectAttributes.maxDropShadowSize, objectAttributes.maxStrokeWidth);
					}
					textNode.setAttribute('y', y);

					if(!$(textNode).hasClass('clone')) {
						this.checkForSpellingMistakes(textNode);
					}
				} else if(textNode.nodeName == 'g') {
					let x = 0, y = 0;
					var lineRect = textNode.getBoundingClientRect();
					switch (line.align) {
						case 'center':
							x = (svgWidth / 2) - (lineRect.width / 2);
							break;
						case 'right':
							x = svgWidth - lineRect.width;
							break;
					}

					textNode.setAttribute('transform', 'translate(' + x + ', ' + y + ')');
				} else if(textNode.nodeName == 'svg') {
					switch (line.align) {
						case 'left':
							$(this).css('text-align', 'left');
							break;
						case 'right':
							$(this).css('text-align', 'right');
							break;
						default:
							$(this).css('text-align', '');
					}
				}
			}

			if(objectAttributes.hasStroke) {
				if(this.renderedWidth) {
					this.setRenderedWidth(this.renderedWidth + objectAttributes.maxStrokeWidth * 2, objectAttributes.maxStrokeWidth * 2);
				}

				if(this.renderedHeight) {
					this.setRenderedHeight(this.renderedHeight + objectAttributes.maxStrokeWidth * 2);
				}
			}

			if(objectAttributes.hasDropShadow) {
				// TODO: Should we be using blur instead of hard coding to * 2?
				if(this.renderedWidth) {
					this.setRenderedWidth(this.renderedWidth + objectAttributes.maxDropShadowSize * 2, objectAttributes.maxDropShadowSize * 2);
				}

				if(this.renderedHeight) {
					this.setRenderedHeight(this.renderedHeight + objectAttributes.maxDropShadowSize * 2);
				}
			}

			if(objectAttributes.backgroundColors.length) {
				var documentFragment = document.createDocumentFragment();
				let svgRect = this.svgEditor.getBoundingClientRect();
				var firstTextRect = $(this.svgEditor).children('text, g')[0].getBoundingClientRect();
				for (let i = 0; i < objectAttributes.backgroundColors.length; i++) {
					var def = objectAttributes.backgroundColors[i];
					var tspan = def.tspan;
					var tspanRect = tspan.getBoundingClientRect();

					var rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
					rect.rootNode = this;
					rect.setAttribute('x', tspanRect.left - svgRect.left);
					// We don't have to account for the line height here because working off the top of the firstTextRect already does it
					rect.setAttribute('y', tspanRect.top - firstTextRect.top);
					rect.setAttribute('width', tspanRect.width);
					rect.setAttribute('height', (tspanRect.height / 1.3 * objectAttributes.lineHeight));
					rect.setAttribute('fill', def.color);

					documentFragment.appendChild(rect);
				}

				this.svgEditor.insertBefore(documentFragment, this.svgEditor.firstChild);
			}

			let text = this.getInstanceText();
			if($.trim(text).length > 0) {
				$(this).removeClass('flowEmptyContent');
			} else {
				$(this).addClass('flowEmptyContent');
			}

			var validTextNodes = textNodes.filter(function(textNode) {
				return textNode.line;
			})
			var hasRightAlignment = validTextNodes.filter(function(textNode) {
				return textNode.line.align === 'right';
			}).length === validTextNodes.length;
			if(hasRightAlignment) {
				$(this).addClass('hasRightAlignedText');
			} else {
				$(this).removeClass('hasRightAlignedText');
			}

			this.updateCachedJustifiedLines();
		},
		justifyTextNode: function(textNode, leadingTextSpace) {
			var manualWidth = this.manualWidth - leadingTextSpace;
			var shouldJustify = false;
			
			if(!this.editable && this.instance.justifiedLines && $.isArray(this.instance.lines)) {
				var lineIndex = this.instance.lines.indexOf(textNode.line);
				if(lineIndex >= 0) {
					shouldJustify = this.instance.justifiedLines[lineIndex];
				}
			} else {
				var textWidth = textNode.cachedBoundingClientRect.width;

				var nextLineNode = textNode.nextSibling;
				if($(nextLineNode).hasClass('clone')) {
					nextLineNode = nextLineNode.nextSibling;
				}
				if(nextLineNode) {
					var nextLineFirstWordWidth = this.getFirstWordWidthFromTextNode(nextLineNode);
					textWidth += nextLineFirstWordWidth;
				}

				// Keep consistent diff requirements
				var maxDiff = 0.54 * this.ratio;
				if(textWidth - (manualWidth - maxDiff) > 0) {
					shouldJustify = true;
				}
			}

			if(shouldJustify) {
				textNode.setAttribute('textLength', manualWidth);

				// Some fonts like Pacifico are actually rendered wider than the textLength for some insane reason
				let newRect = textNode.getBoundingClientRect();
				if((newRect.width - 1) > manualWidth) {
					manualWidth = manualWidth - (newRect.width - manualWidth) + 1;
					textNode.setAttribute('textLength', manualWidth);
				}

				if($.SVGRequiresTspanTextLength) {
					$(textNode).find('tspan').each(function() {
						this.setAttribute('textLength', manualWidth);
					});
				}
			}
		},

		// Cache which lines are justified so render matches what the user sees
		updateCachedJustifiedLines: function() {
			if(!this.editable) {
				return;
			}

			// Add a non-number to force this not to be an array on deserialization
			var justifiedLines = {
				f: true
			};
			var texts = $(this.svgEditor).children('text').not('.clone').toArray();
			texts.forEach(function(text, line) {
				if(text.hasAttribute('textLength')) {
					justifiedLines[line] = true;
				}
			});

			var instanceJustifiedLines = this.instance.justifiedLines || {f: true};
			if(!$.objectEquals(justifiedLines, instanceJustifiedLines)) {
				this.changeInstanceProperty('justifiedLines', justifiedLines, false);
			}
		},

		checkForSpellingMistakes: function(textNode) {
			if(!this.textEditable || !this.editable || !window.nspellcheck) {
				return;
			}

			var textContent = textNode.textContent;
			var misspelledWords = $.FlowLayoutSVGUtils.checkForMisspelledWord(textContent);
			if(misspelledWords.length) {
				var defs = this.svgEditor.firstChild;
				if(defs.nodeName !== 'defs') {
					defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
					this.svgEditor.insertBefore(defs, this.svgEditor.firstChild);
				}
				if(!this.svgEditor.firstChild.querySelector('pattern')) {
					var pattern = document.createElementNS('http://www.w3.org/2000/svg', 'pattern');
					pattern.setAttribute('patternUnits', 'userSpaceOnUse');
					pattern.setAttribute('id', 'spellingErrorPattern');
					pattern.setAttribute('width', '4');
					pattern.setAttribute('height', '4');

					var wiggleImg = document.createElementNS('http://www.w3.org/2000/svg', 'image');
					wiggleImg.setAttribute('href', 'css/images/wiggle.png');
					pattern.appendChild(wiggleImg);
					defs.appendChild(pattern);
				}

				misspelledWords.forEach(function(misspelledWord) {
					me.createSpellingMistakeLines(textNode, misspelledWord).forEach(function(rect) {
						// Want immediately after defs but before text nodes so pointer events hit text nodes and not rects
						me.svgEditor.insertBefore(rect, me.svgEditor.firstChild.nextSibling);
					});
				});
			}
		},
		createSpellingMistakeLines: function(textNode, spellingMistake) {
			var rects = [];
			var textContent = textNode.textContent.toLowerCase().split(String.fromCharCode(160)).join(' ').replace($.FlowLayoutSVGUtils.apostropheLookalikeRegex, "'");
			try {
				var mistakeStartIndexes = textContent.allIndexesOf(spellingMistake.toLowerCase());
				mistakeStartIndexes.forEach(function(mistakeStartIndex) {
					if(mistakeStartIndex === -1) {
						return rects;
					}
					var mistakeEndIndex = mistakeStartIndex + spellingMistake.length - 1;

					var selectionLine = me.getLine(me.selectionLine);
					if(selectionLine && textNode.line == selectionLine) {
						if(me.selectionPosition > mistakeStartIndex && me.selectionPartPosition <= mistakeEndIndex && me.focused) {
							return;
						}
					}

					var startTspan = textNode.childNodes[0];
					var tspanChars = startTspan.getNumberOfChars();
					while(mistakeStartIndex >= tspanChars) {
						startTspan = startTspan.nextSibling;
						if(!startTspan) {
							return rects;
						}

						mistakeStartIndex -= tspanChars;
						mistakeEndIndex -= tspanChars;
						tspanChars = startTspan.getNumberOfChars();
					}

					var endTspan = startTspan;
					while(mistakeEndIndex >= tspanChars) {
						endTspan = endTspan.nextSibling;
						if(!endTspan) {
							return rects;
						}

						mistakeEndIndex -= tspanChars;
						tspanChars = endTspan.getNumberOfChars();
					}

					var startX = startTspan.getStartPositionOfChar(mistakeStartIndex).x;
					var endX = endTspan.getEndPositionOfChar(mistakeEndIndex).x;

					var rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
					rect.setAttribute('x', startX);
					// This y is the offset in the pattern as well, so if we want to have squiggly always the same we have to use translate
					rect.setAttribute('y', 0);
					rect.style.transform = 'translateY(' + textNode.getAttribute('y') + 'px)';
					rect.setAttribute('width', endX - startX);
					rect.setAttribute('height', 3);
					rect.setAttribute('fill', 'url(#spellingErrorPattern)');

					rects.push(rect);
				});

				return rects;
			} catch(e) {
				this.fireErrorReport('createSpellingMistakeLine', 'Error in createSpellingMistakeLine', e, {
					textContent: textContent,
					spellingMistake: spellingMistake,
					instance: JSON.stringify(this.instance)
				});

				return rects;
			}
		},

		createTempLine: function(line) {
			return this.createLine(line, this.getStartObjectAttributes(this.instance));
		},
		createLine: function(line, objectAttributes) {
			// Line can have information on it
			var parts;
			if(typeof line != 'object' || !$.isInit(line.parts)) {
				parts = [line];
			} else if(line.parts.length === 0) {
				parts = [{
					text: ''
				}];
			} else {
				parts = line.parts;
			}

			var textNode = document.createElementNS('http://www.w3.org/2000/svg', 'text');
			textNode.line = line;
			var textNodes = [textNode];
			var lineAttributes = {
				maxFontSize: 0,
				dropShadows: {},
				fontFamily: 'open sans'
			};

			for(let i = 0; i < parts.length; i++) {
				var part = parts[i];
				if(!this.focused && window.JsBarcode && this.hasBarcodeInPart(part)) {
					part = $.extend(true, {}, part);
					part.text = this.getLineText(line);
				}

				let tspanNode = this.createLinePart(part, objectAttributes, lineAttributes, parts.length == 1);
				if(tspanNode.nodeName == 'tspan') {
					textNode.appendChild(tspanNode);
				} else {
					textNodes[0] = textNode = tspanNode;
					textNode.line = line;
					break;
				}
			}

			if(line['drop-shadow'] && $.isPlainObject(line['drop-shadow']) && $.getObjectCount(line['drop-shadow']) > 0) {
				lineAttributes.dropShadow = line['drop-shadow'];
				objectAttributes.hasDropShadow = true;
			}

			textNode.setAttribute('x', '0');

			// Most fonts seem to work well with this constant value
			var specialLineHeightFix = 0.2;
			if($.isInit(this.fontLineHeightFixes[lineAttributes.fontFamily])) {
				specialLineHeightFix = this.fontLineHeightFixes[lineAttributes.fontFamily];
			}

			var startHeightMultiplier = objectAttributes.startHeightMultiplier - specialLineHeightFix;

			if(textNode.nodeName.toLowerCase() == 'svg') {
				textNode.setAttribute('y', '0');
			} else {
				textNode.setAttribute('y', objectAttributes.nextLineStartY + startHeightMultiplier * lineAttributes.maxFontSize);
			}
			textNode.maxFontSize = lineAttributes.maxFontSize;
			textNode.fontFamily = lineAttributes.fontFamily;
			objectAttributes.nextLineStartY += objectAttributes.lineHeight * lineAttributes.maxFontSize;

			// SVG Stroke does half inside half outside
			// In order to get just outside stroke, we are adding a version with stroke behind the normal version
			if(lineAttributes.hasStroke) {
				let clonedTextNode = textNode.cloneNode(true);
				clonedTextNode.line = line;
				clonedTextNode.originalTextNode = textNode;
				textNode.cloneTextNode = clonedTextNode;
				$(clonedTextNode).addClass('clone strokeClone');

				for(let i = 0; i < clonedTextNode.childNodes.length; i++) {
					let tspanNode = clonedTextNode.childNodes[i];
					if(tspanNode.style.stroke) {
						tspanNode.style.stroke = '';
						tspanNode.style['stroke-width'] = '';
					}
					tspanNode.rootNode = this;
				}

				textNodes.push(clonedTextNode);
				clonedTextNode.clonedFrom = textNode;

				// Set textNode to this version with no stroke for drop-shadow
				textNode = clonedTextNode;
			}

			if(lineAttributes.dropShadow) {
				var dropShadow = lineAttributes.dropShadow;
				let dropShadowString = JSON.stringify(dropShadow);

				if(!objectAttributes.dropShadowColors[dropShadowString]) {
					var dropShadowSize = lineAttributes.maxFontSize * dropShadow.depth;
					objectAttributes.dropShadowColors[dropShadowString] = {
						id: 'drop-shadow-' + $.getUniqueId(),
						size: dropShadowSize,
						blur: dropShadow.intensity * lineAttributes.maxFontSize
					};

					objectAttributes.maxDropShadowSize = Math.max(dropShadowSize / $.PRODUCTION_RATIO, objectAttributes.maxDropShadowSize);
				}
				var filterId = objectAttributes.dropShadowColors[dropShadowString].id;

				let clonedTextNode = textNode.cloneNode(true);
				clonedTextNode.line = line;
				clonedTextNode.originalTextNode = textNode;
				textNode.cloneTextNode = clonedTextNode;
				$(clonedTextNode).removeClass('strokeClone').addClass('clone dropShadowClone');

				clonedTextNode.setAttribute('filter', 'url(#' + filterId + ')');
				clonedTextNode.setAttribute('fill', dropShadow.color);

				// Go through and clear of any text nodes not part of drop-shadow
				for(let i = 0; i < textNode.childNodes.length; i++) {
					let tspanNode = clonedTextNode.childNodes[i];
					tspanNode.style.fill = '';
					tspanNode.rootNode = this;
				}

				textNodes.unshift(clonedTextNode);
			}

			return textNodes;
		},
		createLinePart: function(part, objectAttributes, lineAttributes, addBlankSpace) {
			// Line can have information on it
			if(typeof part != 'object') {
				part = {
					text: part
				};
			}

			var spaceReplacement = String.fromCharCode(160);
			if($.FlowLayoutSVGUtils.isFontNoWhitespace(part.fontFamily)) {
				spaceReplacement = ' ';
			}

			// Convert text with dynamic text
			let text = part.text;
			if(text) {
				if(text.indexOf && (text.indexOf('\n') != -1 || text.indexOf('\r') != -1)) {
					text = part.text = text.replace($.FlowLayoutSVGUtils.newLineRegex, ' ');
				}

				if(text.replace) {
					if(!this.focused || !this.textEditable) {
						text = this.getDynamicText(text, objectAttributes.dynamicFieldReps);
					}
					text = text.replace(/ /ig, spaceReplacement);
				}
			}
			
			if(!text && addBlankSpace) {
				text = spaceReplacement;
			}

			if(part.upperCase) {
				text = text.toUpperCase();
			}

			// Get the font size we want
			var fontSizePt = this.defaultFontSize;
			if (part['font-size']) {
				if(part['font-size'] == 'auto') {
					fontSizePt = objectAttributes.automaticFontSize || this.defaultFontSize;
				} else {
					fontSizePt = parseFloat(part['font-size'].replace('pt', ''));
				}
			}
			fontSizePt = fontSizePt / $.PRODUCTION_RATIO * this.ratio;
			var fontSizePx = $.convertToPx(fontSizePt, true);
			lineAttributes.maxFontSize = Math.max(fontSizePx, lineAttributes.maxFontSize);
			let fontFamily = 'open sans';
			if(part.fontFamily) {
				lineAttributes.fontFamily = fontFamily = part.fontFamily;
			}

			// We are going to try to check and see if the font is actually loaded
			// If not, we are going to try to load it and then refresh once it is loaded
			// In some cases (particularly studio specific fonts) the css for the font definition isn't even live, so we have to retry after css file is done loading
			if(!$.FlowLayoutSVGUtils.globalLoadedFonts[fontFamily] && document.fonts && document.fonts.check && !$.isBackgroundRenderer) {
				if(document.fonts.check('12px "' + fontFamily + '"')) {
					$.FlowLayoutSVGUtils.globalLoadedFonts[fontFamily] = true;
				} else {
					document.fonts.load('12px "' + fontFamily + '"').then(() => {
						if(document.fonts.check('12px "' + fontFamily + '"')) {
							$.FlowLayoutSVGUtils.globalLoadedFonts[fontFamily] = true;
							if($(this).isAttached()) {
								this.refreshInstance(false);
								if(this.onFontLoadedReload) {
									this.onFontLoadedReload();
								}
							}
						} else {
							// Css file is not done loading yet so browser has no idea what the heck this font is
							window.addFontToWaitCallbackList(fontFamily, () => {
								this.refreshInstance(false);
								if(this.onFontLoadedReload) {
									this.onFontLoadedReload();
								}
							});
						}
					}).catch((e) => {
						console.error('Failed to load font ' + fontFamily, e);
					});
				}
			} else if($.FlowLayoutSVGUtils.multiByteCharacterRegex.test(text) && !$.FlowLayoutSVGUtils.globalLoadedFonts.emoji && document.fonts && document.fonts.check && !$.isBackgroundRenderer) {
				document.fonts.load('12px "emoji"', text).then(() => {
					if(document.fonts.check('12px "emoji"', text)) {
						$.FlowLayoutSVGUtils.globalLoadedFonts.emoji = true;

						this.refreshInstance(false);
						if(this.onFontLoadedReload) {
							this.onFontLoadedReload();
						}
					}
				}).catch((e) => {
					console.error('Failed to load font emoji', e);
				});
			}

			// Return either a tspan or barcode node (currently g)
			if(!this.focused && window.JsBarcode && this.hasBarcodeInPart(part)) {
				if(window.QRCode && this.hasQRCodeInPart(part)) {
					return this.createQRCodeNode(part, text, fontSizePx, objectAttributes, lineAttributes);
				} else {
					return this.createBarcodeNode(part, text, fontSizePx, objectAttributes, lineAttributes);
				}
			} else {
				return this.createLinePartNode(part, text, fontSizePx, objectAttributes, lineAttributes);
			}
		},
		createLinePartNode: function(part, text, fontSizePx, objectAttributes, lineAttributes) {
			let tspanNode = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
			tspanNode.rootNode = this;
			tspanNode.textContent = text;

			tspanNode.style['font-size'] = fontSizePx + 'px';
			for (var styleName in part) {
				if (['fontFamily', 'font-weight', 'font-style', 'text-decoration', 'color'].indexOf(styleName) != -1) {
					var svgStyleName = styleName;
					var value = part[styleName];
					if (styleName == 'color') {
						svgStyleName = 'fill';
					} else if (styleName == 'fontFamily') {
						// Ignore fontFamily: null
						if(!value) {
							continue;
						}
						// Don't render barcode families
						if(this.isFontBarcode(value)) {
							continue;
						}
						// Get rid of imported in Windows fonts
						if($.GoogleFontList.indexOf($.FlowLayoutSVGUtils.getTitleCaseFont(value)) == -1) {
							if(part.customFont) {
								window.loadGoogleFontsList([part.customFont]);
							} else {
								continue;
							}
						}
						// Do not set for truly empty tspans since it just breaks our checking of Prince embedding fonts into pdfs
						else if(text === '') {
							continue;
						}

						value = '"' + value + '"' + ', ' + $.GoogleFontDefaultFallbacks;
					}

					tspanNode.style[svgStyleName] = value;
				}
			}

			if (part.stroke  && $.isPlainObject(part.stroke) && $.getObjectCount(part.stroke) > 0) {
				tspanNode.style.stroke = part.stroke.color;
				var constPadding = this.ratio / $.PRODUCTION_RATIO * 0.6;
				var strokeWidth = lineAttributes.maxFontSize / $.PRODUCTION_RATIO * 3 * part.stroke.thickness + constPadding;
				tspanNode.style['stroke-width'] = strokeWidth + 'px';
				objectAttributes.hasStroke = lineAttributes.hasStroke = true;
				objectAttributes.maxStrokeWidth = Math.max(strokeWidth, objectAttributes.maxStrokeWidth);
			}

			if (part['drop-shadow'] && $.isPlainObject(part['drop-shadow']) && $.getObjectCount(part['drop-shadow']) > 0) {
				lineAttributes.dropShadow = part['drop-shadow'];
				objectAttributes.hasDropShadow = true;
			}

			if (part['background-color']) {
				var color = part['background-color'];

				objectAttributes.backgroundColors.push({
					color: color,
					tspan: tspanNode
				});
			}

			if($.FlowLayoutSVGUtils.isFontNoWhitespace(part.fontFamily)) {
				$(tspanNode).css('white-space', 'pre');
			}

			return tspanNode;
		},
		createBarcodeNode: function(part, text, fontSizePx, objectAttributes, lineAttributes) {
			// Barcodes can't handle non-breaking space like 160
			text = text.split(String.fromCharCode(160)).join(' ');

			// Barcodes can't handle some characters like *
			if(part.fontFamily.toLowerCase() === 'ean13') {
				text = text.replace(/[^0-9]+/g, '');

				// Passing in 12 auto calculates the 13 checksum digit
				if(text.length != 12) {
					return this.createLinePartNode(part, 'Invalid: Requires 12 digits', fontSizePx, objectAttributes, lineAttributes);
				}
			} else {
				if(part.fontFamily.indexOf('128') === -1) {
					text = text.replace($.BarcodeIllegalCharacters, '');
				}
				text = text.replace($.NonASCIICharacterTest, '');
			}

			// Barcodes can't handle blank barcode
			if(!text) {
				text = 'Blank';
			}
			
			var format = 'code39';
			if(part.fontFamily.indexOf('128') != -1) {
				format = 'code128';
			} else if(part.fontFamily.toLowerCase() === 'ean13') {
				format = 'EAN13';
			}

			var barWidth = 2;
			if(part.barWidth) {
				barWidth = part.barWidth;
			}
			barWidth = (barWidth / 2) * (this.ratio / $.PRODUCTION_RATIO);

			var height = fontSizePx;
			if(this.instance && this.instance.manualSize && this.instance.manualSize.height) {
				height = this.instance.manualSize.height * this.ratio;
			}

			var barcodeOptions = {
				format: format,
				displayValue: false,
				margin: 0,
				height: height,
				width: barWidth,
				lineColor: part.color
			};
			if(part.fontFamily.toLowerCase() === 'ean13') {
				// Without flat option, we are returning multiple g groups
				barcodeOptions.flat = true;
			}

			var barcodeSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
			$(barcodeSVG).JsBarcode(text, barcodeOptions);

			var gNode = $(barcodeSVG).children('g')[0];
			gNode.line = part;
			gNode.rootNode = this;
			gNode.textRendered = text;

			for(let i = 0; i < gNode.childNodes.length; i++) {
				gNode.childNodes[i].rootNode = this;
			}

			if(part['background-color']) {
				var color = part['background-color'];

				objectAttributes.backgroundColors.push({
					color: color,
					tspan: gNode
				});
			}

			// Make sure barcode fits inside of elements boundaries
			var manualWidth = $(this).getFloatStyle('width');
			if(manualWidth) {
				var renderedWidth = $(barcodeSVG).getFloatAttribute('width');
				if(renderedWidth > manualWidth) {
					let multiplier = manualWidth / renderedWidth;
					for(let i = 0; i < gNode.childNodes.length; i++) {
						var rect = gNode.childNodes[i];

						var rectX = $(rect).getFloatAttribute('x');
						var rectWidth = $(rect).getFloatAttribute('width');

						rect.setAttribute('x', rectX * multiplier);
						rect.setAttribute('width', rectWidth * multiplier);
					}
				}
			}

			return gNode;
		},
		createQRCodeNode: function(part, text, fontSizePx, objectAttributes, lineAttributes) {
			var width = 100;
			var height = 100;
			if(this.instance.manualSize) {
				width = this.instance.manualSize.width;
				height = this.instance.manualSize.height;
			}
			let size = Math.min(width, height) * this.ratio;

			this.svgEditor.setAttribute('width', size);
			this.svgEditor.setAttribute('height', size);

			let renderedText = text;
			let pageSet = this.wrapper?.page?.pageSet;
			if(pageSet?.rewriteQRCode) {
				renderedText = pageSet.rewriteQRCode(text);
			}

			var options = {
				text: renderedText,
				width : size,
				height : size,
				useSVG: true
			};

			if(part.color) {
				options.colorDark = part.color;
			}
			if(part['background-color']) {
				options.colorLight = part['background-color'];
			}

			var qrcode = new window.QRCode(this.svgEditor, options);
			
			// TODO: We should really be inlining this crap, but for whatever reason it will only display with this svg embedded directly in it
			var svgNode = $(qrcode._el).find('svg')[0];
			svgNode.line = part;
			svgNode.rootNode = this;
			for(let i = 0; i < svgNode.childNodes.length; i++) {
				svgNode.childNodes[i].rootNode = this;
			}
			svgNode.renderedText = renderedText;

			return svgNode;
		},
		hasFont: function(fontName) {
			if(!this.instance) {
				return false;
			}

			var hasFont = false;
			this.iterateInstanceParts(function(part) {
				if(this.hasFontInPart(part, fontName)) {
					hasFont = true;
					return false;
				}
			});

			return hasFont;
		},
		hasFontInPart: function(part, fontName) {
			return part.fontFamily === fontName;
		},
		hasBarcode: function() {
			if(!this.instance) {
				return false;
			}

			var hasBarcode = false;
			this.iterateInstanceParts(function(part) {
				if(this.hasBarcodeInPart(part)) {
					hasBarcode = true;
					return false;
				}
			});

			return hasBarcode;
		},
		hasBarcodeInPart: function(part) {
			return this.isFontBarcode(part.fontFamily);
		},
		isFontBarcode: function(fontFamily) {
			return $.FlowLayoutSVGUtils.isFontBarcode(fontFamily);
		},
		hasQRCode: function() {
			if(!this.instance) {
				return false;
			}

			var hasQRCode = false;
			this.iterateInstanceParts(function(part) {
				if(this.hasQRCodeInPart(part)) {
					hasQRCode = true;
					return false;
				}
			});

			return hasQRCode;
		},
		hasQRCodeInPart: function(part) {
			return $.FlowLayoutSVGUtils.isFontQRCode(part.fontFamily);
		},
		isAutoSized: function() {
			var isAutoSized = false;
			this.iterateInstanceParts(function(part) {
				if(part['font-size'] == 'auto') {
					isAutoSized = true;
					return false;
				}
			});

			return isAutoSized;
		},
		isFreelyResized: function() {
			var isAutoSized = false;
			this.iterateInstanceParts(function(part) {
				if(part['font-size'] == 'auto' || this.hasBarcodeInPart(part)) {
					isAutoSized = true;
					return false;
				}
			});

			return isAutoSized;
		},

		getDynamicText: function(text, dynamicFieldReps) {
			if(this.getDynamicFields && this.getDynamicFieldRep) {
				return this.getDynamicTextWithRep(text, dynamicFieldReps, this.getDynamicFieldRep);
			} else {
				return text;
			}
		},
		getDynamicTextWithRep: function(text, dynamicFieldReps, getDynamicFieldRep) {
			if(this.getDynamicFields) {
				var dynamicFields = this.getDynamicFields().filter(field => field !== null && field !== undefined && typeof field === 'string');
				var lowerCaseDynamicFields = dynamicFields.reduce(function(map, field) {
					map[field.toLowerCase()] = field;
					return map;
				}, {});
				// Do normal replacements
				dynamicFields.forEach(function(field) {
					text = me.getDynamicTextWithFieldAndRep(text, field, dynamicFieldReps, getDynamicFieldRep, lowerCaseDynamicFields);
				});
				if(dynamicFields.includes('Order Number')) {
					// Unverified properties are pulled dynamically from the order data.  If you build a layout with an unverified property in it, orders without those properties should still show as blank
					text = this.getAlwaysBlankDynamicText(text);
				}

				// Check for combined replacements (ie: name => first name last name)
				for(var replaceFromText in $.combinedSubjectFields) {
					var replaceTextRegex = new RegExp('%(' + replaceFromText + ')%', 'i');
					var replaceMatch = text.match(replaceTextRegex);
					if(replaceMatch) {
						var replacementPlaceholders = $.combinedSubjectFields[replaceFromText];
						var replaceWithText = replacementPlaceholders;

						dynamicFields.forEach(function(field) {
							replaceWithText = me.getDynamicTextWithFieldAndRep(replaceWithText, field, dynamicFieldReps, getDynamicFieldRep, lowerCaseDynamicFields);
						});

						if(replacementPlaceholders != replaceWithText) {
							text = text.replace(new RegExp(replaceMatch[0], 'ig'), replaceWithText);
						}
					}
				}
			}

			return text;
		},
		getDynamicTextWithFieldAndRep: function(text, field, dynamicFieldReps, getDynamicFieldRep, lowerCaseDynamicFields) {
			var regexText = field + ' ?(\\d?)';
			var checkIfArray = null;
			if(field[field.length - 1] == '1') {
				checkIfArray = (field.substr(0, field.length - 1) + 'x').toLowerCase();
				regexText += '|' + checkIfArray;
			}

			var fieldTextRegex = new RegExp('%(' + regexText + ')%', 'i');
			var match;
			// eslint-disable-next-line
			while(match = text.match(fieldTextRegex)) {
				// If we have Email, Email 1, Email 2, etc... then putting in a variable %email 2% should never pick up Email for subject 2 instead of the field Email 2
				if(lowerCaseDynamicFields[match[1]] && match[1].toLowerCase() !== field.toLowerCase()) {
					text = this.getDynamicTextWithFieldAndRep(text, lowerCaseDynamicFields[match[1]], dynamicFieldReps, getDynamicFieldRep, lowerCaseDynamicFields);
					continue;
				}

				var fieldMatch = match[0].replace(/%/g, '');
				var data = dynamicFieldReps[fieldMatch];
				if(!$.isInit(data)) {
					var subjectIndex = null;
					var options = {};
					// Pose Name 2 is not subject 2, it is pose 2 of whatever subject is listed
					if(['Pose Name', 'Ordered Photo Name', 'Order Background Name', 'Group Photo Name'].includes(field)) {
						if(this.instance && this.instance.subjectIndex) {
							subjectIndex = this.instance.subjectIndex;
						}

						if(match[2]) {
							options.secondaryIndex = parseInt(match[2]) - 1;
						}
					} else {
						if(match[2]) {
							subjectIndex = parseInt(match[2]) - 1;
						} else if(this.instance && this.instance.subjectIndex) {
							subjectIndex = this.instance.subjectIndex;
						}
					}

					if(match[1] == checkIfArray) {
						var parts = [];
						for(let j = 1; j < 100; j++) {
							var numberedField = field.substr(0, field.length - 1) + j;
							var value = getDynamicFieldRep.call(this, numberedField, subjectIndex, options);
							if(value && value != numberedField) {
								parts.push(value);
							} else {
								break;
							}
						}

						data = parts.join(', ');
					} else {
						data = getDynamicFieldRep.call(this, field, subjectIndex, options);
					}

					dynamicFieldReps[fieldMatch] = data;
				}

				if($.isInit(data)) {
					if($.isArray(data)) {
						let commas = data.join(', ');
						if(commas.includes('\n')) {
							data = data.join('\n');
						} else {
							data = commas;
						}
					}
					text = text.replace(new RegExp(match[0], 'ig'), data);
				} else {
					// Stop this from infinite recursion if we don't find a match
					break;
				}
			}

			return text;
		},
		getAlwaysBlankDynamicText: function(text) {
			var fieldTextRegex = new RegExp('%(order property|order option) (.*?)%', 'i');
			var match;
			// eslint-disable-next-line
			while(match = text.match(fieldTextRegex)) {
				text = text.replace(match[0], '');
			}

			return text;
		},
		emptyLines: function() {
			delete this.cachedTextNodes;
			while(this.svgEditor.firstChild) {
				this.svgEditor.removeChild(this.svgEditor.firstChild);
			}

			me.svgEditor.removeAttribute('width');
			me.svgEditor.removeAttribute('height');
		},
		getCurrentSelectionTSpan: function(scope) {
			if(!scope) {
				scope = this;
			}

			let text = this.getCurrentSelectionText(scope);
			var tspans = $(text).children('tspan');
			if(tspans.length === 0) {
				return null;
			}

			// Iterate to next tspan if position is too high (ie: parts)
			var startPosition = scope.selectionPosition;
			var currentTspan = tspans[0];
			while(currentTspan.nextSibling && startPosition > currentTspan.textContent.length) {
				startPosition -= currentTspan.textContent.length;
				currentTspan = currentTspan.nextSibling;
			}
			scope.selectionPartPosition = startPosition;

			return currentTspan;
		},
		getText: function(line) {
			var texts = $(this.svgEditor).children('text').not('.clone');
			let text = texts[line];

			return text;
		},
		getCurrentSelectionText: function(scope) {
			return this.getText(this.getSelectionLine(scope));
		},
		setPadding: function(padding) {
			$(me).css('padding', (me.ratio * padding) + 'px');
		},
		sanitizeUserTypesEvent: function(e) {
			if(e.key == 'Unidentified' || e.key === 'Dead') {
				e.key = '';
			}
		},
		onUserTypes: function(e) {
			this.altKeyPressed = e.altKey;
			if(e.altKey || (e.keyCode === 229 && e.key === 'Process')) {
				return true;
			}

			this.sanitizeUserTypesEvent(e);
			if(_onUserTypes.apply(this, arguments)) {
				// Already handled by parent function
				return true;
			}
			else if(!this.textEditable) {
				return true;
			}
			// F1 -> F12
			else if(e.keyCode >= 112 && e.keyCode <= 123) {
				return true;
			}
			// Left/right arrow
			else if(e.keyCode == 37 || e.keyCode == 39) {
				var lineText = this.getCurrentLineText();
				var inc = e.keyCode == 39 ? 1 : -1;
				if($.FlowLayoutSVGUtils.isMultiByteCharacter(lineText, this.selectionPosition + Math.min(0, inc))) {
					inc *= $.FlowLayoutSVGUtils.getMultiByteCharacterLength(lineText, this.selectionPosition, inc === -1);
				}
				
				this.selectionPosition += inc;
				this.selectionLength = 0;

				let lineLength = lineText.length;
				// Wrap around to previous line
				if(this.selectionPosition < 0) {
					if(this.selectionLine === 0) {
						this.selectionPosition = 0;
					} else {
						this.selectionLine--;
						this.selectionPosition = this.getCurrentLineLength();
					}
				}
				// Wrap around to next line or don't allow if on last line
				else if(this.selectionPosition > lineLength) {
					if((this.selectionLine + 1) >= this.getLineCount()) {
						this.selectionPosition--;
					} else {
						this.selectionLine++;
						this.selectionPosition = 0;
					}
				}

				this.updateToolbarDisplay();
				this.updateCursorPosition();
			}
			// Up/down arrow
			else if(e.keyCode == 38 || e.keyCode == 40) {
				// var startTspan = this.getCurrentSelectionTSpan();
				// var startRect = startTspan.getStartPositionOfChar(this.selectionPartPosition);

				this.selectionLine += e.keyCode == 40 ? 1 : -1;
				if(this.selectionLine < 0) {
					this.selectionLine = 0;
					this.selectionPosition = 0;
				} else if(this.selectionLine >= this.getLineCount()) {
					this.selectionLine = this.getLineCount() - 1;
					this.selectionPosition = this.getCurrentLineLength();
				} else {
					// Try to maintain column position
					// var newText = this.getCurrentSelectionText();
					// this.selectionPosition = this.getCharacterFromXPosition(newText, startRect.x, false);
				}
				this.selectionLength = 0;

				this.updateToolbarDisplay();
				this.updateCursorPosition();
			}
			// Home
			else if(e.keyCode == 36) {
				this.selectionPosition = 0;
				this.selectionLength = 0;

				this.updateToolbarDisplay();
				this.updateCursorPosition();
			}
			// End
			else if(e.keyCode == 35) {
				this.selectionPosition = this.getCurrentLineLength();
				this.selectionLength = 0;

				this.updateToolbarDisplay();
				this.updateCursorPosition();
			}
			// Enter
			else if(e.keyCode == 13) {
				if(this.maxCharacters && this.getCurrentLineLength() + text.length > this.maxCharacters) {
					e.preventDefault();
					return false;
				}
				if(!this.allowNewLines || (this.maxLines && this.getInstanceLines().length >= this.maxLines) || this.hasBarcode()) {
					return false;
				}

				this.splitAlongCurrentPosition();
				this.updateLines();
			}
			// Backspace
			else if(e.keyCode == 8) {
				if(this.selectionPosition > 0 || this.selectionLength) {
					let selection = this.getCurrentSelection({
						preferStartPart: true
					});
					if(this.selectionLength) {
						this.deleteRangeFromCurrentSelection(selection);
					} else {
						let removeCharacters = 1;
						if($.FlowLayoutSVGUtils.isMultiByteCharacter(selection.text, this.selectionPartPosition - 1)) {
							removeCharacters = $.FlowLayoutSVGUtils.getMultiByteCharacterLength(selection.text, this.selectionPartPosition, true);
						}

						selection.text = selection.text.substring(0, this.selectionPartPosition - removeCharacters) + selection.text.substring(this.selectionPartPosition);
						this.selectionPosition -= removeCharacters;
					}

					if(selection.text === '') {
						this.deleteSelectionPart(selection);
					}
				} else if(this.selectionLine > 0) {
					// Merge this and previous line together
					var mergeLine = this.getLine(this.selectionLine - 1);
					var currentLine = this.getCurrentLine();
					this.appendSpaceToLineIfNeeded(mergeLine);
					
					this.selectionPosition = this.getLineLength(mergeLine);
					this.mergeLinesTogether(mergeLine, this.getCurrentLine());
					this.selectionLine--;

					if(this.recalculateWordWrapText(currentLine)) {
						// Update display again if we changed
						this.updateLines();
					}
				}

				this.updateLines();
			}
			// Delete
			else if(e.keyCode == 46 || e.inputType === 'deleteByCut') {
				let selection = this.getCurrentSelection();
				if(this.selectionLength) {
					this.deleteRangeFromCurrentSelection(selection);
				} else if(this.selectionPosition >= this.getCurrentLineLength()) {
					// Merge this and next line together
					if(this.selectionLine + 1 < this.getLineCount()) {
						this.mergeLinesTogether(this.getCurrentLine(), this.getLine(this.selectionLine + 1));
					}
				} else {
					let removeCharacters = 1;
					if($.FlowLayoutSVGUtils.isMultiByteCharacter(selection.text, this.selectionPartPosition)) {
						removeCharacters = $.FlowLayoutSVGUtils.getMultiByteCharacterLength(selection.text, this.selectionPartPosition);
					}

					selection.text = selection.text.substring(0, this.selectionPartPosition) + selection.text.substring(this.selectionPartPosition + removeCharacters);
				}

				if(selection.text === '') {
					this.deleteSelectionPart(selection);
				}

				this.updateLines();
			}
			// Control + c => copy
			else if((e.keyCode == 67 || e.keyCode == 88) && e.ctrlKey && this.selectionLength) {
				var input = document.createElement('textarea');
				document.body.appendChild(input);

				let text = this.getTextFromSelection();
				input.value = text;
				input.setSelectionRange(0, input.value.length);
				input.select();
				document.execCommand('copy');

				document.body.removeChild(input);

				// This is just for testing purposes
				this.lastCopyText = input.value;

				// We lose focus after doing the copy
				$(this.hiddenInput).focus();

				// Ctrl + x
				if(e.keyCode == 88) {
					let selection = this.getCurrentSelection();
					this.deleteRangeFromCurrentSelection(selection);

					if(selection.text === '') {
						this.deleteSelectionPart(selection);
					}

					this.updateLines();
				}
			}
			// Want to trigger native paste event
			else if(e.keyCode == 86 && e.ctrlKey) {
				e.stopPropagation();
				return true;
			}
			// Ctrl + a => select all
			else if(e.keyCode == 65 && e.ctrlKey) {
				this.selectionPosition = 0;
				this.selectionLine = 0;
				this.selectionLength = this.getInstanceLength({
					requireMinSpace: true
				});

				this.updateCursorPosition();
			}
			// Page up
			else if(e.keyCode == 33) {
				this.selectionLine = 0;
				this.updateCursorPosition();
			}
			// Page down
			else if(e.keyCode == 34) {
				this.selectionLine = this.getLineCount() - 1;
				this.updateCursorPosition();
			}
			// Random control characters
			else if((e.keyCode < 48 && [9, 32].indexOf(e.keyCode) == -1) || [91, 92, 93].indexOf(e.keyCode) != -1 || (e.keyCode >= 112 && e.keyCode <= 145)) {
				return true;
			}
			// Defer to global undo/redo handler
			else if((e.keyCode == 90 || e.keyCode == 89) && e.ctrlKey) {
				return true;
			}
			// Normal characters (I hope)
			else {
				// Uses Polyfill: https://github.com/inexorabletash/polyfill/blob/master/keyboard.md
				var text;
				if(e.type == 'paste') {
					if(e.originalEvent.clipboardData) {
						text = e.originalEvent.clipboardData.getData('text');
					} else if(window.clipboardData) {
						text = window.clipboardData.getData('text');
					} else {
						throw 'Do not know where to look for clipboardData';
					}

					text = text.replace(/\t/g, $.DEFAULT_TAB_SPACES);
					// We are only using higher range control character so we can preserve newlines to be used in line wrapping step
					text = text.replace($.FlowLayoutSVGUtils.unusualControlCharacterRegex, '');

					if(text.length > 2000 && $.alertWhenPastingLargeText) {
						alert('You just copy pasted a large chunk of text.  It will take a minute to flow everything onto the page');
					}
				} else if(e.keyCode == 9) {
					text = $.DEFAULT_TAB_SPACES;
				} else if(typeof e.key === 'string') {
					text = e.key;
				} else if((['insertText', 'insertCompositionText'].includes(e.inputType) || e.type === 'compositionend') && typeof e.data === 'string') {
					text = e.data;
				} else {
					e.preventDefault();
					return false;
				}

				if(this.maxCharacters && this.getCurrentLineLength() + text.length > this.maxCharacters) {
					e.preventDefault();
					return false;
				}

				text = this.sanitizeEmojiText(text);

				var startSelectionPosition = this.selectionPosition;
				var startSelectionLine = this.selectionLine;
				let selection = this.getCurrentSelection({
					preferStartPart: true
				});
				if(this.selectionLength) {
					selection = this.deleteRangeFromCurrentSelection(selection);
				}

				if(!$.isInit(selection.text)) {
					var exception = new Error('There is no text on this selection');
					exception.selection = selection;
					throw exception;
				}
				selection.text = selection.text.substring(0, this.selectionPartPosition) + text + selection.text.substring(this.selectionPartPosition);
				this.selectionPosition += text.length;
				if(e.type == 'paste' && (text.indexOf('\n') != -1 || text.indexOf('\r') != -1)) {
					this.splitSelectionAlongNewLines(selection);
				}
				this.updateLinesInUserTypes();

				// Want to strip newlines since they were auto removed in this.splitSelectionAlongNewLines() above
				// console.time('wrap');
				var totalLength = text.replace(/\r\n/g, '').replace(/\n/g, '').length;
				if(this.findWordWrapText(startSelectionLine, startSelectionPosition, totalLength)) {
					// Update display again if we changed
					this.updateLines();
				} else {
					this.noWordWrapInUserTypes();
				}
				// console.timeEnd('wrap');

				this.removeHardLineBreaks();
			}

			// Anything which does not return true immediately should preventDefault
			e.preventDefault();
			return false;
		},
		updateLinesInUserTypes: function() {
			this.updateLines();
		},
		noWordWrapInUserTypes: function() {
			
		},
		getLastLineIndex: function() {
			return this.getLineCount() - 1;
		},
		splitAlongCurrentPosition: function(render, options) {
			var line;
			var startInstance;
			var startSelection = {
				position: this.selectionPosition,
				partPosition: this.selectionPartPosition,
				length: this.selectionLength,
				line: this.selectionLine
			};
			try {
				if(!options) {
					options = {};
				}

				var instance = this.instance;
				startInstance = $.extend(true, {}, instance);
				if(!$.isArray(instance.lines)) {
					instance.lines = [instance.lines];
				}
				render = render !== false;

				line = this.getCurrentLine();
				let newLine = this.createBasicLineClone(line);
				if(this.selectionPosition === 0) {
					this.insertLine(newLine, this.selectionLine, render);
				} else if(this.selectionPosition === this.getLineLength(line)) {
					this.insertLine(newLine, this.selectionLine + 1, render);
				} else {
					if(line.parts) {
						var currentPart = this.getCurrentSelection();
						var partIndex = line.parts.indexOf(currentPart);
						if(this.selectionPartPosition) {
							this.splitSelectionIntoParts(line, currentPart, this.selectionPartPosition);
							if(line.parts.length > 1) {
								partIndex++;
							}
						}
						newLine.parts = this.mergeIdenticalPartsTogether(line.parts.splice(partIndex));
					} else {
						let text = line.text;
						line.text = text.substring(0, this.selectionPosition);
						newLine.text = text.substring(this.selectionPosition);
					}

					if(options.deleteLeadingSpace) {
						if(newLine.parts) {
							newLine.parts[0].text = newLine.parts[0].text.substr(1);
						} else {
							newLine.text = newLine.text.substr(1);
						}
					}

					if(options.mergeWithNextLine && this.instance.lines.length > (this.selectionLine + 1) && !this.disableWrapMergeWithNextLine) {
						var nextLine = this.getLine(this.selectionLine + 1);
						var nextLineText = this.getLineText(nextLine);
						if(nextLine.hardLineBreak || $.trim(nextLineText) == '' || nextLineText.indexOf('   ') === 0) {
							this.insertLine(newLine, this.selectionLine + 1, render);
						} else {
							this.appendTextToLine(newLine, ' ');
							this.mergeLinesTogether(nextLine, newLine, false, undefined, render);
						}
					} else {
						this.insertLine(newLine, this.selectionLine + 1, render);
					}
				}

				this.selectionLine++;
				this.selectionPosition = 0;
				this.selectionLength = 0;
			} catch(e) {
				this.fireErrorReport('splitAlongCurrentPosition', 'Error in splitAlongCurrentPosition', e, {
					startInstance: JSON.stringify(startInstance),
					currentInstance: JSON.stringify(this.instance),
					origInstance: JSON.stringify(this.origInstance),
					render: render,
					options: options,
					line: JSON.stringify(line),
					startSelection: startSelection
				});

				throw e;
			}
		},
		createBasicLineClone: function(line) {
			let newLine = $.extend(true, {}, line);
			if(newLine.text) {
				newLine.text = '';
			} else if(newLine.parts) {
				var newPart = newLine.parts[newLine.parts.length - 1];
				newPart.text = '';
				newLine.parts = [newPart];
			}

			return newLine;
		},
		appendSpaceToLineIfNeeded: function(line) {
			try {
				var part = line;

				if(line.parts) {
					part = line.parts[line.parts.length - 1];
				}

				if(part.text[part.text.length - 1] !== ' ') {
					part.text += ' '
				}
			} catch(e) {
				this.fireErrorReport('appendSpaceToLineIfNeeded', 'Error in appendSpaceToLineIfNeeded', e, {
					instance: JSON.stringify(this.instance),
					line: line
				});

				throw e;
			}
		},
		appendTextToLine: function(line, text) {
			try {
				if(line.parts) {
					line.parts[line.parts.length - 1].text += text;
				} else {
					line.text += text;
				}
			} catch(e) {
				this.fireErrorReport('appendTextToLine', 'Error in appendTextToLine', e, {
					instance: JSON.stringify(this.instance),
					line: line,
					text: text
				});

				throw e;
			}
		},
		appendPartsToLine: function(line, parts) {
			if(!line.parts) {
				this.splitLineToParts(line);
			}
			if(parts[0].text && parts[0].text.length && parts[0].text[0] !== ' ') {
				parts[0].text = ' ' + parts[0].text;
			}

			parts.forEach(function(part) {
				var newPart = $.extend(true, {}, part);
				me.lineSpecificStyles.forEach(function(style) {
					if(newPart[style]) {
						delete newPart[style];
					}
				});

				line.parts.push(newPart);
			});
			line.parts = this.mergeIdenticalPartsTogether(line.parts);
		},
		deleteRangeFromCurrentSelection: function(selection) {
			var newSelection = this.deleteRangeFromSelection(this.selectionLine, selection, this.selectionLength, this.selectionPartPosition);
			this.selectionLength = 0;
			return newSelection;
		},
		deleteRangeFromSelection: function(lineIndex, startSelection, remainingCharacters, startPosition) {
			var startLineIndex = lineIndex;
			let line = this.getLine(lineIndex);
			let selection = startSelection;
			var mergedLines = 0;

			var lastStartSelection = startSelection;
			while(remainingCharacters > 0) {
				var charactersRemoved = selection.text.length - startPosition;
				selection.text = selection.text.substring(0, startPosition) + selection.text.substring(startPosition + remainingCharacters);
				remainingCharacters -= charactersRemoved;

				var goToNextLine = false;
				var goToPrevLine = false;
		
				if(selection == line && this.selectionPosition >= 0) {
					goToNextLine = true;
				} else if (selection == line && this.selectionPosition < 0) {
					goToPrevLine = true;
				} else {
					var selectionIndex = line.parts.indexOf(selection);
					// Check if this is the entire part and not the entire line, delete
					if(selection.text === '' && line.parts.length && (line.parts.length > 1 || remainingCharacters > 0)) {
						line.parts.splice(selectionIndex, 1);

						if(selection == startSelection) {
							startSelection = line.parts[selectionIndex];
						}
					} else {
						selectionIndex++;
					}

					if(selectionIndex == line.parts.length && this.selectionPosition >= 0) {
						goToNextLine = true;
					} else if(selectionIndex == line.parts.length && this.selectionPosition < 0){
						goToPrevLine = true;
					} else {
						selection = line.parts[selectionIndex];
						startPosition = 0;
					}
				}

				if(goToNextLine && remainingCharacters > 0) {
					lineIndex++;
					let newLine = this.getLine(lineIndex);
					if(newLine) {
						line = newLine;
						if(line.parts) {
							selection = line.parts[0];
						} else {
							selection = line;
						}
						startPosition = 0;
						mergedLines++;

						// startSelection can get nulled out if we are deleting across all of first line and into the second
						if(!startSelection) {
							startSelection = selection;
						}
					} else {
						break;
					}
				} else if (goToPrevLine && remainingCharacters < 0) {
					lineIndex--;
					let newLine = this.getLine(lineIndex);
					if(newLine) {
						line = newLine;
						if(line.parts) {
							selection = line.parts[0];
						} else {
							selection = line;
						}
						startPosition = 0;
						mergedLines--;

						// startSelection can get nulled out if we are deleting across all of first line and into the second
						if(!startSelection) {
							startSelection = selection;
						}
					} else {
						break;
					}
				} else if(line.parts && line.parts.length === 0) {
					line.parts = [{
						text: ''
					}];
				}

				if(startSelection) {
					lastStartSelection = startSelection;
				}
			}

			if(mergedLines > 0) {
				for(let i = 0; i < mergedLines; i++) {
					startSelection = this.mergeLinesTogether(this.getLine(startLineIndex), this.getLine(startLineIndex + 1), null, startSelection);
				}
			} else if(mergedLines < 0) {
				for(let i = 0; i < -mergedLines; i++) {
					startSelection = this.mergeLinesTogether(this.getLine(startLineIndex - 1), this.getLine(startLineIndex), null, startSelection);
				}
			}

			if(startSelection) {
				// Sometimes mergeLinesTogether will create parts where there were none before
				if (startSelection.parts) {
					return startSelection.parts[0];
				} else {
					return startSelection;
				}
			} else {
				if(line.parts.length === 0) {
					delete line.parts;
					$.extend(true, line, lastStartSelection);
					return line;
				} else {
					throw 'Unknown behavior';
				}
			}
		},
		deleteSelectionPart: function(selection) {
			let line = this.getCurrentLine();
			if(line == selection || !line.parts || line.parts.length <= 1) {
				return;
			}

			var index = line.parts.indexOf(selection);
			if(index != -1) {
				line.parts.splice(index, 1);
			}
		},
		mergeLinesTogether: function(mergeOntoLine, deleteLine, appendToMergeLine, startSelection, render) {
			if(!$.isInit(appendToMergeLine)) {
				appendToMergeLine = true;
			}

			var deleteLineIndex = this.instance.lines.indexOf(deleteLine);

			if($(mergeOntoLine).objectEquals(deleteLine, ['text', 'align', 'drop-shadow'], true) && !mergeOntoLine.parts && !deleteLine.parts) {
				// We can do a simple merge
				if(appendToMergeLine) {
					mergeOntoLine.text = mergeOntoLine.text + deleteLine.text;
				} else {
					mergeOntoLine.text = deleteLine.text + mergeOntoLine.text;
				}
			} else if(deleteLine.text === '') {
				// Do nothing since we want to just delete the second line
				// First line styling takes precedence
				if(mergeOntoLine.parts && mergeOntoLine.parts.length === 0 && !deleteLine.parts) {
					mergeOntoLine.parts.push(deleteLine);
				}
			} else if(mergeOntoLine.text === '' && !deleteLine.parts) {
				mergeOntoLine.text = deleteLine.text;
			} else {
				// Need to add a separate part
				// Create the parts based on current line if not exists
				if(!mergeOntoLine.parts) {
					var linePart = $.extend(true, {}, mergeOntoLine);
					for(let i in mergeOntoLine) {
						delete mergeOntoLine[i];
					}

					if(linePart.align) {
						mergeOntoLine.align = linePart.align;
						delete linePart.align;
					}

					mergeOntoLine.parts = [linePart];
				}

				// Add the deleteLine as a part
				if(appendToMergeLine) {
					if(deleteLine.parts) {
						$.merge(mergeOntoLine.parts, deleteLine.parts);
					} else {
						mergeOntoLine.parts.push(deleteLine);
					}
				} else {
					if(deleteLine.parts) {
						mergeOntoLine.parts = $.merge($.merge([], deleteLine.parts), mergeOntoLine.parts);
					} else {
						mergeOntoLine.parts.unshift(deleteLine);
					}
				}

				mergeOntoLine.parts = this.mergeIdenticalPartsTogether(mergeOntoLine.parts);
			}

			if(render) {
				this.updateLineRender(mergeOntoLine);
			}

			if(deleteLineIndex != -1) {
				this.removeLine(deleteLineIndex, render);
			}

			if(startSelection === deleteLine) {
				return mergeOntoLine;
			} else {
				return startSelection;
			}
		},
		updateLineRender: function(line, updateCachedRect) {
			var lineIndex = this.instance.lines.indexOf(line);
			var textNode = this.createTempLine(line)[0];
			var oldTextNode = this.getText(lineIndex);
			while(oldTextNode.firstChild) {
				oldTextNode.removeChild(oldTextNode.firstChild);
			}

			[].slice.call(textNode.childNodes).forEach(function(tspanNode) {
				oldTextNode.appendChild(tspanNode);
			});

			// Since we are adding text to the next line, center we calculated before is no longer correct
			// Remove center alignment since it matches left alignment for text wrapping purposes
			if(oldTextNode.getAttribute('text-anchor') === 'middle') {
				oldTextNode.setAttribute('x', oldTextNode.cachedLeadingTextSpace);
				oldTextNode.removeAttribute('text-anchor');
			}

			if(updateCachedRect) {
				oldTextNode.cachedBoundingClientRect = oldTextNode.getBoundingClientRect();
			}
		},
		insertLine: function(newLine, newLineIndex, render) {
			var lines = this.instance.lines;
			lines.splice(newLineIndex, 0, newLine);

			if(render) {
				var insertBeforeTextNode = this.getText(newLineIndex);
				var linesTextNodes = this.createTempLine(newLine);

				var textNode;
				for(let j = 0; j < linesTextNodes.length; j++) {
					textNode = linesTextNodes[j];

					if(insertBeforeTextNode) {
						$(textNode).insertBefore(insertBeforeTextNode);
					} else {
						this.svgEditor.appendChild(textNode);
					}

					this.cachedTextNodes.splice(newLineIndex + j, 0, textNode);
				}

				return linesTextNodes;
			}

			return null;
		},
		removeLine: function(deleteLineIndex, render) {
			this.instance.lines.splice(deleteLineIndex, 1);

			if(render) {
				var textNode = this.getText(deleteLineIndex);
				this.svgEditor.removeChild(textNode);
			}
		},
		splitSelectionAlongNewLines: function(selection) {
			if(!$.isArray(this.instance.lines)) {
				this.instance.lines = [this.instance.lines];
			}

			var newLineIndex;
			while((newLineIndex = selection.text.search(/\r\n|\r\r|\r|\n/)) != -1) {
				let line = this.getCurrentLine();
				let newLine = $.extend(true, {}, line);
				newLine.hardLineBreak = true;
				let text = selection.text;
				var newLineLength = 1;
				if(text.length > (newLineIndex + 1) && (text.charCodeAt(newLineIndex + 1) == 13 || text.charCodeAt(newLineIndex + 1) == 10)) {
					newLineLength++;
				}

				selection.text = text.substr(0, newLineIndex);

				var newSelection;
				if (newLine.text) {
					newSelection = newLine;
				} else if (newLine.parts) {
					if(newLine.parts.length) {
						var partIndex = line.parts.indexOf(selection);
						var newPart = newLine.parts[partIndex];

						// Need to remove space from parts which are going to be deleted
						for (let i = 0; i < partIndex; i++) {
							this.selectionPosition -= line.parts[i].text.length;
						}

						// Get rid of extra parts from both lines
						line.parts.splice(partIndex + 1, line.parts.length - partIndex - 1);
						newLine.parts.splice(0, partIndex);

						newSelection = newPart;
					} else {
						delete newLine.parts;
						newSelection = newLine;
					}
				}
				newSelection.text = text.substr(newLineIndex + newLineLength);

				this.insertLine(newLine, this.selectionLine + 1);
				this.selectionLine++;
				this.selectionPosition -= (newLineIndex + newLineLength);
				selection = newSelection;
			}
		},
		removeHardLineBreaks: function() {
			this.iterateInstanceLines(function(line) {
				if(line.hardLineBreak) {
					delete line.hardLineBreak;
				}
			});
		},
		// This is to be used when we need to recalculate based off font-size or similar changes
		recalculateWordWrapText: function(selections, updateLinesBeforeCheck, updateOnChange) {
			if(!this.wordWrapText) {
				return false;
			}

			// If no selections passed, recalculate for entire thing
			var lineStart = -1;
			if(selections) {
				for(let i = 0; i < selections.length; i++) {
					var selectionLine = this.getLineIndexForPart(selections[i]);
					if(lineStart == -1) {
						lineStart = selectionLine;
					} else {
						lineStart = Math.min(lineStart, selectionLine);
					}
				}
			}

			var textLength = 0;
			if(lineStart >= 0) {
				for (let i = lineStart; i < this.instance.lines.length; i++) {
					textLength += this.getLineLength(this.getLine(i));
				}
			} else {
				lineStart = 0;
				textLength = this.getInstanceLength();
			}

			var startSelectionPosition = this.selectionPosition;
			var startSelectionLine = this.selectionLine;
			var startSelectionLength = this.selectionLength;

			if(updateLinesBeforeCheck !== false) {
				this.updateLines();
			}
			var wasChange = this.findWordWrapText(lineStart, 0, textLength);
			if(updateOnChange && wasChange) {
				this.updateLines();
			}

			this.selectionPosition = startSelectionPosition;
			this.selectionLine = startSelectionLine;
			this.selectionLength = startSelectionLength;

			return wasChange;
		},
		// This is to be used when the user manually changed something
		findWordWrapText: function(startLine, startPosition, length, wordWrapRightPosition, rootLeftPosition) {
			if(!this.wordWrapText || this.hasBarcode()) {
				return false;
			}

			// Get what character we should word wrap at
			wordWrapRightPosition = this.getWordWrapRightPosition(wordWrapRightPosition);
			if(!wordWrapRightPosition) {
				return false;
			}
			this.selectionLine = startLine;
			this.selectionPosition = startPosition;

			rootLeftPosition = this.getRootLeftPosition(rootLeftPosition);
			var breakCharacter = this.getWordWrapBreakCharacter(wordWrapRightPosition, rootLeftPosition);

			let text = this.getCurrentLineText();
			// Right of text is less than right of parent boundary
			// We need + 2 because length is one more then index and character n + 1 means to the right of that character (ie: to right of last character)
			if(breakCharacter > (text.length - 1)) {
				if((length - text.length) > 0 && startLine < this.getLastLineIndex()) {
					return this.findWordWrapText(startLine + 1, 0, length - text.length + startPosition, wordWrapRightPosition, rootLeftPosition);
				} else {
					this.selectionPosition += length;
					return false;
				}
			}

			var wordBreakCharacter = this.getWordBreakCharacter(breakCharacter, text);
			// We want to word wrap if be are past the last character or if the last character is a space
			if(wordBreakCharacter > 0 && wordBreakCharacter < text.length && (wordBreakCharacter < (text.length - 1) || text[wordBreakCharacter] === ' ')) {
				this.splitAlongWordBreakCharacter(wordBreakCharacter, length, wordWrapRightPosition, rootLeftPosition);
				this.updateSelectionAfterWordWrap(startLine, startPosition, length);
				return true;
			} else {
				this.selectionPosition += length;
				return false;
			}
		},
		getWordWrapRightPosition: function(wordWrapRightPosition) {
			if(!wordWrapRightPosition) {
				var parentNode = this.parentNode;
				if(typeof this.wordWrapTextBounds !== 'undefined') {
					parentNode = this.wordWrapTextBounds;
				}
				if(!parentNode) {
					return null;
				}
				wordWrapRightPosition = parentNode.getBoundingClientRect().right - this.wordWrapRightPadding;

				if(this.instance.manualSize && this.instance.manualSize.width) {
					let svgRect = this.getBoundingClientRect();
					var svgWrapRightPosition = svgRect.right;

					if(svgRect.left > wordWrapRightPosition || this.preferManualSizeWrap) {
						// If the element starts past it's parent, just use my right bounds
						wordWrapRightPosition = svgWrapRightPosition;
					} else {
						wordWrapRightPosition = Math.min(wordWrapRightPosition, svgWrapRightPosition);
					}
				}
			}

			return wordWrapRightPosition;
		},
		getRootLeftPosition: function(rootLeftPosition) {
			if(!rootLeftPosition) {
				rootLeftPosition = this.getBoundingClientRect().left;
			}

			return rootLeftPosition;
		},
		// This just finds where we should wrap
		getWordWrapBreakCharacter: function(wordWrapRightPosition, rootLeftPosition, textNode, lineNumber) {
			if(!textNode) {
				textNode = this.getCurrentSelectionText();
				lineNumber = this.selectionLine;
			}

			var textLength = textNode.getAttribute('textLength');
			if(textLength) {
				textNode.removeAttribute('textLength');
				if($.SVGRequiresTspanTextLength) {
					[].forEach.call(textNode.childNodes, function(tspanNode) {
						tspanNode.removeAttribute('textLength');
					});
				}
			}

			if(textNode.overrideWordWrapRightPosition && (!this.manualLastWordWrapRightPosition || wordWrapRightPosition !== this.manualLastWordWrapRightPosition[lineNumber])) {
				wordWrapRightPosition = textNode.overrideWordWrapRightPosition;
			}

			var lastTspanNode = textNode.childNodes[textNode.childNodes.length - 1];
			var textRect = lastTspanNode.getBoundingClientRect();

			var incrementPastEdge = 0;
			var xPositionCheck = wordWrapRightPosition - rootLeftPosition;
			var svgRect;
			if(textNode.getAttribute('text-anchor') == 'end' && this.style.width) {
				var expectedWidth = $(this).getFloatStyle('width');
				if(textRect.width > expectedWidth) {
					incrementPastEdge = -1;
				}

				svgRect = this.svgEditor.getBoundingClientRect();
				if(svgRect.width > expectedWidth) {
					var outerDiff = svgRect.width - expectedWidth;
					var largestTextDiff = svgRect.width - textRect.width;
					xPositionCheck += Math.min(outerDiff, largestTextDiff);
				}

			} else {
				var textRight = textRect.right;

				// If we have rotated text next to edge of page, tspans naturally go higher and lower then they appear so position can be off the edge when it shouldn't be
				var rotation = this.getRotation();
				if(rotation) {
					svgRect = this.svgEditor.getBoundingClientRect();
					textRight = svgRect.right;
				}

				var correction = 0.8;
				if(textNode.cloneTextNode) {
					correction *= 2;
				}

				// Currently we aren't detecting edges while rotated on the side even remotely correctly, so don't try
				if(textRight > (wordWrapRightPosition + correction) && !rotation) {
					incrementPastEdge = -1;
				}
			}

			var character = this.getCharacterFromXPosition(textNode, xPositionCheck, {
				incrementPastEdge: incrementPastEdge
			});

			if(textLength) {
				textNode.setAttribute('textLength', textLength);
				if($.SVGRequiresTspanTextLength) {
					[].forEach.call(textNode.childNodes, function(tspanNode) {
						tspanNode.setAttribute('textLength', textLength);
					});
				}
			}

			return character;
		},
		// This finds the nearest word to wrap on
		getWordBreakCharacter: function(breakCharacter, text) {
			var minBreakCharacter = breakCharacter;
			var maxBreakCharacter = breakCharacter;

			// Check if we are in the middle of a dynamic variable
			if(this.getDynamicFields) {
				var variableStart = text.lastIndexOf('%', breakCharacter);
				if(variableStart !== -1) {
					var dynamicFields = this.getDynamicFields(true);
					var substr = text.substring(variableStart + 1, breakCharacter).toLowerCase();

					for(let i = 0; i < dynamicFields.length; i++) {
						var field = dynamicFields[i];

						if(field.toLowerCase().indexOf(substr) !== -1) {
							minBreakCharacter = variableStart;

							var variableClose = text.indexOf('%', minBreakCharacter + 1);
							if(variableClose === -1) {
								maxBreakCharacter = text.length;
							} else {
								maxBreakCharacter = variableClose;
							}
						}
					}
				}
			}

			// Make sure we split along word boundaries
			var wordBreakCharacter = minBreakCharacter;
			while(wordBreakCharacter > 0 && text[wordBreakCharacter] != ' ') {
				wordBreakCharacter--;
			}

			// If we are on a really long start word try looking in the other direction
			if(wordBreakCharacter === 0 && maxBreakCharacter > 0) {
				wordBreakCharacter = maxBreakCharacter;

				// Increment until we find a space or the end
				while(wordBreakCharacter < (text.length - 1) && text[wordBreakCharacter] != ' ') {
					wordBreakCharacter++;
				}
			}

			return wordBreakCharacter;
		},
		splitAlongWordBreakCharacter: function(wordBreakCharacter, length, wordWrapRightPosition, rootLeftPosition) {
			// Split along these lines
			this.selectionPosition = wordBreakCharacter;
			this.splitAlongCurrentPosition(true, {
				mergeWithNextLine: true,
				deleteLeadingSpace: true
			});
			this.changeInstanceProperty('lines', this.instance.lines);

			// Recurse to next lines
			this.findWordWrapText(this.selectionLine, 0, length - wordBreakCharacter - 1, wordWrapRightPosition, rootLeftPosition);
		},
		updateSelectionAfterWordWrap: function(startLine, startPosition, length) {
			// After done recursing need to add back original startPosition
			this.selectionPosition += startPosition;
			// If we are negative then we were typing this in the middle and need to go back
			if(this.selectionPosition < 0) {
				this.selectionLine = startLine;
				this.selectionPosition = startPosition + length;
			}
		},
		recalculateReverseWordWrap: function(wordWrapRightPosition, rootLeftPosition) {
			if(!this.wordWrapText) {
				return false;
			}

			wordWrapRightPosition = this.getWordWrapRightPosition(wordWrapRightPosition);
			if(!wordWrapRightPosition) {
				return false;
			}
			rootLeftPosition = this.getRootLeftPosition(rootLeftPosition);

			var deleteManualPosition = false;
			if(!this.manualLastWordWrapRightPosition) {
				this.manualLastWordWrapRightPosition = {};
				deleteManualPosition = true;
			}

			var lineCount = this.getLineCount();
			var hasChanges = false;
			for(var lineNumber = 0; lineNumber < (lineCount - 1); lineNumber++) {
				var currentLine = this.getLine(lineNumber);
				var currentLineText = this.getLineText(currentLine);
				// Ignore empty lines
				if(currentLineText.replace(/\s/ig, '').length === 0) {
					continue;
				}

				var nextLine = this.getLine(lineNumber + 1);
				var nextLineText = this.getLineText(nextLine);
				if(nextLineText.replace(/\s/ig, '').length === 0) {
					continue;
				}

				var mergeParts = this.getPartsWeCanMergeOnNextLine(currentLine, nextLine, lineNumber, wordWrapRightPosition, rootLeftPosition);
				if(mergeParts.length) {
					var lineDeleted = false;
					this.appendPartsToLine(currentLine, mergeParts);
					if(this.removePartsFromLine(nextLine, mergeParts)) {
						lineDeleted = true;
					}
					this.removeStartingWhitespaceFromLine(nextLine);

					// Should only need to update current line if we are going to look at it again
					if(lineDeleted) {
						var textNode = this.getText(lineNumber + 1);
						this.svgEditor.removeChild(textNode);
						
						this.updateLineRender(currentLine);
					} else {
						this.updateLineRender(nextLine, true);
					}

					hasChanges = true;
					// If we are shrinking lines to put text on previous line, maintain whether or not this line should be able to have text added to it
					if(this.lastWordWrapRightPosition) {
						var nextText = this.getText(lineNumber + 1);
						if(nextText) {
							var manualRightPosition = nextText.cachedBoundingClientRect.width;
							if(manualRightPosition < this.lastWordWrapRightPosition) {
								this.manualLastWordWrapRightPosition[lineNumber + 1] = manualRightPosition;
							}
						}
					}

					if(lineDeleted) {
						lineCount--;
						lineNumber--;
					}
				}
			}

			if(hasChanges) {
				this.updateLines();
			}

			if(deleteManualPosition) {
				delete this.manualLastWordWrapRightPosition;
			}

			return hasChanges;
		},
		getPartsWeCanMergeOnNextLine: function(currentLine, nextLine, lineNumber, wordWrapRightPosition, rootLeftPosition) {
			var currentLineText = this.getLineText(currentLine);
			var currentText = this.getText(lineNumber);
			var currentTspan = $(currentText).find('tspan').last()[0];
			var startTextContents = currentTspan.textContent;

			var mergeParts = [];
			var whiteSpaceRegex = /\s/;
			var firstPart = true;
			try {
				this.iterateLineParts(nextLine, function(part) {
					var partText = part.text;

					var manualBreak = false;
					var lastSpaceIndex = 0;
					var spaceIndex = -1;
					var startSkipIndexes = 1;
					do {
						var skipIndexes = 1;
						while((lastSpaceIndex + skipIndexes) < partText.length && whiteSpaceRegex.test(partText.charAt(lastSpaceIndex + skipIndexes))) {
							skipIndexes++;
						}

						// If we have a bunch of prefix spaces, user is trying to manually position things on their own line so don't unwrap
						if(firstPart) {
							startSkipIndexes = skipIndexes;
							firstPart = false;

							if(startSkipIndexes > 2) {
								return false;
							}
						}

						spaceIndex = partText.substr(lastSpaceIndex + skipIndexes).search(whiteSpaceRegex);
						if(spaceIndex == -1) {
							spaceIndex = partText.length;
						} else {
							spaceIndex += lastSpaceIndex + 1;
						}
						var word = partText.substring(lastSpaceIndex, spaceIndex);
						if(!whiteSpaceRegex.test(word.charAt(0))) {
							word = ' ' + word;
						}

						currentTspan.textContent += word.replace(/ /ig, String.fromCharCode(160));
						var breakCharacter = this.getWordWrapBreakCharacter(wordWrapRightPosition, rootLeftPosition, currentText, lineNumber);
						if(breakCharacter < (currentLineText.length + word.length)) {
							manualBreak = true;
							break;
						}

						// check that this is actually set
						if(this.lastWordWrapRightPosition) {
							var lastWordWrapRightPosition = this.lastWordWrapRightPosition;
							if(this.manualLastWordWrapRightPosition[lineNumber]) {
								lastWordWrapRightPosition = Math.min(this.manualLastWordWrapRightPosition[lineNumber], lastWordWrapRightPosition);
							}

							var currentBreakCharacter = this.getWordWrapBreakCharacter(lastWordWrapRightPosition, rootLeftPosition, currentText, lineNumber);
							if(currentBreakCharacter == breakCharacter) {
								manualBreak = true;
								break;
							}
						}

						lastSpaceIndex = spaceIndex + 1;
						while(lastSpaceIndex < (partText.length - 1) && whiteSpaceRegex.test(partText.charAt(lastSpaceIndex))) {
							lastSpaceIndex++;
						}
						currentLineText += word;
					} while(spaceIndex != -1 && lastSpaceIndex < partText.length);

					if(lastSpaceIndex > 0) {
						if(lastSpaceIndex >= (partText.length - 1)) {
							if(startSkipIndexes == 1) {
								part.text = ' ' + part.text;
							}

							mergeParts.push(part);
						} else {
							var newPart = this.splitSelectionIntoParts(nextLine, part, 0, lastSpaceIndex);

							if(startSkipIndexes == 1) {
								newPart.text = ' ' + newPart.text.substr(0, newPart.text.length - 1);
							} else {
								newPart.text = newPart.text.substr(0, newPart.text.length - 1);
							}
							mergeParts.push(newPart);
						}
					}

					// Make sure we don't keep trying parts further in
					if(manualBreak) {
						return false;
					}
				});
			} finally {
				currentTspan.textContent = startTextContents;
			}

			return mergeParts;
		},
		getFirstWordWidthFromTextNode: function(textNode) {
			var firstTspan = textNode.childNodes[0];
			var startTextContents = firstTspan.textContent;
			try {
				var whiteSpaceRegex = /\s/;
				var firstSpaceIndex = startTextContents.search(whiteSpaceRegex);
				if(firstSpaceIndex !== -1) {
					firstTspan.textContent = startTextContents.substr(0, firstSpaceIndex);
				}

				return firstTspan.getBoundingClientRect().width;
			} finally {
				firstTspan.textContent = startTextContents;
			}
		},
		removeTextFromLine: function(line, text) {
			line.text = line.text.replace(text, '');

			var lineText = this.getLineText(line);
			if(lineText.length === 0) {
				var lineNumber = this.getLineIndexForPart(line);
				this.removeLine(lineNumber);
			}
		},
		removePartsFromLine: function(line, parts) {
			if((parts.length == 1 && parts[0] == line) || (line.parts && line.parts.length == parts.length)) {
				// Remove the line
				var lineNumber = this.getLineIndexForPart(line);
				this.removeLine(lineNumber);

				return true;
			} else {
				parts.forEach(function(part) {
					line.parts.removeItem(part);
				});

				return false;
			}
		},
		removeStartingWhitespaceFromLine: function(line) {
			if(!line.parts || !line.parts.length) {
				return;
			}

			line.parts[0].text = line.parts[0].text.replace(/^\s+/g, '');
		},

		getTextFromSelection: function() {
			var lineIndex = this.selectionLine;
			var startPosition = this.selectionPosition;
			var remainingCharacters = this.selectionLength;
			let text = '';
			var lineCount = this.getLineCount();
			while(remainingCharacters > 0 && lineIndex < lineCount) {
				if(text) {
					text += '\r\n';
				}

				var currentLine = this.getLine(lineIndex);
				var lineText = this.getLineText(currentLine);
				if(startPosition) {
					lineText = lineText.substr(startPosition);
				}
				if(lineText.length <= remainingCharacters) {
					text += lineText;
					remainingCharacters -= lineText.length;
				} else {
					text += lineText.substr(0, remainingCharacters);
					remainingCharacters = 0;
				}

				lineIndex++;
				startPosition = 0;
			}

			return text;
		},
		updateLines: function() {
			this.refreshInstance(true);
			this.changeInstanceProperty('lines', this.instance.lines);
		},
		getSelectionLine: function(scope) {
			if(!scope) {
				scope = this;
			}

			// Fix for selectionLine == invalid line
			if($.isArray(this.instance.lines)) {
				while(this.instance.lines.length <= scope.selectionLine) {
					scope.selectionLine--;
				}
			} else {
				scope.selectionLine = 0;
			}

			return Math.max(scope.selectionLine, 0);
		},
		getCurrentLine: function() {
			return this.getLine(this.getSelectionLine());
		},
		getLine: function(index) {
			var lines = this.instance.lines;

			var line;
			if($.isArray(lines)) {
				if(index >= lines.length) {
					return null;
				}

				line = lines[index];

				if(typeof line == 'string') {
					line = lines[index] = {
						text: line
					};
				}
			} else if(index === 0) {
				line = lines;

				if(typeof line == 'string') {
					line = this.instance.lines = {
						text: line
					};
				}
			} else {
				return null;
			}

			if(line.parts && $.isInit(line.text)) {
				delete line.text;
			}

			return line;
		},
		getLineForPart: function(part) {
			return this.getLine(this.getLineIndexForPart(part));
		},
		getLineIndexForPart: function(part) {
			for(let i = 0; i < this.instance.lines.length; i++) {
				let line = this.instance.lines[i];
				if(line == part || (line.parts && line.parts.indexOf(part) != -1)) {
					return i;
				}
			}

			return -1;
		},
		getLineCount: function() {
			if($.isArray(this.instance.lines)) {
				return this.instance.lines.length;
			} else {
				return 1;
			}
		},
		getInstanceText: function(instance, options) {
			if(!instance) {
				instance = this.instance;
			}
			options = $.extend({
				lineBreak: '',
				requireMinSpace: false
			}, options);

			var str = '';
			if($.isArray(instance.lines)) {
				str = instance.lines.map(function(line) {
					var lineStr = me.getLineText(line);

					if(!lineStr && options.requireMinSpace) {
						lineStr = ' ';
					}

					return lineStr;
				}).join(options.lineBreak);
			} else if($.isPlainObject(instance.lines)) {
				str = this.getLineText(instance.lines);
			} else {
				str = instance.lines;
			}

			return str || '';
		},
		getCurrentLineText: function() {
			return this.getLineText(this.getCurrentLine());
		},
		getLineText: function(line) {
			if(!$.isInit(line)) {
				return '';
			} else if(typeof line == 'string') {
				return line;
			} else if(line.parts) {
				var str = '';
				for(let i = 0; i < line.parts.length; i++) {
					str += line.parts[i].text;
				}

				return str;
			} else if($.isInit(line.text)) {
				return line.text;
			} else {
				return '';
			}
		},
		getInstanceLength: function(options) {
			return this.getInstanceText(undefined, options).length;
		},
		getCurrentLineLength: function() {
			return this.getLineLength(this.getCurrentLine());
		},
		getLineLength: function(line) {
			return this.getLineText(line).length;
		},
		getSelectionsText: function(selections) {
			if(!$.isArray(selections)) {
				selections = [selections];
			}

			let text = '';
			for(let i = 0; i < selections.length; i++) {
				text += this.getLineText(selections[i]);
			}

			return text;
		},
		getSelectionsLength: function(selections) {
			return this.getSelectionsText(selections).length;
		},
		iterateInstanceLines: function(callback) {
			var lines = this.getInstanceLines();
			for(let i = 0; i < lines.length; i++) {
				if(callback.call(this, lines[i], i) === false) {
					return false;
				}
			}

			return true;
		},
		getInstanceLines: function() {
			if($.isArray(this.instance.lines)) {
				var lines = [];
				for (let i = 0; i < this.instance.lines.length; i++) {
					lines.push(this.getLine(i));
				}

				return lines;
			} else {
				// Otherwise return the instance part
				return [this.getLine(0)];
			}
		},
		iterateInstanceParts: function(callback) {
			return this.iterateParts(this.getInstanceParts(), callback);
		},
		iterateLineParts: function(line, callback) {
			return this.iterateParts(this.getLineParts(line), callback);
		},
		iterateParts: function(parts, callback) {
			for(let i = 0; i < parts.length; i++) {
				if(callback.call(this, parts[i]) === false) {
					return false;
				}
			}

			return true;
		},
		getInstanceParts: function() {
			return $.FlowLayoutSVGUtils.getInstanceParts(this.instance);
		},
		getLineParts: function(line) {
			return $.FlowLayoutSVGUtils.getLineParts(line);
		},
		sanitizeLine: function(line) {
			// Implicit line fixing
			this.getLineParts(line);
		},
		sanitizeLinePart: function(part) {
			return $.FlowLayoutSVGUtils.sanitizeLinePart(part);
		},
		sanitizeEmojiText: function(text) {
			return $.FlowLayoutSVGUtils.sanitizeEmojiText(text);
		},
		getCurrentSelection: function(options) {
			if(!options) {
				options = {};
			}

			// Handle negative lengths here as well in case bug in mouseup
			var selectionPosition = this.selectionPosition;
			var selectionLength = this.selectionLength;
			if(this.selectionLength < 0) {
				selectionLength = -selectionLength;
				selectionPosition = Math.max(0, selectionPosition - selectionLength);

				if(options.createPart) {
					this.selectionLength = selectionLength;
					this.selectionPosition = selectionPosition;
				}
			}

			this.selectionPartPosition = selectionPosition;
			if(options.criteria == 'instance') {
				return this.sanitizeSelection(this.instance);
			} else if(options.criteria == 'line') {
				let selection = this.sanitizeSelection(this.getCurrentLine());
				if(selectionLength) {
					var remainingLength = selectionLength - this.getLineLength(selection) + selectionPosition;
					selection = [selection];
					for(let i = Math.max(this.selectionLine, 0) + 1; i < this.getLineCount() && remainingLength > 0; i++) {
						let line = this.getLine(i);
						let lineLength = this.getLineLength(line);

						remainingLength -= lineLength;
						selection.push(line);
					}
				}

				if (options.createPart) {
					if(!options.singleSelection && !selectionLength) {
						selection = this.getSimilarSiblingParts(selection, selection, {
							criteria: 'line'
						});
					}
				}

				return selection;
			} else {
				try {
					let line = this.getCurrentLine();
					let selection = line;
					if (line.parts) {
						// Try to get what specific part is selected
						if(line.parts.length) {
							var character = 0;

							var parts = this.getLineParts(line);
							for (let i = 0; i < parts.length; i++) {
								var part = parts[i];
								if($.isInit(part.text)) {
									var charactersToPart = character + part.text.length;
									if (selectionPosition < charactersToPart || (selectionPosition == charactersToPart && (options.preferStartPart || i == (parts.length - 1)))) {
										this.selectionPartPosition -= character;
										selection = part;
										break;
									}
									character += part.text.length;
								}
							}

							if(selection === line) {
								selection = parts[0];
							}
						} else {
							// This is an invalid state, but should still handle in case in happens again
							selection = {
								text: ''
							};
							line.parts.push(selection);
						}
					}

					if (options.createPart) {
						if (selectionLength) {
							selection = this.splitSelectionIntoParts(line, selection, this.selectionPartPosition, selectionLength);
						} else if(!options.singleSelection) {
							selection = this.getSimilarSiblingParts(line, selection);
						}
					}

					return this.sanitizeSelection(selection);
				} catch(e) {
					this.fireErrorReport('getCurrentSelection', 'Error in getCurrentSelection', e);
				}
			}
		},
		getCurrentSelectionTextLiteral: function(options) {
			let selection = this.getCurrentSelection(options);

			if($.isPlainObject(selection)) {
				return selection.text;
			} else if($.isArray(selection)) {
				return selection.reduce(function(str, selection) {
					return str + selection.text;
				}, '');
			} else {
				return '';
			}
		},
		sanitizeSelection: function(selection) {
			if($.isPlainObject(selection)) {
				if(!$.isInit(selection.text) && !selection.parts) {
					selection.text = '';
				}
			}

			return selection;
		},
		splitLineToParts: function(line) {
			return this.splitSelectionIntoParts(line, line, 0, this.getLineLength(line));
		},
		splitSelectionIntoParts: function(line, selection, position, length) {
			if(typeof length == 'undefined') {
				length = selection.text.length - position;
			}

			// Create a new part representing what was selected
			var prefixPart = $.extend(true, {}, selection);
			let selectedPart = $.extend(true, {}, selection);
			var suffixPart = $.extend(true, {}, selection);

			prefixPart.text = prefixPart.text.substr(0, position);
			selectedPart.text = selectedPart.text.substr(position, length);
			suffixPart.text = suffixPart.text.substr(position + length);

			var remainingCharacters;
			if(selection == line) {
				// Remove all of the style information stored on the line
				for (let i in selection) {
					delete selection[i];
				}
				selection.parts = [];
				if (prefixPart.text.length) {
					selection.parts.push(prefixPart);
				}
				selection.parts.push(selectedPart);
				if (suffixPart.text.length) {
					selection.parts.push(suffixPart);
				}

				if(selectedPart.align) {
					line.align = selectedPart.align;
					delete prefixPart.align;
					delete selectedPart.align;
					delete suffixPart.align;
				}

				remainingCharacters = length - selectedPart.text.length;
			} else {
				// Insert parts around existing part
				var selectionIndex = line.parts.indexOf(selection);
				if (prefixPart.text.length) {
					line.parts.splice(selectionIndex, 0, prefixPart);
					selectionIndex++;
				}
				line.parts[selectionIndex] = selectedPart;
				if (suffixPart.text.length) {
					line.parts.splice(selectionIndex + 1, 0, suffixPart);
				}

				remainingCharacters = length - selectedPart.text.length;
				if(remainingCharacters) {
					var selections = [selectedPart];
					selectionIndex++;
					while (remainingCharacters && selectionIndex < line.parts.length) {
						var extraPart = line.parts[selectionIndex];
						if(extraPart.text.length > remainingCharacters) {
							extraPart = this.splitSelectionIntoParts(line, extraPart, 0, remainingCharacters);
						}

						selections.push(extraPart);
						remainingCharacters -= extraPart.text.length;
						selectionIndex++;
					}

					selectedPart = selections;
				}
			}

			if(remainingCharacters > 0 && $.isArray(this.instance.lines)) {
				// Recursively add next lines selection
				var lineIndex = this.instance.lines.indexOf(line) + 1;
				if(lineIndex < this.instance.lines.length) {
					selectedPart = $.returnArray(selectedPart);

					var nextLine = this.getLine(lineIndex);
					let nextSelection;
					if (nextLine.parts) {
						nextSelection = nextLine.parts[0];
					} else {
						nextSelection = nextLine;
					}

					nextSelection = this.splitSelectionIntoParts(nextLine, nextSelection, 0, remainingCharacters);
					if ($.isArray(nextSelection)) {
						$.merge(selectedPart, nextSelection);
					} else {
						selectedPart.push(nextSelection);
					}
				}
			}

			if($.isArray(selectedPart) && selectedPart.length == 1) {
				selectedPart = selectedPart[0];
			}
			return selectedPart;
		},
		getSimilarSiblingParts: function(line, selection, options) {
			if(!options) {
				options = {};
			}

			if(this.instance.lines == selection || this.instance.lines == line) {
				return selection;
			}
			var selections = [selection];

			// Check within this line
			try {
				var lookForward = true;
				var lookBack = true;
				if (line.parts && line != selection) {
					var partIndex = line.parts.indexOf(selection);
					if (partIndex > 0) {
						lookBack = false;
					}
					if (partIndex < (line.parts.length - 1)) {
						lookForward = false;
					}
				}

				var startLineIndex = this.instance.lines.indexOf(line);
				// check next lines
				if (lookForward) {
					for (let i = startLineIndex + 1; i < this.instance.lines.length; i++) {
						var nextLine = this.getLine(i);

						let similarPart = this.getSimilarSiblingPart(selection, nextLine, options);
						if(similarPart) {
							selections.push(similarPart);
						} else {
							break;
						}
					}
				}

				// check previous lines
				if (lookBack) {
					for (let i = startLineIndex - 1; i >= 0; i--) {
						var prevLine = this.getLine(i);

						let similarPart = this.getSimilarSiblingPart(selection, prevLine, options);
						if(similarPart) {
							selections.push(similarPart);
						} else {
							break;
						}
					}
				}
			} catch(e) {
				this.fireErrorReport('getSimilarSiblingParts', 'Error in getSimilarSiblingParts', e, {
					line: line,
					selection: selection
				});
			}

			return selections.length > 1 ? selections : selection;
		},
		getSimilarSiblingPart: function(selection, siblingPart, options) {
			var matchExclusions = ['text'];

			var nextSelection;
			if (siblingPart.parts && options.criteria != 'line') {
				nextSelection = siblingPart.parts[0];
			} else {
				nextSelection = siblingPart;
			}

			if(options.criteria == 'line') {
				if(this.checkIfLinesSimilar(selection, nextSelection)) {
					return nextSelection;
				} else {
					return false;
				}
			} else if (this.checkIfPartsSimilar(selection, nextSelection, matchExclusions)) {
				return nextSelection;
			} else {
				return false;
			}
		},
		checkIfLinesSimilar: function(matchLine, line) {
			if($.isPlainObject(line) || $.isPlainObject(matchLine)) {
				for(let i = 0; i < this.lineSpecificStyles.length; i++) {
					var style = this.lineSpecificStyles[i];
					if(line[style] !== matchLine[style]) {
						return false;
					}
				}

				return true;
			} else {
				return true;
			}
		},
		checkIfPartsSimilar: function(matchSelection, selection, matchExclusions) {
			if($.isPlainObject(selection) || $.isPlainObject(matchSelection)) {
				if($.objectEquals(selection, matchSelection, matchExclusions, true)) {
					return true;
				}
			} else {
				return true;
			}
		},
		// Selection can be either a line or a part
		addStyleToSelection: function(selections, name, value) {
			try {
				if (!$.isArray(selections)) {
					selections = [selections];
				}

				var selectionName = name;
				if (['bold', 'italic', 'underline'].indexOf(name) != -1) {
					selectionName = this.getCSSFromStyle(name);
				}

				if (value == 'toggle') {
					if (selections[0][selectionName]) {
						value = false;
					} else {
						value = true;
					}
				}

				if (['bold', 'italic', 'underline'].indexOf(name) != -1) {
					value = value ? name : '';
				}

				for (let i = 0; i < selections.length; i++) {
					let selection = selections[i];
					if (value) {
						selection[selectionName] = value;

						if(selectionName === 'fontFamily') {
							var titleCaseFont = $.FlowLayoutSVGUtils.getTitleCaseFont(value);
							if($.GlobalGoogleFontList.indexOf(titleCaseFont) === -1) {
								// The studio font lists should have been added to the $.GoogleFontList.  This is to stop invalid font selections being added as a customFont
								if($.GoogleFontList.includes(titleCaseFont)) {
									selection.customFont = titleCaseFont;
								} else {
									let matchingLowerCaseFont = $.GoogleFontList.map(font => font.toLowerCase()).includes(value.toLowerCase());
									if(matchingLowerCaseFont) {
										$.fireErrorReport(null, 'title case of font is incorrect', 'A font needs to have its title case manually added to $.GoogleFontSpecialTitleCaseMap', {
											titleCaseFont: titleCaseFont
										});
									}
								}
							} else if(selection.customFont) {
								selection.customFont = false;
							}
						}
					} else {
						delete selection[selectionName];
					}

					if (this.onChangeSelectedText) {
						this.onChangeSelectedText(selection, selectionName, value);
					}
				}
				if(this.onChangeMultipleSelections) {
					this.onChangeMultipleSelections(selections, selectionName, value);
				}

				let line = this.getCurrentLine();
				if (line.parts) {
					line.parts = this.mergeIdenticalPartsTogether(line.parts);
				}

				// If we get rendered width after re-wrapping text, even increasing font size can trigger it due to wrapping causing shorter lines
				var startRenderedWidth = this.renderedWidth;
				this.updateLines();
				var endRenderedWidth = this.renderedWidth;
				this.recalculateWordWrapText(selections, false, true);
				// Only reverse wrap if we take up less space then before (ie: shrinking font-size)
				if(startRenderedWidth > endRenderedWidth) {
					// Add a lastWordWrapPosition so we can get it only reverse the wraps that were up against the edge before
					var startLastWordWrapRightPosition = this.lastWordWrapRightPosition;
					var wordWrapRightPosition = this.lastWordWrapRightPosition || this.getWordWrapRightPosition();
					this.lastWordWrapRightPosition = wordWrapRightPosition - (startRenderedWidth - endRenderedWidth);
					try {
						this.recalculateReverseWordWrap();
					} finally {
						this.lastWordWrapRightPosition = startLastWordWrapRightPosition;
					}
				}

				if(selections[0] == this.instance) {
					this.changeInstanceProperty(name, value);
				} else {
					this.changeInstanceProperty('lines', this.instance.lines);
				}

				if(this.getSelectionsLength(selections) == this.getInstanceLength()) {
					this.addStyleToSecondary(selectionName, value);
				}
			} catch(e) {
				this.fireErrorReport('addStyleToSelection', 'Error in adding style to selections', e, {
					selections: selections,
					name: name,
					value: value
				});
			}
		},
		addStyleToSecondary: function(name, value) {
			this.secondaryFocusedElements.forEach(function(elem) {
				if(elem.addStyleToEntireInstance) {
					elem.addStyleToEntireInstance(name, value, true, true);
				}
			});
		},
		addStyleToSubSelections: function(selections, name, subName, value) {
			var exampleSelection = selections;
			if($.isArray(selections)) {
				exampleSelection = selections.filter(function(selection) {
					return !!selection[name];
				})[0];
			}
			// Legacy issue of drop shadow being put on parts when it should have been per line
			if(!exampleSelection[name] && exampleSelection.parts && name === 'drop-shadow') {
				exampleSelection = exampleSelection.parts.filter(part => !!part[name]).slice(-1)[0] || exampleSelection;
			}

			exampleSelection[name][subName] = value;
			me.addStyleToSelection(selections, name, exampleSelection[name]);
		},
		addStyleToEntireInstance: function(name, value, render, save) {
			var iterator = 'iterateInstanceParts';
			if(['align', 'drop-shadow'].includes(name)) {
				iterator = 'iterateInstanceLines';
			}
			this[iterator](function(part) {
				if(!part.overrideStyles || !part.overrideStyles.includes(name)) {
					part[name] = value;
				}
			});
			this.mergeIdenticalPartsTogetherInInstance();

			if(render !== false) {
				if(name == 'color') {
					$(this).find('tspan').css('fill', value);
				} else if(name == 'background-color' && $(this).find('rect').length) {
					if(value) {
						$(this).find('rect').attr('fill', value);
					} else {
						$(this).find('rect').remove();
					}
				} else {
					this.refreshInstance();
				}
			}

			if(save) {
				this.changeInstanceProperty('lines', this.instance.lines);
			}
		},
		mergeIdenticalPartsTogetherInInstance: function() {
			this.iterateInstanceLines(function(line) {
				if(line.parts) {
					line.parts = me.mergeIdenticalPartsTogether(line.parts);
				}
			});
		},
		mergeIdenticalPartsTogether: function(parts) {
			if(!parts.length) {
				return [];
			}

			var mergedParts = [parts[0]];
			var lastPart = parts[0];
			for(let i = 1; i < parts.length; i++) {
				var nextPart = parts[i];

				if($(lastPart).objectEquals(nextPart, 'text', true)) {
					lastPart.text += nextPart.text;
				} else if(nextPart.text) {
					mergedParts.push(nextPart);
					lastPart = nextPart;
				}
			}

			return mergedParts;
		},
		getStyleFromCSS: function(css) {
			if(!this.cssStyleMappings) {
				var map = {};
				for(var style in this.styleCSSMappings) {
					map[this.styleCSSMappings[style]] = style;
				}

				this.cssStyleMappings = map;
			}

			return this.cssStyleMappings[style];
		},
		getCSSFromStyle: function(style) {
			return this.styleCSSMappings[style];
		},
		handleContentEditableInputEvent: function(e) {
			/* Some orders I found in testing:
			
			Chrome desktop:
				First emoji: insertCompositionText isComposing true, insertText isComposing: false
				Second emoji: insertCompositionText isComposing true twice, compositonend

			Chrome Phone:
				Typing: insertCompositionText isComposing true twice, compositionend twice
			*/

			if(e.type === 'compositionend') {
				// From android phone this appears to trigger twice in a row
				if(this.lastInsertTextData === e.data && this.lastInsertTextTimestamp && Math.abs(this.lastInsertTextTimestamp - e.timeStamp) < 200) {
					return false;
				}
				this.onUserTypes(e);
				this.focusHiddenInput();

				
				this.lastInsertTextEvent = e.inputType;
				this.lastInsertTextData = e.data;
				this.lastInsertTextTimestamp = e.timeStamp;
				return false;
			} else if(e.inputType === 'insertFromPaste') {
				// Handled by paste event
				this.focusHiddenInput();
				return;
			} else if(e.inputType === 'historyUndo') {
				if($.userEvents) {
					$.userEvents.undoLastEvent();
				}

				// Refresh again after just in case last even didn't have anything to do with this text box
				this.refreshInstance(true);
				return false;
			} else if(e.inputType === 'historyRedo') {
				if($.userEvents) {
					$.userEvents.redoLastEvent();
				}
				
				this.refreshInstance(true);
				this.focusHiddenInput();
				return false;
			} else if(['insertText', 'insertCompositionText'].indexOf(e.inputType) !== -1) {
				// Windows Emoji toolbar appears to call insertText and then insertCompositionText immediately after each other
				if(this.lastInsertTextData === e.data && this.lastInsertTextTimestamp && Math.abs(this.lastInsertTextTimestamp - e.timeStamp) < 200) {
					return false;
				} else if(e.isComposing) {
					return;
				}

				this.onUserTypes(e);
				this.focusHiddenInput();

				this.lastInsertTextEvent = e.inputType;
				this.lastInsertTextData = e.data;
				this.lastInsertTextTimestamp = e.timeStamp;
				return false;
			} else if(e.inputType === 'deleteByCut') {
				this.onUserTypes(e);
				this.focusHiddenInput();
				return false;
			} else if(['insertReplacementText'].indexOf(e.inputType) === -1) {
				// eslint-disable-next-line
				console.warn('ignored inputType: ', e.inputType, e);

				this.refreshInstance(true);
				this.focusHiddenInput();
				return false;
			}

			let line = this.getCurrentLine();
			if(!line.parts) {
				if(line.text) {
					line = {
						parts: [line]
					};

					this.lineSpecificStyles.forEach(function(style) {
						if(line.parts[0][style]) {
							line[style] = line.parts[0][style];
							delete line.parts[0][style];
						}
					});
				} else {
					line = {
						parts: [{
							text: line
						}]
					};
				}
			}
			var lineText = this.getLineText(line);
			var textNode = this.getCurrentSelectionText();
			var replacedText = textNode.textContent.split(String.fromCharCode(160)).join(' ');

			// NOTE: Spell check doesn't work across tspan boundaries, so a subtraction or addition will always be in a single part
			var dmp = new window.diff_match_patch();
			var diffs = dmp.diff_main(lineText, replacedText);

			var parts = this.getLineParts(line);
			var part = parts[0];
			var partIndex = 0;
			var partTextIndex = 0;
			diffs.forEach(function(diff) {
				var diffText = diff[1];
				if(!part) {
					return;
				}

				// Match
				if(diff[0] === 0) {
					var partTextRemaining = part.text.length - partTextIndex;

					while(partIndex < (parts.length - 1) && partTextRemaining < diffText.length) {
						diffText = diffText.substr(partTextRemaining);
						partIndex++;
						part = parts[partIndex];
						partTextIndex = 0;

						partTextRemaining = part.text.length;
					}

					if(part && partTextRemaining >= diffText.length) {
						partTextIndex += diffText.length;

						if(partIndex < (parts.length - 1) && partTextRemaining === diffText.length) {
							partIndex++;
							part = parts[partIndex];
							partTextIndex = 0;
						}
					}
				}
				// Insertion
				else if(diff[0] === 1) {
					part.text = part.text.substr(0, partTextIndex) + diffText + part.text.substr(partTextIndex);
					partTextIndex += diffText.length;
				} else if(diff[0] === -1) {
					part.text = part.text.substr(0, partTextIndex) + part.text.substr(partTextIndex + diffText.length);
				}
			});

			if($.isArray(this.instance.lines)) {
				this.instance.lines[this.selectionLine] = line;
			} else {
				this.instance.lines = [line];
			}
			this.updateLines();
			this.selectionLength = 0;
			this.updateCursorPosition();
			this.focusHiddenInput();
		},
		setFocused: function(focused, userClicked) {
			_setFocused.apply(this, arguments);
			if(this.shouldRefreshOnFocus() && userClicked) {
				this.refreshInstance();
			}

			if(focused) {
				if(this.editable) {
					if(this.editInitialized) {
						if(userClicked) {
							if(this.textEditable) {
								this.selectionPosition = 0;
								this.selectionLength = 0;
								this.selectionLine = 0;
								this.lastSelectCurrentPartAction = null;
							}
						}
					}
				}

				if(this.textEditable && !this.instance.locked && userClicked) {
					this.setCursorEnabled(true);

					// I know at least FF is broken.  I am guessing there is a decent chance IE/Edge is just as bad
					// Chrome started breaking svg content editable without outer wrapper around December 2020
					if($.browser.chrome && this.useOuterWrapper) {
						$(this).attr('contentEditable', true).attr('spellcheck', 'true');
						this.addEventListener('input', this.inputEventHandler = function(e) {
							me.handleContentEditableInputEvent(e);
						});
						this.addEventListener('compositionend', this.compositionEndEventHandler = function(e) {
							me.handleContentEditableInputEvent(e);
						});
					}
				}
			} else {
				if(this.textEditable) {
					this.setCursorEnabled(false);

					$(this).removeAttr('contentEditable').removeAttr('spellcheck');
					if(this.inputEventHandler) {
						this.removeEventListener('input', this.inputEventHandler);
						this.inputEventHandler = null;
					}
				}
			}
		},
		setSelection: function(position, line, length) {
			this.selectionPosition = position;
			this.selectionLine = line;
			this.selectionLength = length;

			this.updateCursorPosition();
		},
		shouldRefreshOnFocus: function() {
			if(this.hasDynamicText() && this.textEditable) {
				return true;
			} else if(this.hasBarcode()) {
				return true;
			}
		},
		hasDynamicText: function(instance) {
			if(!instance) {
				instance = this.instance;
			}

			if(this.getDynamicFields && instance) {
				return $.FlowLayoutSVGUtils.dynamicTextRegex.test(this.getInstanceText(instance));
			} else {
				return false;
			}
		},
		initCursor: function(scope) {
			if(!scope) {
				scope = this;
			}

			if(!scope.cursor) {
				scope.cursor = $('<div class="flowSVGCursor" style="display: none;">');
				if(scope.color) {
					scope.cursor.css('background', scope.color);
				}
				$(this).append(scope.cursor);
			}
		},
		initSelection: function(scope) {
			if(!scope) {
				scope = this;
			}

			var selectionPath = $('<div class="flowSVGSelection">');
			if(scope.color) {
				selectionPath.css('background', scope.color);
			}
			$(this).append(selectionPath);

			scope.selectionPaths = scope.selectionPaths.add(selectionPath);
			return selectionPath;
		},
		clearSelection: function(scope) {
			if(!scope) {
				scope = this;
			}

			scope.selectionPaths.remove();
			scope.selectionPaths = $();
		},
		setCursorEnabled: function(enabled, scope) {
			if(!scope) {
				scope = this;
			}

			scope.cursorEnabled = enabled;
			if(enabled) {
				this.updateCursorPosition(scope);
			} else {
				if(scope.cursorBlinkTimer) {
					window.clearInterval(scope.cursorBlinkTimer);
				}

				if(scope.cursor) {
					if (scope == this) {
						scope.cursor.hide();
					} else {
						scope.cursor.remove();
					}
				}
				this.clearSelection(scope);
			}
		},
		updateCursorPosition: function(scope, options = {}) {
			if(!scope) {
				scope = this;
			}

			if(!scope.cursorEnabled) {
				return;
			} else if(this.style.display == 'none') {
				this.setCursorEnabled(false, scope);
				return;
			}

			this.initCursor(scope);
			if (scope.cursorBlinkTimer) {
				window.clearInterval(scope.cursorBlinkTimer);
			}

			var startTransform = this.style.transform;
			if(startTransform) {
				this.style.transform = '';
			}

			try {
				// Get selected tspan/various coordinates
				var rootRect = this.getBoundingClientRect();
				let svgRect = this.svgEditor.getBoundingClientRect();
				var currentTspan = this.getCurrentSelectionTSpan(scope);
				if(!currentTspan) {
					return;
				}

				var currentText = currentTspan.parentNode;
				var startPosition = Math.max(scope.selectionPartPosition, 0);
				var endPosition = startPosition + scope.selectionLength;
				if (scope.selectionLength < 0) {
					var tmp = startPosition;
					startPosition = endPosition;
					endPosition = tmp;

					// If we selected across a part boundary
					var firstRun = true;
					while((firstRun || (currentText.previousSibling && (!$(currentText.previousSibling).hasClass('clone') || (currentText.previousSibling.previousSibling && currentText.previousSibling.previousSibling.nodeName === 'text')) && currentText.previousSibling.nodeName === 'text')) && startPosition < 0) {
						if(!firstRun) {
							currentText = currentText.previousSibling;
							if($(currentText).hasClass('clone')) {
								currentText = currentText.previousSibling;
							}
							currentTspan = currentText.lastChild;

							if(this.getLineText(currentText.line).length > 0) {
								startPosition += currentTspan.textContent.length;
								endPosition += currentTspan.textContent.length;
							}
						}

						while(currentTspan.previousSibling && startPosition < 0) {
							currentTspan = currentTspan.previousSibling;
							startPosition += currentTspan.textContent.length;
							endPosition += currentTspan.textContent.length;
						}
						firstRun = false;
					}
				}
				startPosition = Math.max(0, startPosition);

				var textRect = currentText.getBoundingClientRect();

				if (!currentTspan.nextSibling && startPosition > currentTspan.textContent.length) {
					scope.selectionPosition -= startPosition - currentTspan.textContent.length;
					startPosition = currentTspan.textContent.length;
				}

				// Get current selection position
				var selectionLeftDiff = (svgRect.left - rootRect.left) - 1;
				var selectionLeft = this.getCharacterRangeLeft(currentTspan, startPosition) + selectionLeftDiff;
				var lineHeight = textRect.height;
				var lineLeadingSpace = lineHeight * (0.33 / 2);
				var lineTop = (textRect.top - rootRect.top) + lineLeadingSpace;
				lineHeight = lineHeight - (currentText.maxFontSize * 0.33);

				this.clearSelection(scope);
				if(scope.selectionLength) {
					// Update selection box
					scope.cursor.hide();

					// Iterate to end tspan if endPosition is in another tspan
					var endText = currentText;
					var endTspan = currentTspan;
					do {
						while (endTspan.nextSibling && endPosition > endTspan.textContent.length) {
							endPosition -= endTspan.textContent.length;
							endTspan = endTspan.nextSibling;
						}

						var endSelectionLeft = this.getCharacterRangeLeft(endTspan, endPosition) + selectionLeftDiff;
						var selectionPath = this.initSelection(scope);
						selectionPath.css({
							left: selectionLeft + 'px',
							top: lineTop + 'px',
							width: (endSelectionLeft - selectionLeft) + 'px',
							height: lineHeight + 'px'
						});

						if(this.getLineText(endText.line).length > 0) {
							endPosition -= endTspan.textContent.length;
						}
						endText = endText.nextSibling;
						if($(endText).hasClass('clone')) {
							endText = endText.nextSibling;
						}

						if(endText) {
							endTspan = endText.childNodes[0];

							textRect = endText.getBoundingClientRect();
							selectionLeft = this.getCharacterRangeLeft(endTspan, 0) + selectionLeftDiff;
							lineHeight = textRect.height;
							lineLeadingSpace = lineHeight * (0.33 / 2);
							lineTop = (textRect.top - rootRect.top) + lineLeadingSpace;
							lineHeight = lineHeight - lineLeadingSpace;
						}
					} while(endText && endPosition > 0);
				} else {
					// Update blinking cursor
					scope.cursor.css({
						left: selectionLeft + 'px',
						top: lineTop + 'px',
						height: lineHeight + 'px'
					}).show();

					// Make sure cursor is visible while moving around
					scope.cursorBlinkTimer = window.setInterval(function () {
						scope.cursor.toggleClass('invisibleCursor');
					}, 600);
				}

				if (this.editToolbar && scope == this) {
					this.updateToolbarDisplay();
				}
			} catch(e) {
				this.fireErrorReport('updateCursorPosition', 'Error in updateCursorPosition', e, {
					html: $(this.svgEditor).html(),
					selection: {
						position: scope.selectionPosition,
						partPosition: scope.selectionPartPosition,
						length: scope.selectionLength,
						line: scope.selectionLine
					}
				});
			} finally {
				if(startTransform) {
					this.style.transform = startTransform;
				}
			}

			if(this.wrapper && scope == this) {
				this.wrapper.updateUserSelection(this.instance.id, this.getAllUserSelections());
			}

			// We explicitly check to not be recursive since sometimes secondary elements aren't marked as secondary properly
			if(!$(this).hasClass('flowLayoutSecondaryFocused') && this.withLinkedElem && options.recursive !== false) {
				this.withLinkedElem(function(layout, otherElem) {
					otherElem.updateCursorPositionToMatch(scope);
					otherElem.updateCursorPosition(undefined, {
						recursive: false
					});
				});
			}
		},
		updateCursorPositionToMatch: function(scope) {
			this.selectionLine = scope.selectionLine;
			this.selectionPosition = scope.selectionPosition;
			this.selectionLength = scope.selectionLength;
		},
		getCharacterRangeLeft: function(tspan, character) {
			try {
				if(isNaN(character)) {
					character = 0;
				}
				var contentLength = tspan.getNumberOfChars();
				// Firefox seems to be always returning 0
				if($.browser.firefox && !contentLength) {
					contentLength = tspan.textContent.length;
				}
				if (character > contentLength || character < 0) {
					character = contentLength;
				}

				var left = 0;
				// For last character, need to temp add a character to see how much space it takes
				if(contentLength === 0) {
					let startText = tspan.textContent;
					tspan.textContent += String.fromCharCode(160);
					// Appears to be a Chrome bug that makes tspan not report this correctly and throw an error even though it has characters
					if(tspan.getNumberOfChars() > 0) {
						let selectionRect = tspan.getStartPositionOfChar(character);
						left = selectionRect.x;
					}

					tspan.textContent = startText;
				} else if (character >= contentLength) {
					left = tspan.getStartPositionOfChar(character - 1).x;

					// text-anchors will screw up this diff calculation
					var startLeft = left;
					var textAnchor = tspan.parentNode.getAttribute('text-anchor');
					if(textAnchor) {
						tspan.parentNode.setAttribute('text-anchor', '');
						startLeft = tspan.getStartPositionOfChar(character - 1).x;
					}

					let startText = tspan.textContent;
					tspan.textContent += String.fromCharCode(160);

					let selectionRect = tspan.getStartPositionOfChar(character);
					var newLeft = selectionRect.x;
					left += newLeft - startLeft;

					// Restore back to starting condition
					tspan.textContent = startText;
					if(textAnchor) {
						tspan.parentNode.setAttribute('text-anchor', textAnchor);
					}
				} else if(character < contentLength) {
					let selectionRect = tspan.getStartPositionOfChar(character);
					left = selectionRect.x;
				}
			} catch(e) {
				this.fireErrorReport('getCharacterRangeLeft', 'Error in getCharacterRangeLeft', e, {
					tspan: tspan.outerHTML,
					character: character,
					contentLength: contentLength
				});
			}

			return left;
		},
		updateSelectionFromEvent: function(event) {
			if(!this.cursorEnabled) {
				return;
			}

			try {
				var isClick = ['click', 'mousedown', 'dblclick', 'contextmenu'].indexOf(event.type) != -1;
				var isNormalClick = isClick;
				if(event.shiftKey) {
					isNormalClick = false;
				}
				if(isNormalClick && event.button === 2 && this.selectionLength > 0) {
					return;
				}
				if(isNormalClick) {
					this.selectionLine = 0;
					this.selectionPosition = 0;
					this.selectionLength = 0;

					if($(this.cursor).hasClass('hasPopup') && $(this.cursor).popup('is visible')) {
						$(this.cursor).popup('hide');
					}
				}

				let svgRect = this.svgEditor.getBoundingClientRect();
				var clientX = event.clientX;
				var clientY = event.clientY;
				var positionX = clientX - svgRect.left;
				
				var rotation = this.getRotation(true);
				if(rotation) {
					var positionY = clientY - svgRect.top;
					var centerX = svgRect.width / 2;
					var centerY = svgRect.height / 2;
					var rotatedCenterX = Math.abs(centerX * Math.cos(-rotation) - centerY * Math.sin(-rotation));

					positionX = ((positionX - centerX) * Math.cos(-rotation) - (positionY - centerY) * Math.sin(-rotation)) + rotatedCenterX;
				}

				var texts = $(this.svgEditor).children('text').not('.clone');
				var lineDetected = false;
				for (let i = 0; i < texts.length; i++) {
					let text = texts[i];
					var textRect = text.getBoundingClientRect();

					// TODO: The || rotation check can be taken out whenever we implement rotating the y position check as well for multiple lines on rotated text boxes
					if(clientY && ((textRect.top < clientY && textRect.bottom > clientY) || (i == texts.length - 1 && !lineDetected))) {
						if(isNormalClick) {
							this.selectionLine = i;
						}

						var character = this.getCharacterFromXPosition(text, positionX, {
							incrementCloseToEdge: 1,
							skipCharacterRotation: true
						});
						if(isNormalClick) {
							this.selectionPosition = Math.max(0, character - 1);
							if (event.detail == 2) {
								this.onDoubleClickPart('dblclick');
							} else if (event.detail == 3) {
								this.onDoubleClickPart('trplclick');			
							} else {
								this.clicksSinceLastDoubleClick++;
							}
						} else if(event.type == 'mousemove' || isClick) {
							this.onMouseMove(i, character);
						}

						lineDetected = true;
					}
				}
			} catch(e) {
				this.fireErrorReport('updateSelectionFromEvent', 'Error in updateSelectionFromEvent', e, {
					event: event
				});
			}

			this.updateCursorPosition();
		},
		onMouseMove: function(textIndex, character) {
			// Want to iterate over several lines
			var length = 0, lineStart = this.selectionPosition;
			this.endingLine = 0;
			for (let j = this.selectionLine; j < textIndex; j++) {
				let lineLength = this.getLineLength(this.getLine(j));
				if (j == this.selectionLine) {
					length += lineLength - this.selectionPosition;
					lineStart = 0;
				} else {
					length += lineLength;
				}
			}
			for (let j = this.selectionLine; j > textIndex; j--) {
				var prevLineLength = this.getLineLength(this.getLine(j-1));
				let lineLength = this.getLineLength(this.getLine(j));

				if (j == this.selectionLine) {
					length -= this.selectionPosition;
					lineStart = 0;
					this.endingLine -= 1;
				} else {
					length -= lineLength;
					this.endingLine -= 1;
				}
			}
			if (this.selectionLine <= textIndex) {
				this.selectionLength = length + Math.max(0, character - 1) - lineStart;
			} else {
				this.selectionLength = -(prevLineLength - (lineStart + length + Math.max(0, character - 1)));
			}
			this.endPositionIndex = Math.max(0, character - 1);
		},
		updateWindowSelection: function() {
			try {
				let selection = window.getSelection();
				selection.removeAllRanges();

				var tspan = this.getCurrentSelectionTSpan();
				// barcode/qr codes don't have a current tspan
				if(!tspan) {
					return;
				}
				var tspanTextNode = tspan.childNodes[0];

				var startPosition = this.selectionPartPosition;
				let startText = tspanTextNode.wholeText;
				var endNode = tspan;
				var endText = endNode.childNodes[0].wholeText;
				var endSelection = this.selectionLength + this.selectionPartPosition;

				if(this.selectionLength) {
					while(endSelection > endText.length) {
						if(endNode.nextSibling) {
							endSelection -= endText.length;

							endNode = endNode.nextSibling;
							endText = endNode.childNodes[0].wholeText;
						} else if(endNode.parentNode.nextSibling) {
							var nextTextNode = endNode.parentNode.nextSibling;
							if($(nextTextNode).hasClass('clone')) {
								nextTextNode = nextTextNode.nextSibling;
								if(!nextTextNode) {
									break;
								}
							}

							if(this.getLineText(endNode.parentNode.line).length > 0) {
								endSelection -= endText.length;
							}

							endNode = nextTextNode.children[0];
							endText = endNode.childNodes[0].wholeText;
						} else {
							break;
						}
					}
				} else {
					// Try to get spelling to trigger every time by selecting a word
					while(startPosition > 0 && !this.isWordBreakCharacter(startText.charAt(startPosition - 1))) {
						startPosition--;
					}
					while(endSelection < startText.length && !this.isWordBreakCharacter(startText.charAt(endSelection))) {
						endSelection++;
					}
				}

				var range = document.createRange();
				range.setStart(tspanTextNode, startPosition);
				range.setEnd(endNode.childNodes[0], endSelection);
				selection.addRange(range);
			} catch(e) {
				// eslint-disable-next-line
				console.error('Failed to update window selection', e);
			}
		},
		getCharacterFromXPosition: function(textNode, x, options) {
			if(!options) {
				options = {};
			}
			var character = 0, lastCharacterLeft;

			var rotation = this.getRotation(true);
			var tspan, j, k;
			try {
				for(j = 0; j < textNode.childNodes.length; j++) {
					tspan = textNode.childNodes[j];
					var textContent = tspan.textContent;
					var textLength = tspan.getNumberOfChars();
					// Firefox seems to be always returning 0
					if($.browser.firefox && !textLength) {
						textLength = tspan.textContent.length;
					}

					for(k = 0; k < textLength; k++) {
						var characterRect = tspan.getStartPositionOfChar(k);
						var characterX = characterRect.x;

						// For whatever reason, getStartPositionOfChar doesn't apply any transforms to the calculation
						if(rotation && !options.skipCharacterRotation) {
							characterX = characterX * Math.cos(rotation) - characterRect.y * Math.sin(rotation);
						}
						
						if(characterX > x) {
							// Check if we are close to the right edge of this next character
							var newCharacter = this.getCharacterFromXPositionCheckLastCharacter(character, lastCharacterLeft, x, characterRect, options);
							// Don't want to end on an Emoji character
							if(newCharacter === character && $.FlowLayoutSVGUtils.isMultiByteCharacter(textContent, k - 1)) {
								newCharacter--;
								while($.FlowLayoutSVGUtils.isMultiByteCharacter(textContent, newCharacter - 2) && textContent.substr(newCharacter - 1).search(window.allEmojiRegex) !== 0 && newCharacter >= 0) {
									newCharacter--;
								}
							}

							character = newCharacter;
							break;
						} else if (k == (textContent.length - 1) && (j == textNode.childNodes.length - 1)) {
							// Check if we are close to the right edge of this next character
							character = this.getCharacterFromXPositionCheckLastCharacter(character, lastCharacterLeft, x, characterRect, options);
						}

						character++;
						lastCharacterLeft = characterX;
					}

					if(textContent.length === 0) {
						character++;
					}
				}
			} catch(e) {
				this.fireErrorReport('getCharacterFromXPosition', 'Error in getCharacterFromXPosition', e, {
					character: character,
					lastCharacterLeft: lastCharacterLeft,
					textNode: textNode ? $(textNode).html() : 'null',
					tspan: tspan ? $(tspan).html() : 'null',
					j: j,
					k: k
				});
			}

			return character;
		},
		getCharacterFromXPositionCheckLastCharacter: function(character, lastCharacterLeft, x, characterRect, options) {
			// Check if we are close to the right edge of this next character
			if(lastCharacterLeft || character > 0) {
				if(options.incrementCloseToEdge) {
					var checkWidth = (characterRect.x - lastCharacterLeft) / 2;
					var checkLeft = characterRect.x - checkWidth;
					if (checkLeft < x) {
						character += options.incrementCloseToEdge;
					}
				} else if(options.incrementPastEdge) {
					character += options.incrementPastEdge;
				}
			}

			return character;
		},
		onDoubleClickPart: function(click) {
			if(click == 'dblclick') {
				this.selectCurrentPart('word');
			} else if(click == 'trplclick') {
				this.selectCurrentPart('line');
			} else if(click == 'quadclick') {
				this.selectCurrentPart('instance');
			} else {
				this.selectCurrentPart('word');
			}
			this.clicksSinceLastDoubleClick = 0;
		},
		selectCurrentPart: function(scope) {
			let line = this.getCurrentLine();
			let selection = this.getCurrentSelection({
				preferStartPart: true
			});

			if(scope == 'word' && !this.isSpaceCharacter(selection.text[this.selectionPartPosition])) {
				// Back track until we find a space or the beginning
				var wordStartIndex;
				for(wordStartIndex = this.selectionPartPosition; wordStartIndex > 0; wordStartIndex--) {
					if(this.isSpaceCharacter(selection.text[wordStartIndex])) {
						wordStartIndex++;
						break;
					}
				}

				var wordEndIndex;
				for(wordEndIndex = this.selectionPartPosition; wordEndIndex < selection.text.length; wordEndIndex++) {
					if(this.isSpaceCharacter(selection.text[wordEndIndex])) {
						break;
					}
				}

				this.selectionPosition -= (this.selectionPartPosition - wordStartIndex);
				this.selectionLength = wordEndIndex - wordStartIndex;

				if(this.selectionLength == selection.length) {
					this.setLastSelectActionToPart(selection, line);
				} else {
					this.lastSelectCurrentPartAction = 'word';
				}
			} else if(scope == 'part' || scope == 'word') {
				this.selectionPosition -= this.selectionPartPosition;
				this.selectionLength = selection.text.length;

				this.setLastSelectActionToPart(selection, line);
			} else if(scope == 'line') {
				this.selectionPosition = 0;
				this.selectionLength = this.getLineLength(line);
				this.setLastSelectionActionToLine(line);
			} else if(scope == 'instance') {
				this.selectionLine = 0;
				this.selectionPosition = 0;
				this.selectionLength = this.getInstanceLength();
				this.lastSelectCurrentPartAction = 'instance';
			}
		},
		setLastSelectActionToPart: function(selection, line) {
			if(selection == line || line.parts.length == 1) {
				this.setLastSelectionActionToLine(line);
			} else {
				this.lastSelectCurrentPartAction = 'part';
			}
		},
		setLastSelectionActionToLine: function(line) {
			if(this.instance.lines == line || this.instance.lines.length == 1) {
				this.lastSelectCurrentPartAction = 'instance';
			} else {
				this.lastSelectCurrentPartAction = 'line';
			}
		},
		isSpaceCharacter: function(char) {
			if(!char) {
				return false;
			}

			return char === ' ' || char.charCodeAt(0) == 160;
		},
		isWordBreakCharacter: function(char) {
			return this.isSpaceCharacter(char) || $.FlowLayoutSVGUtils.isMultiByteCharacter(char) || $.FlowLayoutSVGUtils.punctuationRegex.test(char);
		},
		initEdit: function(startVisible, clickEvent) {
			if(this.editInitialized) {
				return;
			}

			$(this).on('mousedown', function(e) {
				if(this.focused) {
					this.currentlySelectingText = true;
					this.updateSelectionFromEvent(e);

					if(!this.globalMouseupHandler) {
						$('body').on('mouseup', this.globalMouseupHandler = function () {
							if (me.currentlySelectingText) {
								me.currentlySelectingText = false;
								if(me.selectionLength < 0) {
									me.selectionLine = me.selectionLine + me.endingLine;
									me.selectionPosition = me.endPositionIndex;
									me.selectionLength = -me.selectionLength;
								}
								me.lastSelectedText = new Date().getTime();
								me.focusHiddenInput();
							}

							$('body').off('mouseup', me.globalMouseupHandler);
							me.globalMouseupHandler = null;
						});
					}
				}
			}).on('mousemove', function(e) {
				if(this.currentlySelectingText) {
					this.updateSelectionFromEvent(e);
				}
			}).on('contextmenu', function() {
				// So context menu copy text actually works
				this.updateWindowSelection();
			});
			_initEdit.apply(this, arguments);

			if(startVisible) {
				if(clickEvent && this.textEditable) {
					this.updateSelectionFromEvent(clickEvent);
				}
			}
		},
		onInitHiddenInput: function() {
			this.hiddenInput.add(this).on('paste', function(e) {
				if(e.alreadyHandledFromOtherHandler) {
					return false;
				}

				var errorExtras = me.getErrorReportExtras({
					event: e,
					origInstance: JSON.stringify(me.origInstance),
					paste: e.originalEvent.clipboardData ? e.originalEvent.clipboardData.getData('text') : null
				});

				try {
					me.isTyping = true;
					me.onUserTypes(e);
					e.alreadyHandledFromOtherHandler = true;

					return false;
				} catch(error) {
					me.fireErrorReport('Pasting error', 'Error in onUserTypes', error, errorExtras);
					return false;
				} finally {
					me.isTyping = false;
				}
			});
		},
		getPositionProperty: function() {
			if(this.instance.position) {
				return {
					x: this.instance.position.left,
					y: this.instance.position.top
				};
			} else {
				return {
					x: 0,
					y: 0
				};
			}
		},
		setPositionProperty: function(x, y) {
			this.changeInstanceProperty('position', {
				left: x,
				top: y
			});
		},
		onThisClicked: function(e) {
			var currentTime = new Date().getTime();
			if(this.textEditable && (!this.lastSelectedText || currentTime - this.lastSelectedText > 20)) {
				this.updateSelectionFromEvent(e);
			}
		},
		shouldIgnoreFocus: function(e) {
			if(_shouldIgnoreFocus.apply(this, arguments)) {
				return true;
			} else if(!this.instance) {
				return true;
			} else {
				return false;
			}
		},
		getCurrentSize: function() {
			return {
				width: this.renderedDisplayWidth / this.ratio,
				height: this.renderedDisplayHeight / this.ratio
			};
		},
		getSVGWidthOverflow: function() {
			var width = $(this).getFloatStyle('width');
			return Math.max(0, this.renderedWidth - width);
		},
		getSVGHeightOverflow: function() {
			var height = $(this).getFloatStyle('height');
			return Math.max(0, this.renderedHeight - height);
		},
		getEditToolTarget: function() {
			return this.svgEditor;
		},
		getToolByName: function(name) {
			if('styles' == name) {
				return {
					addClass: 'icon',
					group: ['bold', 'italic', 'underline']
				};
			} else if(name == 'align') {
				return {
					addClass: 'icon',
					updateDisplayAll: true,
					group: ['align left', 'align center', 'align right']
				};
			} else if(name == 'align-all') {
				return {
					addClass: 'icon',
					updateDisplayAll: true,
					group: ['align left', 'align center', 'align right', 'align justify']
				};
			} else if(name == 'z-index') {
				return {
					addClass: 'icon',
					group: ['move back', 'move forward']
				};
			} else if(name == 'effects') {
				let effectGroup = ['stroke', 'border', 'drop shadow', 'opacity'];
				var hasGroup = this.instance && this.instance.groupedElements && this.instance.groupedElements.length > 0;
				if(hasGroup) {
					effectGroup.splice(3, 0, this.getGroupBorderButton());
				}

				return {
					addClass: 'icon',
					group: effectGroup
				};
			} else if(name == 'text-colors') {
				return {
					addClass: 'icon',
					group: ['font-color', 'background-color']
				};
			} else if(['bold', 'italic', 'underline'].indexOf(name) != -1) {
				var cssName = this.getCSSFromStyle(name);

				return {
					icon: name,
					popup: name.toTitleCase(),
					isActive: function(selection) {
						return selection ? selection[cssName] : false;
					},
					onClick: function(selection) {
						me.addStyleToSelection(selection, name, 'toggle');
					}
				}
			} else if(['align left', 'align center', 'align right', 'align justify'].indexOf(name) != -1) {
				var prop = name.replace('align ', '');
				var popup = i18n.t('composer.tools.' + name.toCamelCase());

				return {
					icon: name,
					popup: popup,
					selection: 'line',
					isActive: function(selection) {
						if($.isArray(selection)) {
							selection = selection[0];
						}

						if(selection && selection.align) {
							return selection.align == prop ? true : false;
						} else if(name == 'align left') {
							return true;
						}
					},
					onClick: function(selection) {
						me.addStyleToSelection(selection, 'align', prop);
					}
				};
			} else if(name == 'font-family') {
				let dropdown = [];
				$.GoogleFontList.forEach(function(font) {
					dropdown.push({
						text: font,
						css: {
							'font-family': '"' + font + '"'
						}
					});
				});

				if(this.canHaveBarcodes) {
					$.BarcodeFontTypes.forEach(function(type) {
						dropdown.push({
							text: type
						});
					});
				}

				return {
					title: 'Font Family',
					dropdown: dropdown,
					onChange: function(selection, change) {
						me.addStyleToSelection(selection, 'fontFamily', change);

						if(me.isFontBarcode(change) && typeof me.editTools == 'function') {
							me.requireManualSize();

							window.setTimeout(function() {
								me.updateEditTools();
							}, 1);
						}
					},
					updateLabel: function(selection, dropdown, label) {
						var family = selection.fontFamily ? selection.fontFamily : 'open sans';

						if($.GoogleFontList.indexOf($.FlowLayoutSVGUtils.getTitleCaseFont(family)) == -1) {
							if(selection.customFont) {
								label.css('font-family', '"' + family + '"');
								dropdown.dropdown('set text', selection.customFont);
								return;
							} else {
								family = 'open sans';
							}
						}

						label.css('font-family', '"' + family + '"');
						dropdown.setSelectedValue($.FlowLayoutSVGUtils.getTitleCaseFont(family));
					}
				};
			} else if(name == 'barcode-type') {
				var barcodeTypes = [];
				for(let i = 0; i < $.BarcodeFontTypes.length; i++) {
					var font = $.BarcodeFontTypes[i];

					barcodeTypes.push({
						text: font
					});
				}

				$.GoogleFontList.forEach(function(font) {
					barcodeTypes.push({
						text: font,
						css: {
							'font-family': '"' + font + '"'
						}
					});
				});

				return {
					title: 'Barcode Type',
					dropdown: barcodeTypes,
					onChange: function(selection, change) {
						me.addStyleToSelection(selection, 'fontFamily', change);

						if(!me.isFontBarcode(change) && typeof me.editTools == 'function') {
							window.setTimeout(function() {
								me.updateEditTools();
							}, 1);
						}
					},
					updateLabel: function(selection, dropdown, label) {
						var family = selection.fontFamily ? selection.fontFamily : 'Code39';

						if($.BarcodeFontTypes.indexOf($.FlowLayoutSVGUtils.getTitleCaseFont(family)) == -1) {
							family = 'Code39';
						}

						dropdown.setSelectedValue($.FlowLayoutSVGUtils.getTitleCaseFont(family));
					}
				};
			}  else if(name == 'barcode-line-width') {
				let dropdown = [];

				for(let i = 0; i < $.BarcodeWidths.length; i++) {
					let size = $.BarcodeWidths[i];

					dropdown.push({
						text: size
					});
				}

				return {
					title: 'Line Width',
					dropdown: dropdown,
					onChange: function(selection, change) {
						me.addStyleToSelection(selection, 'barWidth', change);
					},
					updateLabel: function(selection, dropdown, label) {
						let size = selection['barWidth'] ? selection['barWidth'] : 2;
						dropdown.setSelectedValue(size);
						label.text('Bar Width: ' + size);
					}
				};
			} else if(name == 'font-size') {
				let dropdown = [];

				var defaultFontSizes;
				if(this.defaultFontSizes) {
					defaultFontSizes = this.defaultFontSizes;
				} else {
					defaultFontSizes = $.DefaultFontSizes;
				}
				for(let i = 0; i < defaultFontSizes.length; i++) {
					let size = defaultFontSizes[i];
					var displaySize = Math.min(44, (size / $.PRODUCTION_RATIO * this.ratio));

					dropdown.push({
						text: size,
						css: {
							'font-size': displaySize + 'pt'
						}
					});
				}

				return {
					title: 'Font Size',
					dropdown: dropdown,
					onChange: function(selection, change) {
						if(change == 'auto') {
							if(!me.instance.manualSize) {
								me.updateProperty('manualSize', me.getCurrentSize());
								me.setupManualSize();
							}

							// Require auto to apply to entire object
							me.addStyleToEntireInstance('font-size', change, true, true);
						} else {
							change = change + 'pt';

							if(me.isAutoSized()) {
								me.addStyleToEntireInstance('font-size', change, true, true);
							} else {
								me.addStyleToSelection(selection, 'font-size', change);
							}
						}
					},
					updateLabel: function(selection, dropdown, label) {
						let size = selection['font-size'] ? selection['font-size'] : (me.defaultFontSize + 'pt');
						var selectedValue = size.replace('pt', '');
						dropdown.setSelectedValue(selectedValue);

						if(selectedValue == 'auto') {
							label.text('Automatic');
						} else {
							label.text(selectedValue + ' pt');
						}
					}
				};
			} else if(name == 'font-color') {
				return {
					icon: 'font',
					popup: window.i18n.t('composer.tools.fontColor'),
					colorPicker: true,
					getCurrentColor: function(selection) {
						return selection.color ? selection.color : 'black';
					},
					onChange: function(selection, color) {
						me.addStyleToSelection(selection, 'color', color);
					},
					updateButtonColor: function (div, color) {
						div.find('i').css('color', color);
					}
				}
			} else if(name == 'background-color') {
				return {
					icon: 'font',
					popup: window.i18n.t('composer.tools.backgroundColor'),
					colorPicker: true,
					allowEmpty: true,
					getCurrentColor: function(selection) {
						return selection['background-color'] ? selection['background-color'] : 'transparent';
					},
					onChange: function(selection, color) {
						me.addStyleToSelection(selection, 'background-color', color);
					},
					updateButtonColor: function (div, color) {
						div.css('background-color', color);
					}
				}
			} else if(name == 'line-height') {
				let dropdown = ['100%', '133%', '150%', '200%', '300%'];

				return {
					title: 'Line Height',
					dropdown: dropdown,
					selection: 'instance',
					onChange: function(selection, change) {
						var lineHeight = parseInt(change.replace('%', '')) / 100;
						me.addStyleToSelection(selection, 'lineHeight', lineHeight);
					},
					updateLabel: function(selection, dropdown, label) {
						var lineHeight = selection['lineHeight'] ? selection['lineHeight'] : 1.33;
						var lineHeightDisplay = (lineHeight * 100) + '%';

						dropdown.setSelectedValue(lineHeightDisplay);
						label.html('<span class="hideOnNarrowScreen">Line Height: </span>' + lineHeightDisplay);
					}
				};
			} else if(['move back', 'move forward'].indexOf(name) != -1) {
				let popupText = 'Move text ' + name.replace('move ', '');
				return {
					icon: 'arrow ' + (name == 'move back' ? 'down' : 'up'),
					popup: popupText,
					onClick: function(selection) {
						if(name == 'move back') {
							this.lowerZIndex();
						} else {
							this.raiseZIndex();
						}
						this.updateToolbarDisplay();
					},
					updateDisplay: function(selection) {
						let checkProperty = (name === 'move back') ? 'behindCells' : 'overlayCells';
						if(me.instance[checkProperty]) {
							this.setActive(true);
							if(name == 'move back') {
								$(this).attr('data-tooltip', popupText + ' (currently behind subject images)');
							} else {
								$(this).attr('data-tooltip', popupText + ' (currently over subject images)');
							}
						} else {
							this.setActive(false);
							$(this).attr('data-tooltip', popupText);
						}
					}
				}
			} else if(name == 'stroke') {
				return {
					icon: 'square outline',
					popup: 'Stroke',
					colorPicker: true,
					settingsPicker: {
						id: 'thickness',
						name: 'thickness',
						description: 'Thickness: %value%',
						type: 'inc/dec',
						range: [1, 6],
						value: 1
					},
					allowEmpty: true,
					getCurrentColor: function(selection) {
						return selection['stroke'] ? selection['stroke'].color : 'transparent';
					},
					onChange: function(selection, color) {
						if(color && color != 'transparent') {
							let changeSelection = selection;
							if($.isArray(changeSelection)) {
								changeSelection = changeSelection.filter(function(selection) {
									return !!selection['stroke'];
								})[0] || changeSelection[0];
							}

							if(changeSelection.stroke) {
								changeSelection.stroke.color = color;
							} else {
								changeSelection.stroke = {
									color: color,
									thickness: 1
								};
							}

							me.addStyleToSelection(selection, 'stroke', changeSelection.stroke);
						} else {
							me.addStyleToSelection(selection, 'stroke', null);
						}
					},
					updateButtonColor: function (div, color) {
						if(color == 'transparent') {
							color = 'black';
							div.removeClass('active');
						} else {
							div.addClass('active');
						}

						div.find('i').css('color', color);
					},
					onChangeSetting: function(selection, name, value) {
						try {
							me.addStyleToSubSelections(selection, 'stroke', name, value);
						} catch(e) {
							me.fireErrorReport('Error updating stroke', 'Error updating stroke', e, {
								passedSelection: selection,
								settingName: name,
								settingValue: value
							});
						}
					},
					updateSettingsPicker: function(settingsPicker, selection, div) {
						if($.isArray(selection)) {
							selection = me.getCurrentSelection({
								createPart: true
							});

							if($.isArray(selection)) {
								selection = selection[0];
							} else {
								div.updateDisplay(selection);
								return;
							}
						}

						
						settingsPicker.find('#settings-thickness')[0].updateDisplayedValue(selection.stroke ? selection.stroke.thickness : 1);
					}
				};
			} else if(name == 'border') {
				return {
					icon: 'circle outline',
					popup: 'Border',
					colorPicker: true,
					selection: 'instance',
					settingsPicker: {
						id: 'thickness',
						name: 'thickness',
						description: 'Thickness: %value%',
						type: 'inc/dec',
						range: [1, 6],
						value: 1
					},
					allowEmpty: true,
					getCurrentColor: function(selection) {
						return selection['border'] ? selection['border'].color : 'transparent';
					},
					onChange: function(selection, color) {
						if(color && color != 'transparent') {
							if (selection.border) {
								selection.border.color = color;
							} else {
								selection.border = {
									color: color,
									thickness: 1
								};
							}

							me.addStyleToSelection(selection, 'border', selection.border);
						} else {
							me.addStyleToSelection(selection, 'border', null);
						}
					},
					updateButtonColor: function (div, color) {
						if(color == 'transparent') {
							color = 'black';
							div.removeClass('active');
						} else {
							div.addClass('active');
						}

						div.find('i').css('color', color);
					},
					onChangeSetting: function(selection, name, value) {
						try {
							me.addStyleToSubSelections(selection, 'border', name, value);
						} catch(e) {
							me.fireErrorReport('Error updating border', 'Error updating border', e, {
								passedSelection: selection,
								settingName: name,
								settingValue: value
							});
						}
					},
					updateSettingsPicker: function(settingsPicker, selection, div) {
						if($.isArray(selection)) {
							selection = me.getCurrentSelection({
								createPart: true
							});

							if($.isArray(selection)) {
								selection = selection[0];
							} else {
								div.updateDisplay(selection);
								return;
							}
						}

						settingsPicker.find('#settings-thickness')[0].updateDisplayedValue(selection.border ? selection.border.thickness : 1);
					}
				};
			} else if(name == 'drop shadow') {
				return {
					icon: 'cube',
					popup: 'Drop Shadow',
					colorPicker: true,
					selection: 'line',
					settingsPicker: [
						{
							id: 'depth',
							name: 'depth',
							description: 'Depth of %value%',
							type: 'inc/dec',
							range: [2, 20],
							value: this.defaultDropShadow.depth
						},
						{
							id: 'intensity',
							name: 'intensity',
							description: 'Intensity of %value%',
							type: 'inc/dec',
							range: [1, 8],
							value: this.defaultDropShadow.intensity
						}
					],
					allowEmpty: true,
					getCurrentColor: function(selection) {
						if(selection && !selection['drop-shadow'] && selection.parts) {
							selection = selection.parts.filter(part => !!part['drop-shadow']).slice(-1)[0] || selection;
						}
						return selection['drop-shadow'] ? selection['drop-shadow'].color : 'transparent';
					},
					onChange: function(selection, color) {
						if(color && color != 'transparent') {
							let changeSelection = selection;
							if($.isArray(changeSelection)) {
								changeSelection = changeSelection.filter(function(selection) {
									return !!selection['drop-shadow'];
								})[0] || changeSelection[0];
							}
							if(changeSelection && !changeSelection['drop-shadow'] && changeSelection.parts) {
								changeSelection = changeSelection.parts.filter(part => !!part['drop-shadow']).slice(-1)[0] || changeSelection;
							}

							if(changeSelection['drop-shadow']) {
								changeSelection['drop-shadow'].color = color;
							} else {
								changeSelection['drop-shadow'] = {
									color: color,
									intensity: me.defaultDropShadow.intensity,
									depth: me.defaultDropShadow.depth
								};
							}

							me.addStyleToSelection(selection, 'drop-shadow', changeSelection['drop-shadow']);
						} else {
							me.addStyleToSelection(selection, 'drop-shadow', null);
						}
					},
					onChangeSetting: function(selection, name, value) {
						try {
							me.addStyleToSubSelections(selection, 'drop-shadow', name, value);
						} catch(e) {
							me.fireErrorReport('Error updating drop-shadow', 'Error updating drop-shadow', e, {
								passedSelection: selection,
								settingName: name,
								settingValue: value
							});
						}
					},
					updateButtonColor: function (div, color) {
						if(color == 'transparent') {
							color = 'black';
							div.removeClass('active');
						} else {
							div.addClass('active');
						}

						div.find('i').css('color', color);
					},
					updateSettingsPicker: function(settingsPicker, selection, div) {
						if($.isArray(selection)) {
							selection = me.getCurrentSelection({
								createPart: false
							});

							if($.isArray(selection)) {
								selection = selection[0];
							} else {
								div.updateDisplay(selection);
								return;
							}
						}

						settingsPicker.find('#settings-depth')[0].updateDisplayedValue(selection['drop-shadow'] ? selection['drop-shadow'].depth : me.defaultDropShadow.depth);
						settingsPicker.find('#settings-intensity')[0].updateDisplayedValue(selection['drop-shadow'] ? selection['drop-shadow'].intensity : me.defaultDropShadow.intensity);
					}
				};
			} else if(name == 'applyToAll') {
				return {
					icon: 'edit',
					popup: 'Apply Styles To Entire Page',
					singleSelection: true,
					onClick: function(selection) {
						var page = this.wrapper.page;
						if(page) {
							page.copyTextStylesToOthers(this.instance.id, selection);
							this.wrapper.refreshTexts();
						}

						return false;
					}
				};
			} else if(name == 'scan subjects') {
				return {
					icon: 'barcode',
					popup: 'Scan Subjects',
					onClick: function(selection) {
						this.scanForSubjects(selection);
					}
				};
			} else if(name == 'remove') {
				return {
					icon: 'remove',
					color: 'red',
					popup: 'Remove text',
					onClick: function(selection, button) {
						this.removeContent();
					}
				};
			} else if(name == 'copy') {
				return this.getCopyContentButton();
			} else if(name == 'padding-multipler') {
				return {
					title: 'Padding',
					dropdown: [
						'1',
						'2',
						'3',
						'4',
						'5',
						'6',
						'7',
						'8',
						'9',
						'10',
						'11',
						'12',
						'13',
						'14',
						'15',
						'16',
						'17',
						'18',
						'19',
						'20'
					],
					onChange: function(selection, change) {
						me.addStyleToSelection(selection, 'paddingMultiplier', parseInt(change));
						if(me.onUpdatePaddingMultiplier) {
							me.onUpdatePaddingMultiplier();
						}
						return false;
					},
					updateLabel: function(selection, dropdown, label) {
						var selectedValue = 2;
						if(selection.paddingMultiplier) {
							selectedValue = parseInt(selection.paddingMultiplier);
						}

						dropdown.setSelectedValue(selectedValue);
						label.text('Padding: ' + selectedValue);
					}
				};
			} else if(name == 'upper case') {
				return {
					icon: 'text height',
					popup: 'Capitalize text',
					isActive: function(selection) {
						return selection ? selection.upperCase : false;
					},
					onClick: function(selection) {
						me.addStyleToSelection(selection, 'upperCase', 'toggle');
					}
				};
			} else if(name === 'opacity') {
				return {
					icon: 'eye',
					popup: 'Opacity',
					settingsPicker: {
						description: '%value%% Opacity',
						type: 'inc/dec',
						range: [5, 100],
						inc: 5,
						value: this.instance.opacity || 100
					},
					onChange: function(selection, change) {
						me.changeInstanceProperty('opacity', change);
						me.applyEffects();
					},
					isActive: function(selection) {
						return $.isInit(me.instance.opacity) && me.instance.opacity != 100;
					}
				};
			} else if(name === 'dynamic text fields') {
				var fields = this.wrapper.getDynamicFields();
				fields.sort();

				return {
					title: 'Dynamic Text Fields',
					dropdown: fields,
					iconButton: 'pencil',
					popup: 'Select dynamic text field to add',
					onChange: function(selection, change) {
						me.onUserTypes({
							key: '%' + change + '%',
							preventDefault: function() {}
						});
					}
				};
			} else {
				return name;
			}
		},
		updateToolbarDisplay: function() {
			if(!this.editToolbar) {
				return;
			}

			var selections = {};
			this.editToolbar.findSelf('.toolbarButton').each(function() {
				if(!selections[this.definition.selection]) {
					selections[this.definition.selection] = me.getCurrentSelection({
						criteria: this.definition.selection
					});
				}
				this.updateDisplay(selections[this.definition.selection]);
			});
			this.updateToolbarTooltipPosition();
		},
		onChangeInstanceProperty: function(names, values) {
			if(!$.isArray(names)) {
				names = [names];
				values = [values];
			}

			// Default behavior is just to update it to be the same
			for(let i = 0; i < names.length; i++) {
				this.origInstance[names[i]] = values[i];
			}
		},
		setRatio: function(ratio) {
			this.ratio = ratio;
		},
		getDominantStyles: function() {
			var existingStyles = this.getExistingStyles();

			var dominantStyles = {};
			for(var style in existingStyles) {
				var values = existingStyles[style];

				var maxCount = 0;
				var maxValue = null;
				for(var value in values) {
					var count = values[value];

					if(count > maxCount) {
						maxCount = count;
						maxValue = value;
					}
				}

				if(maxValue) {
					try {
						maxValue = JSON.parse(maxValue);
					}
					// eslint-disable-next-line
					catch(e) {}

					dominantStyles[style] = maxValue;
				}
			}

			return dominantStyles;
		},
		getExistingStyles: function() {
			var styles = {};
			if($.isArray(this.instance.lines)) {
				for(let i = 0; i < this.instance.lines.length; i++) {
					this.getExistingStyleForLine(this.instance.lines[i], styles);
				}
			} else if($.isPlainObject(this.instance.lines)) {
				this.getExistingStyleForLine(this.instance.lines, styles);
			}

			return styles;
		},
		getExistingStyleForLine: function(line, styles) {
			if(line.parts) {
				for(let j = 0; j < line.parts.length; j++) {
					var part = line.parts[j];
					this.getExistingStyleForPart(part, styles);
				}
			} else if($.isPlainObject(line)) {
				this.getExistingStyleForPart(line, styles);
			}
		},
		getExistingStyleForPart: function(selection, styles) {
			for(var style in selection) {
				if(style != 'text') {
					if(!styles[style]) {
						styles[style] = {};
					}

					var value = selection[style];
					if($.isPlainObject(value)) {
						value = JSON.stringify(value);
					}

					if(styles[style][value]) {
						styles[style][value]++;
					} else {
						styles[style][value] = 1;
					}
				}
			}
		},
		getFocusCursor: function() {
			if(this.editable) {
				return 'text';
			} else {
				return 'default';
			}
		},
		getUserSelection: function() {
			let selection = {
				id: this.instance.id
			};

			if(this.textEditable) {
				$.extend(selection, {
					selectionLine: this.selectionLine,
					selectionPosition: this.selectionPosition,
					selectionLength: this.selectionLength
				});
			}
			return selection;
		},
		setOtherUserFocused: function(user, currentSelection) {
			var oldScope = this.otherUserSelections[user.userId];
			_setOtherUserFocused.apply(this, arguments);

			var cachedCurrentSelection = $.extend(true, {}, currentSelection);
			try {
				if (currentSelection && $.isInit(currentSelection.selectionPosition)) {
					var scope = this.otherUserSelections[user.userId] = $.extend({
						color: this.getSemanticColor(user),
						selectionPaths: $()
					}, this.otherUserSelections[user.userId], currentSelection);

					this.setCursorEnabled(true, scope);
				} else if (oldScope && oldScope.currentSelection && $.isInit(oldScope.currentSelection.selectionPosition)) {
					this.setCursorEnabled(false, oldScope);
				}
			} catch(e) {
				this.fireErrorReport('setOtherUserFocused', 'Error in setOtherUserFocused', e, {
					oldScope: oldScope,
					currentSelection: cachedCurrentSelection
				});
			}
		},
		scanForSubjects: function(selection) {
			var me = this;
			$.SettingsBuilderDialog([
				{
					id: 'subjects',
					type: 'largeText',
					description: 'Scanned subjects'
				}
			], {
				title: 'Scan subjects',
				onSettingsApplied: function(settings) {
					var lines = settings.subjects.split('\n');
					var subjectLines = me.getScannedSubjectsFromLines(lines);
					let text = me.formatScannedSubjects(subjectLines);

					me.addStyleToSelection(selection, 'text', text);
				}
			});
		},
		getScannedSubjectsFromLines: function(lines) {
			var subjectLines = [];
			var subjects = me.wrapper.page.pageSet.getAllSubjects();
			var rowNumber = 1;
			lines.forEach(function(line) {
				if(!line) {
					return;
				} else if(line === '8888' || line === '7777') {
					subjectLines.push('Row ' + rowNumber);
					rowNumber++;
					return;
				}

				var subject;
				for(let i = 0; i < subjects.length; i++) {
					if(subjects[i]['Record Number'] == line || subjects[i]['Student ID'] == line) {
						subject = subjects[i];
						break;
					}
				}

				if(subject) {
					subjectLines.push(subject['First Name'] + ' ' + subject['Last Name']);
				}
			});

			return subjectLines;
		},
		formatScannedSubjects: function(subjectLines) {
			let text = '';

			subjectLines.forEach(function(line, index) {
				line = line.replace(/ /ig, String.fromCharCode(160));

				var next;
				if(subjectLines.length > index) {
					next = subjectLines[index + 1];
				}

				if(line.indexOf('Row' + String.fromCharCode(160)) === 0) {
					text += line + ':' + String.fromCharCode(160);
				} else {
					text += line;

					if(next) {
						// NOTE: This uses regular space instead of nbsp because we haven't done the replace on the next line
						if(next.indexOf('Row ') !== 0) {
							text += ',';
						}

						text += ' ';
					}
				}
			});

			return text;
		},

		requireManualSize: function() {
			if(this.instance.manualSize) {
				return;
			}

			this.saveCurrentSize();
			this.setupManualSize();
		},
		saveCurrentSize: function() {
			var currentWidth = this.svgEditor.getAttribute('width');
			var currentHeight = this.svgEditor.getAttribute('height');

			var inchWidth = currentWidth / this.ratio;
			if(this.wrapper && this.wrapper.inchWidth) {
				var maxWidth = this.wrapper.inchWidth;
				if(this.instance.position) {
					maxWidth -= this.instance.position.left;
				}
				
				inchWidth = Math.min(inchWidth, maxWidth);
			}

			var manualSize = {
				width: inchWidth,
				height: currentHeight / this.ratio
			};
			this.updateProperty('manualSize', manualSize);

			if(this.flushPositionChangeImmediately) {
				this.flushDelayedSaveQueue();
				if(this.linkedOverflowInstance) {
					this.linkedOverflowInstance.elem.flushDelayedSaveQueue();
				}
				this.flushPositionChangeImmediately = false;
			}
		},
		applyEffects: function() {
			var filter = '';
			var outerBorder = '';

			if(this.instance.opacity) {
				filter += 'opacity(' + this.instance.opacity + '%) ';
			}
			if(this.instance.border) {
				var border = this.instance.border;
				var thickness = this.getBorderThickness();

				outerBorder = thickness + 'px solid ' + border.color;
			}

			$(this).css({
				'filter': filter,
				'-webkit-filter': filter
			});

			$(this.outerWrapper).css({
				border: outerBorder
			});
		},
		getBorderThickness: function() {
			var border = this.instance.border;
			if(border) {
				var thickness = border.thickness;
				if(border.sizeScaling) {
					var maxSize = Math.max(this.renderedDisplayWidth, this.renderedDisplayHeight);
					thickness = thickness * maxSize / 80;
				} else {
					thickness = thickness / 60 * this.ratio;
				}

				return thickness;
			} else {
				return 0;
			}
		},

		getContextMenu: function(e) {
			var selectedWords = this.getSelectedWords();
			var misspelledWords = $.FlowLayoutSVGUtils.checkForMisspelledWord(selectedWords.selectedText);
			if(misspelledWords.length) {
				var misspelledWord = misspelledWords[0];
				var spellingSuggestions = $.FlowLayoutSVGUtils.getSpellingSuggestions(misspelledWord);
				var menuItems = spellingSuggestions.slice(0, 5).map(function(suggestion) {
					return {
						text: suggestion,
						onClick: function() {
							me.replaceSelectedWord(selectedWords, misspelledWord, suggestion);
						}
					}
				});

				menuItems.push('divider');
				menuItems.push({
					text: 'Add to dictionary',
					onClick: function() {
						misspelledWord = misspelledWord.toLowerCase();
						$.ajax({
							url: 'ajax/saveDictionaryWord.php',
							data: {
								word: misspelledWord,
								orgId: window.getDictionaryOrgId()
							},
							type: 'POST',
							success: function(data) {
								if($.CustomDictionary) {
									$.CustomDictionary.push(data.word);
								}

								var page = me.wrapper?.getPage();
								if(page?.db?.userEvents) {
									var userEvents = page.db.userEvents;
									userEvents.addEvent({
										context: ['customDictionary'],
										action: 'insert',
										args: [data.word, 0],
										extras: {
											idProp: 'word'
										}
									});
								}
							}
						});
						$.FlowLayoutSVGUtils.ignoreSpellingWords.push(misspelledWord);
						me.refreshInstance();
					}
				});

				menuItems.popupContext = this.selectionPaths.length ? this.selectionPaths[0] : this.cursor;
				return menuItems;
			} else {
				return false;
			}
		},
		replaceSelectedWord: function(selectedWords, oldWord, newWord) {
			var lineParts = this.getLineParts(this.getCurrentLine());
			var selectionPosition = selectedWords.selectionPosition;
			var selectionLength = selectedWords.selectionLength;

			var startPart = lineParts[0];
			var startPartIndex = 0;
			while(startPart.text.length < selectionPosition + selectionLength) {
				selectionPosition -= startPart.text.length;
				startPartIndex++;
				startPart = lineParts[startPartIndex];

				if(!startPart) {
					this.fireErrorReport('Ran out of parts to replace selected word', 'Ran out of parts to replace selected word', {}, {
						selectedWords: selectedWords,
						oldWord: oldWord,
						newWord: newWord
					});
					console.warn('Ran out of parts to go through to replace "' + oldWord + '" with "' + newWord + '" from at position ' + selectionPosition + ' for length ' + selectionLength);
					return;
				}
			}

			// Try to get what part of selection was the misspelled word in case of user selecting a bunch of text
			var textSelection = startPart.text.substr(selectionPosition, selectionLength);
			let match = textSelection.match(new RegExp('\\b(' + oldWord + ')\\b', 'i'));
			if(match) {
				selectionPosition += match.index;
				selectionLength = match[0].length;
			}

			if(startPart.text.substr(selectionPosition, selectionLength) != oldWord) {
				this.fireErrorReport('Trying to replace word but wrong word detected', 'Trying to replace word but wrong word detected', {}, {
					selectedWords: selectedWords,
					oldWord: oldWord,
					newWord: newWord,
					selectedText: startPart.text.substr(selectionPosition, selectionLength)
				});
				console.warn('Trying to replace "' + oldWord + '" with "' + newWord + '" from "' + startPart.text + '" at position ' + selectionPosition + ' for length ' + selectionLength + ' (' + startPart.text.substr(selectionPosition, selectionLength) + ')');
				return;
			}
			startPart.text = startPart.text.substr(0, selectionPosition) + newWord + startPart.text.substr(selectionPosition + selectionLength);
			this.updateLines();
		},
		getSelectedWords: function() {
			var lineText = this.getCurrentLineText();
			var startPosition = this.selectionPosition;
			while(startPosition > 0 && !this.isSpaceCharacter(lineText[startPosition - 1])) {
				startPosition--;
			}
			var length = Math.max(1, this.selectionLength);
			while(length < lineText.length - startPosition && !this.isSpaceCharacter(lineText[startPosition + length])) {
				length++;
			}

			var selectedText = lineText.substr(startPosition, length);
			selectedText.selectionPosition = startPosition;
			selectedText.selectionLength = length;

			return {
				selectedText: selectedText,
				selectionPosition: startPosition,
				selectionLength: length
			};
		},

		getErrorReportExtras: function(extras) {
			return $.extend({
				instance: JSON.stringify(this.instance),
				selection: {
					position: this.selectionPosition,
					partPosition: this.selectionPartPosition,
					length: this.selectionLength,
					line: this.selectionLine
				}
			}, extras);
		},
		fireErrorReport: function(title, description, exception, extras) {
			if(exception.selection && extras) {
				extras.selectionObject = exception.selection;
			}

			$.fireErrorReport(null, title, description, $.extend({
				exception: exception
			}, this.getErrorReportExtras(), extras));
		},
		removeContent: function() {
			if(!$(this).isAttached()) {
				return;
			}

			var secondaryFocusedElements = $.merge([], this.secondaryFocusedElements);
			this.wrapper.removeText(this, true);
			this.onRemovePropogate();

			secondaryFocusedElements.forEach(function(elem) {
				elem.removeContent();
			});

			if(this.instance.captionImageId) {
				var captionImage = this.wrapper.getFrame(this.instance.captionImageId);
				if(captionImage) {
					captionImage.changeInstanceProperty('captionTextId', null);
				}
			}
		},
		isContentHidden: function(myRect, parentRect) {
			if(!this.parentNode) {
				return true;
			}

			if(!parentRect) {
				parentRect = this.getParentRect();
			}

			return _isContentHidden.call(this, myRect, parentRect);
		},
		isTextBoxHidden: function(myRect, parentRect) {
			if(!this.parentNode) {
				return true;
			}

			if(myRect.left > parentRect.left && myRect.right < parentRect.right && myRect.top > parentRect.top && myRect.bottom < parentRect.bottom) {
				return false;
			}

			var textNodes = $(this.svgEditor).children('text:not(.clone)');
			for(let i = 0; i < textNodes.length; i++) {
				if(_isContentHidden.call(this, textNodes[i].getBoundingClientRect(), parentRect)) {
					return true;
				}
			}

			return false;
		},
		getCachedRect: function() {
			if(this.renderedDisplayWidth) {
				var rect = {
					x: $(this).getFloatStyle('left'),
					y: $(this).getFloatStyle('top'),
					width: this.renderedDisplayWidth + 2,
					height: this.renderedDisplayHeight + 2
				};

				if(this.getRotation) {
					var rotation = this.getRotation();
					if(rotation) {
						rect = this.rotateRect(rect.x, rect.y, rect.width, rect.height, rotation);
					}
				}

				return rect;
			} else {
				return this.getBoundingClientRect();
			}
		},
		destroy: function() {
			if(this.globalMouseupHandler) {
				$('body').off('mouseup', this.globalMouseupHandler);
				this.globalMouseupHandler = null;
			}

			_destroy.apply(this, arguments);
		},
		visibleType: 'text',
		contentType: 'text',
		defaultFontSize: 14,
		defaultLineHeight: $.DEFAULT_LINE_HEIGHT,
		styleCSSMappings: {
			'bold': 'font-weight',
			'italic': 'font-style',
			'underline': 'text-decoration'
		},
		lineSpecificStyles: ['align', 'drop-shadow'],
		maxSchema: 2,
		selectionPosition: 0,
		selectionLength: 0,
		selectionLine: 0,
		focused: false,
		selectionPaths: $(),
		clicksSinceLastDoubleClick: 0,
		fontLineHeightFixes: {
			'architects daughter': 0.3,
			'bubblegum sans': 0.3,
			bonbon: 0.3,
			'cabin sketch': 0.3,
			'dancing script': 0.3,
			eater: -0.1,
			'henny penny': 0,
			'homemade apple': 0,
			'pinyon script': 0.3,
			'press start 2p': -0.05,
			'rock salt': -0.33,
			tangerine: 0.3
		},

		// Stuff users should be overriding
		instance: instance ? instance : null,
		ratio: $.PRODUCTION_RATIO,
		editable: true,
		extraOffset: 0,
		textEditable: true,
		renderable: true,
		allowNewLines: true,
		maxCharacters: null,
		maxLines: null,
		wordWrapText: false,
		defaultDropShadow: {
			color: 'rgb(0, 0, 0)',
			depth: 6,
			intensity: 4
		},
		canHaveBarcodes: false,
		wordWrapRightPadding: 0,
		allowSelectAll: false,
		useOuterWrapper: true,
		refreshWhenFontLoaded: false
	}, options);

	if(me.renderable) {
		if (me.addClass) {
			$(me).addClass(me.addClass);
		}

		if (me.padding) {
			me.setPadding(me.padding);
		}

		var appendSVGEditorTo = me;
		if(me.useOuterWrapper) {
			me.outerWrapper = document.createElement('div');
			me.outerWrapper.className = 'flowSVGOuterWrapper';
			me.appendChild(me.outerWrapper);
			appendSVGEditorTo = me.outerWrapper;
		}

		me.svgEditor = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		me.svgEditor.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
		me.svgEditor.className = 'flowSVGEditor';
		appendSVGEditorTo.appendChild(me.svgEditor);

		if (me.appendTo) {
			$(me).appendTo(me.appendTo);
		}
	}

	if(me.instance) {
		me.setInstance(me.instance);
	} else if(me.renderable) {
		// Setup default width/height
		me.setRenderedWidth(0);
		me.setRenderedHeight(me.defaultFontSize / $.PRODUCTION_RATIO * me.ratio);
	}
	if(me.renderable) {
		me.setEditable(me.editable);
	}

	return me;
};
$.FlowLayoutSVG.MAX_SCHEMA = 2;

$.FlowLayoutSVGUtils = {
	getInstanceText: function(instance) {
		if(typeof instance == 'string') {
			return instance;
		}

		var svg = new $.FlowLayoutSVG({
			renderable: false
		}, instance);

		return svg.getInstanceText();
	},
	getMaxFontSize: function(line, defaultFontSize) {
		var svg = new $.FlowLayoutSVG({
			renderable: false
		});

		var maxFontSize = 0;
		svg.iterateLineParts(line, function(part) {
			if(part['font-size']) {
				maxFontSize = Math.max(maxFontSize, parseFloat(part['font-size'].replace('pt', '')));
			}
		});
		return maxFontSize || defaultFontSize;
	},
	hasBarcode: function(instance) {
		var svg = new $.FlowLayoutSVG({
			renderable: false
		}, instance);

		return svg.hasBarcode();
	},
	isFontQRCode: function(fontFamily) {
		fontFamily = (fontFamily || '').toLowerCase();
		return fontFamily.indexOf('qr code') != -1;
	},
	isFontBarcode: function(fontFamily) {
		fontFamily = (fontFamily || '').toLowerCase();
		// Need to update font-caching.php -> addFontsFromHtml any time this list is changed
		return fontFamily.indexOf('c39') != -1 || (fontFamily.indexOf('code') !== -1 && fontFamily.indexOf('unicode') === -1) || fontFamily.indexOf('ean') === 0 || this.isFontQRCode(fontFamily);
	},
	isFontNoWhitespace: function(fontFamily) {
		return fontFamily && ['reenie beanie', 'ruthie'].indexOf(fontFamily.toLowerCase()) !== -1;
	},
	getTitleCaseFont: function(font) {
		font = (font || '').toLowerCase();

		var titleFont = font.toTitleCase(true);
		if($.GoogleFontSpecialTitleCaseMap[font]) {
			titleFont = $.GoogleFontSpecialTitleCaseMap[font];
		}

		return titleFont;
	},
	getClosestMatchingFontSize: function(fontSize) {
		let match = $.DefaultFontSizes[0];
		if(typeof match == 'string') {
			match = $.DefaultFontSizes[1];
		}

		for(let i = 0; i < $.DefaultFontSizes.length; i++) {
			var defaultFontSize = $.DefaultFontSizes[i];
			if(typeof defaultFontSize == 'string') {
				continue;
			}

			if(fontSize < defaultFontSize) {
				break;
			}
			match = defaultFontSize;
		}

		return match;
	},
	isMultiByteCharacter: function(string, position) {
		return this.multiByteCharacterRegex.test(string.substr(position, 1));
	},
	getMultiByteCharacterLength: function(string, position, backwards) {
		if(backwards) {
			var startStr = string.substr(0, position);
			let match, lastMatch;
			// eslint-disable-next-line
			while(lastMatch = window.allEmojiRegex.exec(startStr)) {
				match = lastMatch;
			}
			window.allEmojiRegex.lastIndex = 0;

			if(match) {
				let matchLength = $.FlowLayoutSVGUtils.getMultiByteCharacterMatchLength(match[0]);
				if((match.index + matchLength) === position) {
					return matchLength;
				}
			}
		} else {
			let match = window.allEmojiRegex.exec(string.substr(position));
			window.allEmojiRegex.lastIndex = 0;
			if(match && match.index === 0) {
				return $.FlowLayoutSVGUtils.getMultiByteCharacterMatchLength(match[0]);
			}
		}

		return 2;
	},
	getMultiByteCharacterMatchLength: function(match) {
		if(match.length === 2 && !$.FlowLayoutSVGUtils.isMultiByteEmojiPresentationCharacter(match, match.length - 1)) {
			return 3;
		} else {
			return match.length;
		}
	},
	isMultiByteJoinCharacter: function(string, position) {
		return string.charCodeAt(position) === 8205;
	},
	isMultiByteEmojiPresentationCharacter: function(string, position) {
		return string.charCodeAt(position) === 65039;
	},
	checkForMisspelledWord: function(text) {
		if(!window.nspellcheck) {
			return [];
		}

		var words = text.replace(this.emailRegex, '').replace(this.urlRegex, '').replace(this.apostropheLookalikeRegex, "'").replace(this.globalMultiByteCharacterRegex, ' ').replace(this.specialCharactersRegex, '').split(this.wordSplitRegex).filter(function(word) {
			return word.length > 0 && word !== "'";
		});
		
		var misspelledWords = [];
		words.forEach(function(word, wordIndex) {
			if($.FlowLayoutSVGUtils.ignoreSpellingWords.includes(word.toLowerCase())) {
				return;
			}

			if(wordIndex < words.length && word === words[wordIndex + 1] && text.split(String.fromCharCode(160)).join(' ').indexOf(word + ' ' + word) !== -1) {
				misspelledWords.push(word + ' ' + word);
			}

			if(!isNaN(word)) {
				return;
			} else if($.FlowLayoutSVGUtils.commonMispelledWords[word.toLowerCase()] && word !== $.FlowLayoutSVGUtils.commonMispelledWords[word.toLowerCase()][0]) {
				if(misspelledWords.indexOf(word) === -1) {
					misspelledWords.push(word);
				}
				return;
			}
			// Most all caps should be acronyms
			else if(word.toUpperCase() === word) {
				return;
			}

			if(word[0] === "'") {
				word = word.substr(1);
			}
			if(word[word.length - 1] === "'") {
				word = word.substr(0, word.length - 1);
			}

			if(misspelledWords.indexOf(word) === -1 && !window.nspellcheck.correct(word) && !$.FlowLayoutSVGUtils.numberRegex.test(word)) {
				misspelledWords.push(word);
			}
		});

		if($.saveSpellingMistakes && misspelledWords.length) {
			var spellingMistakes = $.merge([], misspelledWords).filter(function(word) {
				return !$.FlowLayoutSVGUtils.loggedSpellingMistakes.includes(word);
			});

			if(spellingMistakes.length) {
				$.ajax({
					url: 'ajax/saveSpellingMistake.php',
					data: {
						words: spellingMistakes,
						plicProjectId: $.PlicProjectId
					},
					type: 'POST'
				});

				$.merge($.FlowLayoutSVGUtils.loggedSpellingMistakes, spellingMistakes);
			}
		}

		return misspelledWords;
	},
	getSpellingSuggestions: function(word) {
		if(!window.nspellcheck) {
			return [];
		}

		if($.FlowLayoutSVGUtils.commonMispelledWords[word.toLowerCase()]) {
			var correctWords = $.FlowLayoutSVGUtils.commonMispelledWords[word.toLowerCase()];
			if(word.toLowerCase() !== word) {
				return correctWords.map(function(correctWord) {
					return correctWord[0].toUpperCase() + correctWord.slice(1);
				});
			} else {
				return correctWords;
			}
		}

		return window.nspellcheck.suggest(word).slice(0, 15);
	},

	iterateInstanceParts: function(instance, callback) {
		return $.FlowLayoutSVGUtils.iterateParts($.FlowLayoutSVGUtils.getInstanceParts(instance), callback);
	},
	iterateLineParts: function(line, callback) {
		return $.FlowLayoutSVGUtils.iterateParts($.FlowLayoutSVGUtils.getLineParts(line), callback);
	},
	iterateParts: function(parts, callback) {
		for(let i = 0; i < parts.length; i++) {
			if(callback(parts[i]) === false) {
				return false;
			}
		}

		return true;
	},

	getInstanceParts: function(instance) {
		let lines = instance.lines;

		if($.isArray(lines)) {
			var parts = [];
			for(let i = 0; i < lines.length; i++) {
				let line = lines[i];
				if(!$.isInit(line)) {
					lines[i] = line = {
						text: ''
					};
				}

				$.merge(parts, $.FlowLayoutSVGUtils.getLineParts(line));
			}
			
			return parts;
		} else {
			return $.FlowLayoutSVGUtils.getLineParts(lines);
		}
	},
	getLineParts: function(line) {
		if(typeof line == 'string') {
			return [$.FlowLayoutSVGUtils.sanitizeLinePart({
				text: line
			})];
		} else if(!$.isInit(line)) {
			return [];
		} else if($.isInit(line.text)) {
			return [$.FlowLayoutSVGUtils.sanitizeLinePart(line)];
		} else if(line.parts) {
			// Fix case where part is sometimes just []
			for(let i = 0; i < line.parts.length; i++) {
				var part = line.parts[i];
				if($.isArray(part)) {
					if(line.parts.length == 1) {
						part = line.parts[i] = {
							text: ''
						};
					} else {
						line.parts.splice(i, 1);
						i--;
					}
				} else if(part === null) {
					line.parts.splice(i, 1);
					i--;
				}

				$.FlowLayoutSVGUtils.sanitizeLinePart(part);
			}

			if(!line.parts.length) {
				line.parts = [
					{
						text: ''
					}
				];
			}


			return line.parts;
		} else if($.isPlainObject(line)) {
			return [$.FlowLayoutSVGUtils.sanitizeLinePart(line)];
		} else {
			return [];
		}
	},
	sanitizeLinePart: function(part) {
		if(part) {
			if($.isInit(part.text)) {
				// Convert numbers to strings
				part.text += '';

				// We dont' handle tabs
				part.text = part.text.replace($.FlowLayoutSVGUtils.newLineRegex, ' ');
				part.text = part.text.replace($.FlowLayoutSVGUtils.controlCharacterRegex, '');
				part.text = this.sanitizeEmojiText(part.text);
			} else {
				part.text = '';
			}

			// Migrate old drop-shadow to new format
			if(part['drop-shadow'] && typeof part['drop-shadow'] == 'string') {
				part['drop-shadow'] = {
					color: part['drop-shadow'],
					depth: 3,
					intensity: 4
				};
			}

			// Migrate old stroke to new format
			if(part.stroke && typeof part.stroke == 'string') {
				part.stroke = {
					color: part.stroke,
					thickness: 1
				};
			}

			if(part.customFont === true) {
				delete part.customFont;
			} else if(part.customFont && typeof part.customFont === 'string' && part.customFont.includes('<Font Style')) {
				delete part.customFont;
			}
			if(part.fontFamily && typeof part.fontFamily === 'string' && part.fontFamily.includes('<font style')) {
				delete part.fontFamily;
			}
		}

		return part;
	},
	sanitizeEmojiText: function(text) {
		// Check for 2 byte emoji missing presentation character
		// This check is cheaper than all emoji regex so double check that we need to waste time first
		if($.FlowLayoutSVGUtils.multiByteCharacterRegex.test(text)) {			
			var matches = text.match(window.allEmojiRegex) || [];
			matches.forEach(function(match) {
				if(match.length === 2 && match.match(window.allEmojiRegex) && !$.FlowLayoutSVGUtils.isMultiByteEmojiPresentationCharacter(match, match.length - 1)) {
					// TODO: Make sure we aren't santizing multiple times
					let replaceRegex = new RegExp(match.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') + '(?!' + String.fromCharCode(65039) + ')', 'g');
					text = text.replace(replaceRegex, match + String.fromCharCode(65039));
				}
			});
		}

		// Check for single byte emoji that browsers transparently update to display correctly but Prince fails on
		let singleByteMatches = text.match($.FlowLayoutSVGUtils.singleByteEmojiRegex) || [];
		singleByteMatches.forEach(match => {
			let replaceWith = $.FlowLayoutSVGUtils.singleByteEmojiFixes[match];
			// Want to be extra sure we are only replacing single byte versions and not the valid ones
			let matchReplaceWith = replaceWith;
			if(!['®️', '©️', '™️'].includes(match)) {
				matchReplaceWith = replaceWith.charAt(1);
			}
			let replaceRegex = new RegExp(match + '(?!' + matchReplaceWith + ')', 'g');
			text = text.replace(replaceRegex, replaceWith);
		});

		return text;
	},

	dynamicTextRegex: /%(.+)%/,
	// eslint-disable-next-line
	multiByteCharacterRegex: /[^\u0000-\u00ff]/,
	// eslint-disable-next-line
	globalMultiByteCharacterRegex: /[^\u0000-\u00ff]/g,
	wordSplitRegex: /[\s\u2000-\u206F\u2E00-\u2E7F\\!"¨#$%&()*+,\-./:;<=>?@[\]^_`{|}~¡¿。、·]/,
	punctuationRegex: /[.,/#!$%^&*;:{}=\-_`~()"'¨¡¿。、·]/,
	apostropheLookalikeRegex: /’/g,
	emailRegex: /\S+@\S+\.\S+/g,
	urlRegex: /\S+\.(AAA|AARP|ABARTH|ABB|ABBOTT|ABBVIE|ABC|ABLE|ABOGADO|ABUDHABI|AC|ACADEMY|ACCENTURE|ACCOUNTANT|ACCOUNTANTS|ACO|ACTOR|AD|ADAC|ADS|ADULT|AE|AEG|AERO|AETNA|AF|AFAMILYCOMPANY|AFL|AFRICA|AG|AGAKHAN|AGENCY|AI|AIG|AIRBUS|AIRFORCE|AIRTEL|AKDN|AL|ALFAROMEO|ALIBABA|ALIPAY|ALLFINANZ|ALLSTATE|ALLY|ALSACE|ALSTOM|AM|AMAZON|AMERICANEXPRESS|AMERICANFAMILY|AMEX|AMFAM|AMICA|AMSTERDAM|ANALYTICS|ANDROID|ANQUAN|ANZ|AO|AOL|APARTMENTS|APP|APPLE|AQ|AQUARELLE|AR|ARAB|ARAMCO|ARCHI|ARMY|ARPA|ART|ARTE|AS|ASDA|ASIA|ASSOCIATES|AT|ATHLETA|ATTORNEY|AU|AUCTION|AUDI|AUDIBLE|AUDIO|AUSPOST|AUTHOR|AUTO|AUTOS|AVIANCA|AW|AWS|AX|AXA|AZ|AZURE|BA|BABY|BAIDU|BANAMEX|BANANAREPUBLIC|BAND|BANK|BAR|BARCELONA|BARCLAYCARD|BARCLAYS|BAREFOOT|BARGAINS|BASEBALL|BASKETBALL|BAUHAUS|BAYERN|BB|BBC|BBT|BBVA|BCG|BCN|BD|BE|BEATS|BEAUTY|BEER|BENTLEY|BERLIN|BEST|BESTBUY|BET|BF|BG|BH|BHARTI|BI|BIBLE|BID|BIKE|BING|BINGO|BIO|BIZ|BJ|BLACK|BLACKFRIDAY|BLOCKBUSTER|BLOG|BLOOMBERG|BLUE|BM|BMS|BMW|BN|BNPPARIBAS|BO|BOATS|BOEHRINGER|BOFA|BOM|BOND|BOO|BOOK|BOOKING|BOSCH|BOSTIK|BOSTON|BOT|BOUTIQUE|BOX|BR|BRADESCO|BRIDGESTONE|BROADWAY|BROKER|BROTHER|BRUSSELS|BS|BT|BUDAPEST|BUGATTI|BUILD|BUILDERS|BUSINESS|BUY|BUZZ|BV|BW|BY|BZ|BZH|CA|CAB|CAFE|CAL|CALL|CALVINKLEIN|CAM|CAMERA|CAMP|CANCERRESEARCH|CANON|CAPETOWN|CAPITAL|CAPITALONE|CAR|CARAVAN|CARDS|CARE|CAREER|CAREERS|CARS|CASA|CASE|CASH|CASINO|CAT|CATERING|CATHOLIC|CBA|CBN|CBRE|CBS|CC|CD|CENTER|CEO|CERN|CF|CFA|CFD|CG|CH|CHANEL|CHANNEL|CHARITY|CHASE|CHAT|CHEAP|CHINTAI|CHRISTMAS|CHROME|CHURCH|CI|CIPRIANI|CIRCLE|CISCO|CITADEL|CITI|CITIC|CITY|CITYEATS|CK|CL|CLAIMS|CLEANING|CLICK|CLINIC|CLINIQUE|CLOTHING|CLOUD|CLUB|CLUBMED|CM|CN|CO|COACH|CODES|COFFEE|COLLEGE|COLOGNE|COM|COMCAST|COMMBANK|COMMUNITY|COMPANY|COMPARE|COMPUTER|COMSEC|CONDOS|CONSTRUCTION|CONSULTING|CONTACT|CONTRACTORS|COOKING|COOKINGCHANNEL|COOL|COOP|CORSICA|COUNTRY|COUPON|COUPONS|COURSES|CPA|CR|CREDIT|CREDITCARD|CREDITUNION|CRICKET|CROWN|CRS|CRUISE|CRUISES|CSC|CU|CUISINELLA|CV|CW|CX|CY|CYMRU|CYOU|CZ|DABUR|DAD|DANCE|DATA|DATE|DATING|DATSUN|DAY|DCLK|DDS|DE|DEAL|DEALER|DEALS|DEGREE|DELIVERY|DELL|DELOITTE|DELTA|DEMOCRAT|DENTAL|DENTIST|DESI|DESIGN|DEV|DHL|DIAMONDS|DIET|DIGITAL|DIRECT|DIRECTORY|DISCOUNT|DISCOVER|DISH|DIY|DJ|DK|DM|DNP|DO|DOCS|DOCTOR|DOG|DOMAINS|DOT|DOWNLOAD|DRIVE|DTV|DUBAI|DUCK|DUNLOP|DUPONT|DURBAN|DVAG|DVR|DZ|EARTH|EAT|EC|ECO|EDEKA|EDU|EDUCATION|EE|EG|EMAIL|EMERCK|ENERGY|ENGINEER|ENGINEERING|ENTERPRISES|EPSON|EQUIPMENT|ER|ERICSSON|ERNI|ES|ESQ|ESTATE|ET|ETISALAT|EU|EUROVISION|EUS|EVENTS|EXCHANGE|EXPERT|EXPOSED|EXPRESS|EXTRASPACE|FAGE|FAIL|FAIRWINDS|FAITH|FAMILY|FAN|FANS|FARM|FARMERS|FASHION|FAST|FEDEX|FEEDBACK|FERRARI|FERRERO|FI|FIAT|FIDELITY|FIDO|FILM|FINAL|FINANCE|FINANCIAL|FIRE|FIRESTONE|FIRMDALE|FISH|FISHING|FIT|FITNESS|FJ|FK|FLICKR|FLIGHTS|FLIR|FLORIST|FLOWERS|FLY|FM|FO|FOO|FOOD|FOODNETWORK|FOOTBALL|FORD|FOREX|FORSALE|FORUM|FOUNDATION|FOX|FR|FREE|FRESENIUS|FRL|FROGANS|FRONTDOOR|FRONTIER|FTR|FUJITSU|FUN|FUND|FURNITURE|FUTBOL|FYI|GA|GAL|GALLERY|GALLO|GALLUP|GAME|GAMES|GAP|GARDEN|GAY|GB|GBIZ|GD|GDN|GE|GEA|GENT|GENTING|GEORGE|GF|GG|GGEE|GH|GI|GIFT|GIFTS|GIVES|GIVING|GL|GLADE|GLASS|GLE|GLOBAL|GLOBO|GM|GMAIL|GMBH|GMO|GMX|GN|GODADDY|GOLD|GOLDPOINT|GOLF|GOO|GOODYEAR|GOOG|GOOGLE|GOP|GOT|GOV|GP|GQ|GR|GRAINGER|GRAPHICS|GRATIS|GREEN|GRIPE|GROCERY|GROUP|GS|GT|GU|GUARDIAN|GUCCI|GUGE|GUIDE|GUITARS|GURU|GW|GY|HAIR|HAMBURG|HANGOUT|HAUS|HBO|HDFC|HDFCBANK|HEALTH|HEALTHCARE|HELP|HELSINKI|HERE|HERMES|HGTV|HIPHOP|HISAMITSU|HITACHI|HIV|HK|HKT|HM|HN|HOCKEY|HOLDINGS|HOLIDAY|HOMEDEPOT|HOMEGOODS|HOMES|HOMESENSE|HONDA|HORSE|HOSPITAL|HOST|HOSTING|HOT|HOTELES|HOTELS|HOTMAIL|HOUSE|HOW|HR|HSBC|HT|HU|HUGHES|HYATT|HYUNDAI|IBM|ICBC|ICE|ICU|ID|IE|IEEE|IFM|IKANO|IL|IM|IMAMAT|IMDB|IMMO|IMMOBILIEN|IN|INC|INDUSTRIES|INFINITI|INFO|ING|INK|INSTITUTE|INSURANCE|INSURE|INT|INTERNATIONAL|INTUIT|INVESTMENTS|IO|IPIRANGA|IQ|IR|IRISH|IS|ISMAILI|IST|ISTANBUL|IT|ITAU|ITV|JAGUAR|JAVA|JCB|JE|JEEP|JETZT|JEWELRY|JIO|JLL|JM|JMP|JNJ|JO|JOBS|JOBURG|JOT|JOY|JP|JPMORGAN|JPRS|JUEGOS|JUNIPER|KAUFEN|KDDI|KE|KERRYHOTELS|KERRYLOGISTICS|KERRYPROPERTIES|KFH|KG|KH|KI|KIA|KIM|KINDER|KINDLE|KITCHEN|KIWI|KM|KN|KOELN|KOMATSU|KOSHER|KP|KPMG|KPN|KR|KRD|KRED|KUOKGROUP|KW|KY|KYOTO|KZ|LA|LACAIXA|LAMBORGHINI|LAMER|LANCASTER|LANCIA|LAND|LANDROVER|LANXESS|LASALLE|LAT|LATINO|LATROBE|LAW|LAWYER|LB|LC|LDS|LEASE|LECLERC|LEFRAK|LEGAL|LEGO|LEXUS|LGBT|LI|LIDL|LIFE|LIFEINSURANCE|LIFESTYLE|LIGHTING|LIKE|LILLY|LIMITED|LIMO|LINCOLN|LINDE|LINK|LIPSY|LIVE|LIVING|LIXIL|LK|LLC|LLP|LOAN|LOANS|LOCKER|LOCUS|LOFT|LOL|LONDON|LOTTE|LOTTO|LOVE|LPL|LPLFINANCIAL|LR|LS|LT|LTD|LTDA|LU|LUNDBECK|LUXE|LUXURY|LV|LY|MA|MACYS|MADRID|MAIF|MAISON|MAKEUP|MAN|MANAGEMENT|MANGO|MAP|MARKET|MARKETING|MARKETS|MARRIOTT|MARSHALLS|MASERATI|MATTEL|MBA|MC|MCKINSEY|MD|ME|MED|MEDIA|MEET|MELBOURNE|MEME|MEMORIAL|MEN|MENU|MERCKMSD|MG|MH|MIAMI|MICROSOFT|MIL|MINI|MINT|MIT|MITSUBISHI|MK|ML|MLB|MLS|MM|MMA|MN|MO|MOBI|MOBILE|MODA|MOE|MOI|MOM|MONASH|MONEY|MONSTER|MORMON|MORTGAGE|MOSCOW|MOTO|MOTORCYCLES|MOV|MOVIE|MP|MQ|MR|MS|MSD|MT|MTN|MTR|MU|MUSEUM|MUTUAL|MV|MW|MX|MY|MZ|NA|NAB|NAGOYA|NAME|NATURA|NAVY|NBA|NC|NE|NEC|NET|NETBANK|NETFLIX|NETWORK|NEUSTAR|NEW|NEWS|NEXT|NEXTDIRECT|NEXUS|NF|NFL|NG|NGO|NHK|NI|NICO|NIKE|NIKON|NINJA|NISSAN|NISSAY|NL|NO|NOKIA|NORTHWESTERNMUTUAL|NORTON|NOW|NOWRUZ|NOWTV|NP|NR|NRA|NRW|NTT|NU|NYC|NZ|OBI|OBSERVER|OFF|OFFICE|OKINAWA|OLAYAN|OLAYANGROUP|OLDNAVY|OLLO|OM|OMEGA|ONE|ONG|ONL|ONLINE|OOO|OPEN|ORACLE|ORANGE|ORG|ORGANIC|ORIGINS|OSAKA|OTSUKA|OTT|OVH|PA|PAGE|PANASONIC|PARIS|PARS|PARTNERS|PARTS|PARTY|PASSAGENS|PAY|PCCW|PE|PET|PF|PFIZER|PG|PH|PHARMACY|PHD|PHILIPS|PHONE|PHOTO|PHOTOGRAPHY|PHOTOS|PHYSIO|PICS|PICTET|PICTURES|PID|PIN|PING|PINK|PIONEER|PIZZA|PK|PL|PLACE|PLAY|PLAYSTATION|PLUMBING|PLUS|PM|PN|PNC|POHL|POKER|POLITIE|PORN|POST|PR|PRAMERICA|PRAXI|PRESS|PRIME|PRO|PROD|PRODUCTIONS|PROF|PROGRESSIVE|PROMO|PROPERTIES|PROPERTY|PROTECTION|PRU|PRUDENTIAL|PS|PT|PUB|PW|PWC|PY|QA|QPON|QUEBEC|QUEST|QVC|RACING|RADIO|RAID|RE|READ|REALESTATE|REALTOR|REALTY|RECIPES|RED|REDSTONE|REDUMBRELLA|REHAB|REISE|REISEN|REIT|RELIANCE|REN|RENT|RENTALS|REPAIR|REPORT|REPUBLICAN|REST|RESTAURANT|REVIEW|REVIEWS|REXROTH|RICH|RICHARDLI|RICOH|RIL|RIO|RIP|RMIT|RO|ROCHER|ROCKS|RODEO|ROGERS|ROOM|RS|RSVP|RU|RUGBY|RUHR|RUN|RW|RWE|RYUKYU|SA|SAARLAND|SAFE|SAFETY|SAKURA|SALE|SALON|SAMSCLUB|SAMSUNG|SANDVIK|SANDVIKCOROMANT|SANOFI|SAP|SARL|SAS|SAVE|SAXO|SB|SBI|SBS|SC|SCA|SCB|SCHAEFFLER|SCHMIDT|SCHOLARSHIPS|SCHOOL|SCHULE|SCHWARZ|SCIENCE|SCJOHNSON|SCOT|SD|SE|SEARCH|SEAT|SECURE|SECURITY|SEEK|SELECT|SENER|SERVICES|SES|SEVEN|SEW|SEX|SEXY|SFR|SG|SH|SHANGRILA|SHARP|SHAW|SHELL|SHIA|SHIKSHA|SHOES|SHOP|SHOPPING|SHOUJI|SHOW|SHOWTIME|SI|SILK|SINA|SINGLES|SITE|SJ|SK|SKI|SKIN|SKY|SKYPE|SL|SLING|SM|SMART|SMILE|SN|SNCF|SO|SOCCER|SOCIAL|SOFTBANK|SOFTWARE|SOHU|SOLAR|SOLUTIONS|SONG|SONY|SOY|SPA|SPACE|SPORT|SPOT|SR|SRL|SS|ST|STADA|STAPLES|STAR|STATEBANK|STATEFARM|STC|STCGROUP|STOCKHOLM|STORAGE|STORE|STREAM|STUDIO|STUDY|STYLE|SU|SUCKS|SUPPLIES|SUPPLY|SUPPORT|SURF|SURGERY|SUZUKI|SV|SWATCH|SWIFTCOVER|SWISS|SX|SY|SYDNEY|SYSTEMS|SZ|TAB|TAIPEI|TALK|TAOBAO|TARGET|TATAMOTORS|TATAR|TATTOO|TAX|TAXI|TC|TCI|TD|TDK|TEAM|TECH|TECHNOLOGY|TEL|TEMASEK|TENNIS|TEVA|TF|TG|TH|THD|THEATER|THEATRE|TIAA|TICKETS|TIENDA|TIFFANY|TIPS|TIRES|TIROL|TJ|TJMAXX|TJX|TK|TKMAXX|TL|TM|TMALL|TN|TO|TODAY|TOKYO|TOOLS|TOP|TORAY|TOSHIBA|TOTAL|TOURS|TOWN|TOYOTA|TOYS|TR|TRADE|TRADING|TRAINING|TRAVEL|TRAVELCHANNEL|TRAVELERS|TRAVELERSINSURANCE|TRUST|TRV|TT|TUBE|TUI|TUNES|TUSHU|TV|TVS|TW|TZ|UA|UBANK|UBS|UG|UK|UNICOM|UNIVERSITY|UNO|UOL|UPS|US|UY|UZ|VA|VACATIONS|VANA|VANGUARD|VC|VE|VEGAS|VENTURES|VERISIGN|VERSICHERUNG|VET|VG|VI|VIAJES|VIDEO|VIG|VIKING|VILLAS|VIN|VIP|VIRGIN|VISA|VISION|VIVA|VIVO|VLAANDEREN|VN|VODKA|VOLKSWAGEN|VOLVO|VOTE|VOTING|VOTO|VOYAGE|VU|VUELOS|WALES|WALMART|WALTER|WANG|WANGGOU|WATCH|WATCHES|WEATHER|WEATHERCHANNEL|WEBCAM|WEBER|WEBSITE|WED|WEDDING|WEIBO|WEIR|WF|WHOSWHO|WIEN|WIKI|WILLIAMHILL|WIN|WINDOWS|WINE|WINNERS|WME|WOLTERSKLUWER|WOODSIDE|WORK|WORKS|WORLD|WOW|WS|WTC|WTF|XBOX|XEROX|XFINITY|XIHUAN|XIN|XXX|XYZ|YACHTS|YAHOO|YAMAXUN|YANDEX|YE|YODOBASHI|YOGA|YOKOHAMA|YOU|YOUTUBE|YT|YUN|ZA|ZAPPOS|ZARA|ZERO|ZIP|ZM|ZONE|ZUERICH|ZW)\S*/gi,
	numberRegex: /^[0-9]+'?[a-zA-Z]{0,3}$/,
	newLineRegex: /(?:\r\n|\r\r|\r|\n)/g,
	// Vulgar Fractions: \u00BC-\u00BE\u2150-\u215E (ie: ¼½¾⅐⅑⅒⅓⅔⅕⅖⅗⅘⅙⅚⅛⅜⅝⅞)
	specialCharactersRegex: /[\u00BC-\u00BE\u2150-\u215E]/g,
	// eslint-disable-next-line
	controlCharacterRegex: /[\u0080-\u009f\u0000-\u001f]/g,
	unusualControlCharacterRegex: /[\u0080-\u009f]/g,

	commonMispelledWords: {
		payed: ['paid'],
		thru: ['Through'],
		loosing: ['losing'],
		planed: ['planned'],
		specif: ['specific', 'specify'],
		nickle: ['nickel'],
		slippy: ['slippery'],
		toke: ['took'],
		withing: ['within'],
		indite: ['indict'],
		florescent: ['fluorescent'],
		discontentment: ['discontent'],
		causalities: ['casualties']
	},
	ignoreSpellingWords: ['ok', 'waterpark', 'spongebob', 'url', 'aboriginality', 'covid', 'pj', 'tv', 'starship'],

	loggedSpellingMistakes: [],

	// Generated by generateEmojiMap.php and looking at single byte non_qualified results
	singleByteEmojiRegex: /\u00A9\ufe0f|\u00AE\uFE0F|\u1F170|\u1F171|\u1F17E|\u1F17F|\u1F202|\u1F237|\u1F321|\u1F324|\u1F325|\u1F326|\u1F327|\u1F328|\u1F329|\u1F32A|\u1F32B|\u1F32C|\u1F336|\u1F37D|\u1F396|\u1F397|\u1F399|\u1F39A|\u1F39B|\u1F39E|\u1F39F|\u1F3CB|\u1F3CC|\u1F3CD|\u1F3CE|\u1F3D4|\u1F3D5|\u1F3D6|\u1F3D7|\u1F3D8|\u1F3D9|\u1F3DA|\u1F3DB|\u1F3DC|\u1F3DD|\u1F3DE|\u1F3DF|\u1F3F3|\u1F3F5|\u1F3F7|\u1F43F|\u1F441|\u1F4FD|\u1F549|\u1F54A|\u1F56F|\u1F570|\u1F573|\u1F574|\u1F575|\u1F576|\u1F577|\u1F578|\u1F579|\u1F587|\u1F58A|\u1F58B|\u1F58C|\u1F58D|\u1F590|\u1F5A5|\u1F5A8|\u1F5B1|\u1F5B2|\u1F5BC|\u1F5C2|\u1F5C3|\u1F5C4|\u1F5D1|\u1F5D2|\u1F5D3|\u1F5DC|\u1F5DD|\u1F5DE|\u1F5E1|\u1F5E3|\u1F5E8|\u1F5EF|\u1F5F3|\u1F5FA|\u1F6CB|\u1F6CD|\u1F6CE|\u1F6CF|\u1F6E0|\u1F6E1|\u1F6E2|\u1F6E3|\u1F6E4|\u1F6E5|\u1F6E9|\u1F6F0|\u1F6F3|\u203C|\u2049|\u2122\ufe0f|\u2139|\u2194|\u2195|\u2196|\u2197|\u2198|\u2199|\u21A9|\u21AA|\u2328|\u23CF|\u23ED|\u23EE|\u23EF|\u23F1|\u23F2|\u23F8|\u23F9|\u23FA|\u24C2|\u25AA|\u25AB|\u25B6|\u25C0|\u25FB|\u25FC|\u2600|\u2601|\u2602|\u2603|\u2604|\u260E|\u2611|\u2618|\u261D|\u2620|\u2622|\u2623|\u2626|\u262A|\u262E|\u262F|\u2638|\u2639|\u263A|\u2640|\u2642|\u265F|\u2660|\u2663|\u2665|\u2666|\u2668|\u267B|\u267E|\u2692|\u2694|\u2695|\u2696|\u2697|\u2699|\u269B|\u269C|\u26A0|\u26A7|\u26B0|\u26B1|\u26C8|\u26CF|\u26D1|\u26D3|\u26E9|\u26F0|\u26F1|\u26F4|\u26F7|\u26F8|\u26F9|\u2702|\u2708|\u2709|\u270C|\u270D|\u270F|\u2712|\u2714|\u2716|\u271D|\u2721|\u2733|\u2734|\u2744|\u2747|\u2763|\u2764|\u27A1|\u2934|\u2935|\u2B05|\u2B06|\u2B07|\u3030|\u303D|\u3297|\u3299/g,
	// U00AE/00A9/2122 should remain a singe character - fonts already define it and Prince gets confused on non-flattened mode and renders it badly
	singleByteEmojiFixes: {"\u00a9\ufe0f":"\u00a9","\u00ae\ufe0f":"\u00ae","\ud83c\udd70":"\ud83c\udd70\ufe0f","\ud83c\udd71":"\ud83c\udd71\ufe0f","\ud83c\udd7e":"\ud83c\udd7e\ufe0f","\ud83c\udd7f":"\ud83c\udd7f\ufe0f","\ud83c\ude02":"\ud83c\ude02\ufe0f","\ud83c\ude37":"\ud83c\ude37\ufe0f","\ud83c\udf21":"\ud83c\udf21\ufe0f","\ud83c\udf24":"\ud83c\udf24\ufe0f","\ud83c\udf25":"\ud83c\udf25\ufe0f","\ud83c\udf26":"\ud83c\udf26\ufe0f","\ud83c\udf27":"\ud83c\udf27\ufe0f","\ud83c\udf28":"\ud83c\udf28\ufe0f","\ud83c\udf29":"\ud83c\udf29\ufe0f","\ud83c\udf2a":"\ud83c\udf2a\ufe0f","\ud83c\udf2b":"\ud83c\udf2b\ufe0f","\ud83c\udf2c":"\ud83c\udf2c\ufe0f","\ud83c\udf36":"\ud83c\udf36\ufe0f","\ud83c\udf7d":"\ud83c\udf7d\ufe0f","\ud83c\udf96":"\ud83c\udf96\ufe0f","\ud83c\udf97":"\ud83c\udf97\ufe0f","\ud83c\udf99":"\ud83c\udf99\ufe0f","\ud83c\udf9a":"\ud83c\udf9a\ufe0f","\ud83c\udf9b":"\ud83c\udf9b\ufe0f","\ud83c\udf9e":"\ud83c\udf9e\ufe0f","\ud83c\udf9f":"\ud83c\udf9f\ufe0f","\ud83c\udfcb":"\ud83c\udfcb\ufe0f","\ud83c\udfcc":"\ud83c\udfcc\ufe0f","\ud83c\udfcd":"\ud83c\udfcd\ufe0f","\ud83c\udfce":"\ud83c\udfce\ufe0f","\ud83c\udfd4":"\ud83c\udfd4\ufe0f","\ud83c\udfd5":"\ud83c\udfd5\ufe0f","\ud83c\udfd6":"\ud83c\udfd6\ufe0f","\ud83c\udfd7":"\ud83c\udfd7\ufe0f","\ud83c\udfd8":"\ud83c\udfd8\ufe0f","\ud83c\udfd9":"\ud83c\udfd9\ufe0f","\ud83c\udfda":"\ud83c\udfda\ufe0f","\ud83c\udfdb":"\ud83c\udfdb\ufe0f","\ud83c\udfdc":"\ud83c\udfdc\ufe0f","\ud83c\udfdd":"\ud83c\udfdd\ufe0f","\ud83c\udfde":"\ud83c\udfde\ufe0f","\ud83c\udfdf":"\ud83c\udfdf\ufe0f","\ud83c\udff3":"\ud83c\udff3\ufe0f","\ud83c\udff5":"\ud83c\udff5\ufe0f","\ud83c\udff7":"\ud83c\udff7\ufe0f","\ud83d\udc3f":"\ud83d\udc3f\ufe0f","\ud83d\udc41":"\ud83d\udc41\ufe0f","\ud83d\udcfd":"\ud83d\udcfd\ufe0f","\ud83d\udd49":"\ud83d\udd49\ufe0f","\ud83d\udd4a":"\ud83d\udd4a\ufe0f","\ud83d\udd6f":"\ud83d\udd6f\ufe0f","\ud83d\udd70":"\ud83d\udd70\ufe0f","\ud83d\udd73":"\ud83d\udd73\ufe0f","\ud83d\udd74":"\ud83d\udd74\ufe0f","\ud83d\udd75":"\ud83d\udd75\ufe0f","\ud83d\udd76":"\ud83d\udd76\ufe0f","\ud83d\udd77":"\ud83d\udd77\ufe0f","\ud83d\udd78":"\ud83d\udd78\ufe0f","\ud83d\udd79":"\ud83d\udd79\ufe0f","\ud83d\udd87":"\ud83d\udd87\ufe0f","\ud83d\udd8a":"\ud83d\udd8a\ufe0f","\ud83d\udd8b":"\ud83d\udd8b\ufe0f","\ud83d\udd8c":"\ud83d\udd8c\ufe0f","\ud83d\udd8d":"\ud83d\udd8d\ufe0f","\ud83d\udd90":"\ud83d\udd90\ufe0f","\ud83d\udda5":"\ud83d\udda5\ufe0f","\ud83d\udda8":"\ud83d\udda8\ufe0f","\ud83d\uddb1":"\ud83d\uddb1\ufe0f","\ud83d\uddb2":"\ud83d\uddb2\ufe0f","\ud83d\uddbc":"\ud83d\uddbc\ufe0f","\ud83d\uddc2":"\ud83d\uddc2\ufe0f","\ud83d\uddc3":"\ud83d\uddc3\ufe0f","\ud83d\uddc4":"\ud83d\uddc4\ufe0f","\ud83d\uddd1":"\ud83d\uddd1\ufe0f","\ud83d\uddd2":"\ud83d\uddd2\ufe0f","\ud83d\uddd3":"\ud83d\uddd3\ufe0f","\ud83d\udddc":"\ud83d\udddc\ufe0f","\ud83d\udddd":"\ud83d\udddd\ufe0f","\ud83d\uddde":"\ud83d\uddde\ufe0f","\ud83d\udde1":"\ud83d\udde1\ufe0f","\ud83d\udde3":"\ud83d\udde3\ufe0f","\ud83d\udde8":"\ud83d\udde8\ufe0f","\ud83d\uddef":"\ud83d\uddef\ufe0f","\ud83d\uddf3":"\ud83d\uddf3\ufe0f","\ud83d\uddfa":"\ud83d\uddfa\ufe0f","\ud83d\udecb":"\ud83d\udecb\ufe0f","\ud83d\udecd":"\ud83d\udecd\ufe0f","\ud83d\udece":"\ud83d\udece\ufe0f","\ud83d\udecf":"\ud83d\udecf\ufe0f","\ud83d\udee0":"\ud83d\udee0\ufe0f","\ud83d\udee1":"\ud83d\udee1\ufe0f","\ud83d\udee2":"\ud83d\udee2\ufe0f","\ud83d\udee3":"\ud83d\udee3\ufe0f","\ud83d\udee4":"\ud83d\udee4\ufe0f","\ud83d\udee5":"\ud83d\udee5\ufe0f","\ud83d\udee9":"\ud83d\udee9\ufe0f","\ud83d\udef0":"\ud83d\udef0\ufe0f","\ud83d\udef3":"\ud83d\udef3\ufe0f","\u203c":"\u203c\ufe0f","\u2049":"\u2049\ufe0f","\u2122\ufe0f":"\u2122","\u2139":"\u2139\ufe0f","\u2194":"\u2194\ufe0f","\u2195":"\u2195\ufe0f","\u2196":"\u2196\ufe0f","\u2197":"\u2197\ufe0f","\u2198":"\u2198\ufe0f","\u2199":"\u2199\ufe0f","\u21a9":"\u21a9\ufe0f","\u21aa":"\u21aa\ufe0f","\u2328":"\u2328\ufe0f","\u23cf":"\u23cf\ufe0f","\u23ed":"\u23ed\ufe0f","\u23ee":"\u23ee\ufe0f","\u23ef":"\u23ef\ufe0f","\u23f1":"\u23f1\ufe0f","\u23f2":"\u23f2\ufe0f","\u23f8":"\u23f8\ufe0f","\u23f9":"\u23f9\ufe0f","\u23fa":"\u23fa\ufe0f","\u24c2":"\u24c2\ufe0f","\u25aa":"\u25aa\ufe0f","\u25ab":"\u25ab\ufe0f","\u25b6":"\u25b6\ufe0f","\u25c0":"\u25c0\ufe0f","\u25fb":"\u25fb\ufe0f","\u25fc":"\u25fc\ufe0f","\u2600":"\u2600\ufe0f","\u2601":"\u2601\ufe0f","\u2602":"\u2602\ufe0f","\u2603":"\u2603\ufe0f","\u2604":"\u2604\ufe0f","\u260e":"\u260e\ufe0f","\u2611":"\u2611\ufe0f","\u2618":"\u2618\ufe0f","\u261d":"\u261d\ufe0f","\u2620":"\u2620\ufe0f","\u2622":"\u2622\ufe0f","\u2623":"\u2623\ufe0f","\u2626":"\u2626\ufe0f","\u262a":"\u262a\ufe0f","\u262e":"\u262e\ufe0f","\u262f":"\u262f\ufe0f","\u2638":"\u2638\ufe0f","\u2639":"\u2639\ufe0f","\u263a":"\u263a\ufe0f","\u2640":"\u2640\ufe0f","\u2642":"\u2642\ufe0f","\u265f":"\u265f\ufe0f","\u2660":"\u2660\ufe0f","\u2663":"\u2663\ufe0f","\u2665":"\u2665\ufe0f","\u2666":"\u2666\ufe0f","\u2668":"\u2668\ufe0f","\u267b":"\u267b\ufe0f","\u267e":"\u267e\ufe0f","\u2692":"\u2692\ufe0f","\u2694":"\u2694\ufe0f","\u2695":"\u2695\ufe0f","\u2696":"\u2696\ufe0f","\u2697":"\u2697\ufe0f","\u2699":"\u2699\ufe0f","\u269b":"\u269b\ufe0f","\u269c":"\u269c\ufe0f","\u26a0":"\u26a0\ufe0f","\u26a7":"\u26a7\ufe0f","\u26b0":"\u26b0\ufe0f","\u26b1":"\u26b1\ufe0f","\u26c8":"\u26c8\ufe0f","\u26cf":"\u26cf\ufe0f","\u26d1":"\u26d1\ufe0f","\u26d3":"\u26d3\ufe0f","\u26e9":"\u26e9\ufe0f","\u26f0":"\u26f0\ufe0f","\u26f1":"\u26f1\ufe0f","\u26f4":"\u26f4\ufe0f","\u26f7":"\u26f7\ufe0f","\u26f8":"\u26f8\ufe0f","\u26f9":"\u26f9\ufe0f","\u2702":"\u2702\ufe0f","\u2708":"\u2708\ufe0f","\u2709":"\u2709\ufe0f","\u270c":"\u270c\ufe0f","\u270d":"\u270d\ufe0f","\u270f":"\u270f\ufe0f","\u2712":"\u2712\ufe0f","\u2714":"\u2714\ufe0f","\u2716":"\u2716\ufe0f","\u271d":"\u271d\ufe0f","\u2721":"\u2721\ufe0f","\u2733":"\u2733\ufe0f","\u2734":"\u2734\ufe0f","\u2744":"\u2744\ufe0f","\u2747":"\u2747\ufe0f","\u2763":"\u2763\ufe0f","\u2764":"\u2764\ufe0f","\u27a1":"\u27a1\ufe0f","\u2934":"\u2934\ufe0f","\u2935":"\u2935\ufe0f","\u2b05":"\u2b05\ufe0f","\u2b06":"\u2b06\ufe0f","\u2b07":"\u2b07\ufe0f","\u3030":"\u3030\ufe0f","\u303d":"\u303d\ufe0f","\u3297":"\u3297\ufe0f","\u3299":"\u3299\ufe0f"},
	
	globalLoadedFonts: {}
};